/* Flayvr Ami Real PDF v1.1 — self-contained hotfix. PDF engine bundled into the existing Ami asset to remove Shopify script-load dependency. */
(function () {
  'use strict';

  var VERSION = '1.0.0';
  var W = 794;
  var H = 1123;
  var SCALE = 2;
  var FONT = '"Helvetica Neue", Helvetica, Arial, sans-serif';
  var C = {
    bg: '#F3F0EA',
    paper: '#FFFFFF',
    ink: '#191919',
    body: '#5D5954',
    muted: '#77736D',
    line: 'rgba(25,25,25,.09)',
    soft: '#EEEAE3',
    pink: '#E8343F',
    green: '#45A66C'
  };
  var encoder = new TextEncoder();

  function clean(value) {
    return String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  }

  function safeName(value) {
    var name = clean(value || 'Flayvr-Ami-menu.pdf').replace(/[<>:"/\\|?*'&]/g, '');
    return (name || 'Flayvr-Ami-menu.pdf').replace(/\s+/g, '-');
  }

  function clamp(value) {
    var n = Number(value);
    if (!Number.isFinite(n)) return 0;
    return Math.max(0, Math.min(100, Math.round(n)));
  }

  function font(ctx, size, weight) {
    ctx.font = String(weight || 400) + ' ' + size + 'px ' + FONT;
    ctx.textBaseline = 'alphabetic';
  }

  function fill(ctx, color) {
    ctx.fillStyle = color;
  }

  function text(ctx, value, x, y, size, color, weight) {
    font(ctx, size || 14, weight || 400);
    fill(ctx, color || C.ink);
    ctx.fillText(clean(value), x, y);
  }

  function line(ctx, x1, y1, x2, y2, color, width) {
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.strokeStyle = color || C.line;
    ctx.lineWidth = width || 1;
    ctx.stroke();
  }

  function roundRect(ctx, x, y, w, h, r, color) {
    var radius = Math.max(0, Math.min(r || 0, w / 2, h / 2));
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.arcTo(x + w, y, x + w, y + h, radius);
    ctx.arcTo(x + w, y + h, x, y + h, radius);
    ctx.arcTo(x, y + h, x, y, radius);
    ctx.arcTo(x, y, x + w, y, radius);
    ctx.closePath();
    fill(ctx, color);
    ctx.fill();
  }

  function ellipsis(ctx, value, maxWidth) {
    var s = clean(value);
    if (ctx.measureText(s).width <= maxWidth) return s;
    while (s.length > 1 && ctx.measureText(s + '…').width > maxWidth) s = s.slice(0, -1);
    return s + '…';
  }

  function wrapLines(ctx, value, maxWidth, maxLines) {
    var words = clean(value).split(' ').filter(Boolean);
    if (!words.length) return [];
    var lines = [];
    var current = '';
    words.forEach(function (word) {
      var test = current ? current + ' ' + word : word;
      if (!current || ctx.measureText(test).width <= maxWidth) current = test;
      else {
        lines.push(current);
        current = word;
      }
    });
    if (current) lines.push(current);
    if (maxLines && lines.length > maxLines) {
      lines = lines.slice(0, maxLines);
      lines[maxLines - 1] = ellipsis(ctx, lines[maxLines - 1], maxWidth);
    }
    return lines;
  }

  function wrap(ctx, value, x, y, maxWidth, lineHeight, maxLines, size, color, weight) {
    font(ctx, size || 14, weight || 400);
    fill(ctx, color || C.body);
    var lines = wrapLines(ctx, value, maxWidth, maxLines || 99);
    lines.forEach(function (row, index) {
      ctx.fillText(row, x, y + index * lineHeight);
    });
    return y + lines.length * lineHeight;
  }

  function label(ctx, value, x, y, color) {
    font(ctx, 9.2, 500);
    fill(ctx, color || C.muted);
    ctx.fillText(clean(value).toUpperCase(), x, y);
  }

  function makeCanvas() {
    var canvas = document.createElement('canvas');
    canvas.width = W * SCALE;
    canvas.height = H * SCALE;
    var ctx = canvas.getContext('2d', { alpha: false });
    ctx.scale(SCALE, SCALE);
    fill(ctx, C.bg);
    ctx.fillRect(0, 0, W, H);
    return { canvas: canvas, ctx: ctx };
  }

  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      if (!src) return reject(new Error('No image source'));
      var image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = function () { resolve(image); };
      image.onerror = function () { reject(new Error('Image failed to load')); };
      image.src = src;
    });
  }

  async function drawLogo(ctx, data, x, y, width) {
    var src = data && data.logoSrc;
    if (src) {
      try {
        var image = await loadImage(src);
        var ratio = image.naturalHeight / image.naturalWidth;
        ctx.drawImage(image, x, y, width, Math.max(12, width * ratio));
        return;
      } catch (error) {}
    }
    text(ctx, 'flayvr', x, y + 21, 21, C.pink, 500);
  }

  function weekLabel(data) {
    var value = clean(data && data.weekOf);
    return value ? 'WEEK OF ' + value.toUpperCase() : 'AMI / PERSONALISED WEEK';
  }

  async function header(ctx, data, rightLabel) {
    await drawLogo(ctx, data, 48, 38, 84);
    label(ctx, rightLabel || weekLabel(data), 548, 59, C.muted);
  }

  function footer(ctx, page, total, descriptor) {
    line(ctx, 48, 1060, 746, 1060, 'rgba(25,25,25,.10)', 1);
    text(ctx, 'FLAYVR / AMI PERSONALISED MENU', 48, 1084, 8.8, C.muted, 400);
    text(ctx, String(page).padStart(2, '0') + ' / ' + String(total).padStart(2, '0'), 704, 1084, 8.8, C.muted, 500);
    if (descriptor) text(ctx, descriptor, 310, 1084, 8.8, C.muted, 400);
  }

  function tasteScores(taste) {
    var source = (taste && taste.scores) || {};
    return {
      adventure: clamp(source.adventure != null ? source.adventure : source.adv),
      heat: clamp(source.heat),
      intensity: clamp(source.intensity != null ? source.intensity : source.int),
      acid: clamp(source.acid),
      texture: clamp(source.texture != null ? source.texture : source.tex),
      sweet: clamp(source.sweet)
    };
  }

  function drawRadar(ctx, taste, cx, cy, radius) {
    var scores = tasteScores(taste);
    var keys = ['adventure', 'heat', 'intensity', 'acid', 'texture', 'sweet'];
    var labels = ['Adventure', 'Heat', 'Intensity', 'Acid', 'Texture', 'Sweet'];
    var angle = -Math.PI / 2;
    function point(r, index) {
      var a = angle + index * Math.PI / 3;
      return [cx + Math.cos(a) * r, cy + Math.sin(a) * r];
    }
    [0.34, 0.67, 1].forEach(function (scale) {
      ctx.beginPath();
      keys.forEach(function (_, index) {
        var p = point(radius * scale, index);
        if (!index) ctx.moveTo(p[0], p[1]); else ctx.lineTo(p[0], p[1]);
      });
      ctx.closePath();
      ctx.strokeStyle = 'rgba(25,25,25,.10)';
      ctx.lineWidth = 1;
      ctx.stroke();
    });
    keys.forEach(function (_, index) {
      var p = point(radius, index);
      line(ctx, cx, cy, p[0], p[1], 'rgba(25,25,25,.07)', 1);
    });
    ctx.beginPath();
    keys.forEach(function (key, index) {
      var p = point(radius * scores[key] / 100, index);
      if (!index) ctx.moveTo(p[0], p[1]); else ctx.lineTo(p[0], p[1]);
    });
    ctx.closePath();
    ctx.fillStyle = 'rgba(232,52,63,.09)';
    ctx.fill();
    ctx.strokeStyle = C.pink;
    ctx.lineWidth = 2;
    ctx.stroke();
    keys.forEach(function (key, index) {
      var p = point(radius * scores[key] / 100, index);
      ctx.beginPath();
      ctx.arc(p[0], p[1], 2.6, 0, Math.PI * 2);
      ctx.fillStyle = C.pink;
      ctx.fill();
    });
    keys.forEach(function (_, index) {
      var p = point(radius + 17, index);
      font(ctx, 6.6, 500);
      fill(ctx, C.muted);
      var labelText = labels[index].toUpperCase();
      var width = ctx.measureText(labelText).width;
      ctx.fillText(labelText, p[0] - width / 2, p[1] + 2);
    });
  }

  function formatMeta(data) {
    return [
      ['Coverage', clean(data.coverage || 'Personalised plan')],
      ['Plan', data.price ? '£' + clean(data.price) + ' / week' : 'Personalised'],
      ['Food profile', clean(data.foodProfile || 'No restrictions saved')],
      ['Spice', clean(data.spice || 'Medium')]
    ];
  }

  function drawHeroMeta(ctx, data, x, y, width) {
    formatMeta(data).forEach(function (row, index) {
      var yy = y + index * 35;
      text(ctx, row[0], x, yy, 9.5, C.muted, 400);
      font(ctx, 10.2, 500);
      fill(ctx, C.ink);
      ctx.textAlign = 'right';
      ctx.fillText(ellipsis(ctx, row[1], width - 88), x + width, yy);
      ctx.textAlign = 'left';
      line(ctx, x, yy + 13, x + width, yy + 13, 'rgba(25,25,25,.10)', 1);
    });
  }

  function drawTastePanel(ctx, taste, y) {
    if (!taste || !taste.scores) return y;
    roundRect(ctx, 48, y, 698, 280, 28, 'rgba(255,255,255,.83)');
    ctx.beginPath();
    ctx.arc(69, y + 31, 4, 0, Math.PI * 2);
    fill(ctx, C.green);
    ctx.fill();
    text(ctx, 'Your Taste Test shaped this week.', 84, y + 35, 16, C.ink, 500);
    wrap(ctx, 'These are the signals Ami used after checking your dietary rules and this week’s availability.', 84, y + 56, 415, 16, 2, 10.2, C.body, 400);
    var profile = clean(taste.profileName || 'Taste Profile');
    font(ctx, 10, 500);
    var pillW = Math.max(90, Math.min(145, ctx.measureText(profile).width + 28));
    roundRect(ctx, 746 - pillW - 18, y + 20, pillW, 29, 15, '#202020');
    fill(ctx, '#FFFFFF');
    ctx.textAlign = 'center';
    ctx.fillText(profile, 746 - pillW / 2 - 18, y + 39);
    ctx.textAlign = 'left';

    drawRadar(ctx, taste, 142, y + 158, 63);
    var signals = Array.isArray(taste.signals) ? taste.signals.slice(0, 3) : [];
    while (signals.length < 3) signals.push({ label: '', value: '', explanation: '' });
    signals.forEach(function (signal, index) {
      var x = 245 + index * 151;
      line(ctx, x - 13, y + 99, x - 13, y + 209, 'rgba(25,25,25,.10)', 1);
      label(ctx, index === 0 ? 'Strongest signal' : (signal.label || 'Also high'), x, y + 111, C.muted);
      var headline = clean(signal.label || '') + (signal.value !== '' && signal.value != null ? ' · ' + Math.round(Number(signal.value)) + '%' : '');
      wrap(ctx, headline, x, y + 137, 133, 16, 2, 11.6, C.ink, 500);
      wrap(ctx, signal.explanation || '', x, y + 174, 133, 14, 3, 9.1, C.body, 400);
    });
    roundRect(ctx, 244, y + 226, 475, 35, 16, C.soft);
    wrap(ctx, 'What moved down: ' + clean(taste.movedDown || 'Ami keeps lower-scoring signals from dominating the week.'), 258, y + 247, 447, 13, 2, 8.9, C.body, 400);
    return y + 280;
  }

  async function coverPage(data) {
    var c = makeCanvas();
    var ctx = c.ctx;
    await header(ctx, data, weekLabel(data));
    label(ctx, 'Your menu from Ami', 48, 123, C.muted);
    wrap(ctx, 'Cooked for your week,\nnot picked from a catalogue.', 48, 170, 430, 45, 4, 42, C.ink, 300);
    wrap(ctx, data.intro || 'Ami built this week around your food rules first, then balanced the meals around your preferences.', 48, 302, 440, 20, 4, 13.2, C.body, 400);
    drawHeroMeta(ctx, data, 520, 178, 226);
    var tasteBottom = drawTastePanel(ctx, data.taste, 392);
    if (!data.taste || !data.taste.scores) {
      roundRect(ctx, 48, 410, 698, 190, 28, 'rgba(255,255,255,.82)');
      label(ctx, 'Personal chef logic', 72, 448, C.muted);
      wrap(ctx, 'Your food rules come first.', 72, 486, 580, 32, 2, 28, C.ink, 300);
      wrap(ctx, 'Ami has built a valid plan from your saved requirements, dislikes, spice preference and this week’s available meals.', 72, 534, 575, 20, 4, 13, C.body, 400);
      tasteBottom = 600;
    }
    label(ctx, 'This week', 48, tasteBottom + 55, C.muted);
    text(ctx, 'Your menu', 48, tasteBottom + 93, 30, C.ink, 300);
    wrap(ctx, data.menuHelp || 'Taste fit never overrides allergies or dietary rules.', 450, tasteBottom + 73, 296, 16, 3, 10.5, C.body, 400);
    return jpeg(c.canvas);
  }

  function mealHeight(mealCount) {
    if (mealCount <= 1) return 300;
    if (mealCount <= 2) return 330;
    return 650;
  }

  function paginateDays(days) {
    var pages = [];
    var current = [];
    var used = 0;
    var capacity = 800;
    (days || []).forEach(function (day) {
      var count = Math.max(1, (day.meals || []).length);
      var cost = count <= 1 ? 315 : count <= 2 ? 360 : 675;
      if (current.length && used + cost > capacity) {
        pages.push(current);
        current = [];
        used = 0;
      }
      current.push(day);
      used += cost;
    });
    if (current.length) pages.push(current);
    return pages;
  }

  function dayAverage(day) {
    var scores = (day.meals || []).map(function (meal) { return Number(meal.match); }).filter(Number.isFinite);
    if (!scores.length) return null;
    return Math.round(scores.reduce(function (sum, n) { return sum + n; }, 0) / scores.length);
  }

  function drawPill(ctx, value, x, y) {
    var labelText = clean(value);
    if (!labelText) return x;
    font(ctx, 7.9, 400);
    var w = Math.min(94, ctx.measureText(labelText).width + 18);
    roundRect(ctx, x, y, w, 23, 12, C.soft);
    fill(ctx, '#514D47');
    ctx.fillText(ellipsis(ctx, labelText, w - 14), x + 9, y + 15);
    return x + w + 6;
  }

  function drawMeal(ctx, meal, x, y, w, h) {
    roundRect(ctx, x, y, w, h, 21, C.paper);
    label(ctx, meal.slot || 'Meal', x + 18, y + 26, C.muted);
    var match = Number(meal.match);
    if (Number.isFinite(match)) {
      text(ctx, Math.round(match) + '%', x + w - 54, y + 29, 16, C.pink, 500);
      label(ctx, 'Taste match', x + w - 63, y + 43, '#97918A');
    }
    var titleWidth = w - 38 - (Number.isFinite(match) ? 72 : 0);
    wrap(ctx, meal.name || 'Meal', x + 18, y + 52, titleWidth, 17, 3, 14, C.ink, 400);
    var compact = h < 250;
    var descY = compact ? y + 89 : y + 102;
    var tagsY = compact ? y + 127 : y + 151;
    var separatorY = compact ? y + 158 : y + 188;
    var reasonTitleY = compact ? y + 177 : y + 210;
    var reasonTextY = compact ? y + 195 : y + 230;
    wrap(ctx, meal.description || '', x + 18, descY, w - 36, compact ? 13 : 14, compact ? 2 : 3, 9.2, C.body, 400);
    var pillX = x + 18;
    (meal.tags || []).slice(0, compact ? 3 : 4).forEach(function (tag) { pillX = drawPill(ctx, tag, pillX, tagsY); });
    line(ctx, x + 18, separatorY, x + w - 18, separatorY, 'rgba(25,25,25,.10)', 1);
    if (meal.reason && reasonTextY < y + h - 8) {
      text(ctx, 'Why Ami picked this', x + 18, reasonTitleY, 8.8, C.ink, 500);
      var room = Math.max(1, Math.floor((y + h - reasonTextY - 5) / 13) + 1);
      wrap(ctx, meal.reason, x + 18, reasonTextY, w - 36, 13, Math.min(compact ? 2 : 4, room), 8.8, C.body, 400);
    }
  }

  function drawDay(ctx, day, y) {
    var meals = (day.meals || []).slice(0, 4);
    var h = mealHeight(meals.length);
    roundRect(ctx, 48, y, 698, h, 28, 'rgba(255,255,255,.70)');
    text(ctx, day.name || 'Day', 70, y + 28, 11.5, C.ink, 500);
    var avg = dayAverage(day);
    var note = avg != null ? avg + '% average Taste fit' : clean(day.note || 'Personalised for your week');
    if (day.note && avg != null) note += ' · ' + clean(day.note);
    font(ctx, 8.6, 400);
    fill(ctx, C.muted);
    ctx.textAlign = 'right';
    ctx.fillText(ellipsis(ctx, note, 300), 724, y + 28);
    ctx.textAlign = 'left';

    var innerX = 66;
    var innerW = 662;
    var top = y + 49;
    if (meals.length === 1) {
      drawMeal(ctx, meals[0], innerX, top, innerW, h - 67);
    } else if (meals.length === 2) {
      var gap = 10;
      var colW = (innerW - gap) / 2;
      drawMeal(ctx, meals[0], innerX, top, colW, h - 67);
      drawMeal(ctx, meals[1], innerX + colW + gap, top, colW, h - 67);
    } else {
      var gapX = 10;
      var gapY = 10;
      var cw = (innerW - gapX) / 2;
      var rh = (h - 67 - gapY) / 2;
      meals.forEach(function (meal, index) {
        var col = index % 2;
        var row = Math.floor(index / 2);
        drawMeal(ctx, meal, innerX + col * (cw + gapX), top + row * (rh + gapY), cw, rh);
      });
    }
    return y + h;
  }

  async function menuPage(data, group) {
    var c = makeCanvas();
    var ctx = c.ctx;
    await header(ctx, data, weekLabel(data));
    label(ctx, 'This week', 48, 118, C.muted);
    text(ctx, 'Your', 48, 155, 28, C.ink, 300);
    text(ctx, 'menu', 48, 184, 28, C.ink, 300);
    wrap(ctx, data.menuHelp || 'Taste Match shows how closely each suitable meal aligns with your profile. Food rules always come first.', 287, 147, 459, 16, 3, 10.2, C.body, 400);
    var y = 215;
    group.forEach(function (day) {
      y = drawDay(ctx, day, y) + 16;
    });
    return jpeg(c.canvas);
  }

  async function summaryPage(data) {
    var c = makeCanvas();
    var ctx = c.ctx;
    await header(ctx, data, 'WHY THIS WEEK WORKS');
    label(ctx, 'Ami / menu intelligence', 48, 127, C.muted);
    wrap(ctx, 'Why this week\nworks for you.', 48, 173, 475, 44, 3, 40, C.ink, 300);
    line(ctx, 48, 308, 746, 308, 'rgba(25,25,25,.11)', 1);

    roundRect(ctx, 48, 350, 698, 360, 28, 'rgba(255,255,255,.77)');
    label(ctx, 'Why this week works', 72, 389, C.muted);
    wrap(ctx, 'Ami didn’t just choose the highest-scoring dishes.', 72, 430, 610, 27, 3, 23, C.ink, 300);
    wrap(ctx, data.summaryIntro || 'Your Taste Test is a ranking signal, not a command to make every meal taste the same. Ami kept your strongest preferences visible, then varied heat, cuisine and meal shape so the week still feels planned rather than repetitive.', 72, 493, 610, 19, 5, 12.1, C.body, 400);
    var rows = [
      ['Moved up', data.movedUp || 'Meals that better fit your strongest preferences.'],
      ['Moved down', data.movedDown || 'Lower-scoring signals were kept from dominating the week.'],
      ['Balanced', data.balanced || 'A calmer meal can stay when it creates useful contrast without losing your core profile.']
    ];
    rows.forEach(function (row, index) {
      var yy = 582 + index * 46;
      text(ctx, row[0], 72, yy, 9.5, C.muted, 400);
      wrap(ctx, row[1], 157, yy, 535, 14, 2, 10.1, C.ink, 500);
    });

    roundRect(ctx, 48, 742, 698, 235, 28, 'rgba(255,255,255,.77)');
    label(ctx, 'Food profile', 72, 781, C.muted);
    wrap(ctx, 'Taste never overrides safety.', 72, 822, 445, 31, 2, 27, C.ink, 300);
    wrap(ctx, 'Dietary requirements, allergies, dislikes and availability are checked first. Taste Test scores only help Ami rank meals that are already suitable for you.', 72, 877, 430, 19, 5, 12.1, C.body, 400);
    var safety = [];
    if (data.foodProfile) safety.push('Food rules: ' + data.foodProfile);
    if (data.allergies) safety.push('Allergies: ' + data.allergies);
    if (data.dislikes) safety.push('Dislikes: ' + data.dislikes);
    if (data.spice) safety.push('Spice: ' + data.spice);
    wrap(ctx, safety.join(' · ') || 'No additional restrictions saved.', 530, 815, 180, 17, 8, 10.1, C.body, 400);
    return jpeg(c.canvas);
  }

  function jpeg(canvas) {
    return {
      width: canvas.width,
      height: canvas.height,
      base64: canvas.toDataURL('image/jpeg', 0.94).split(',')[1]
    };
  }

  async function renderPages(data) {
    var pages = [];
    pages.push(await coverPage(data));
    var groups = paginateDays(data.days || []);
    for (var i = 0; i < groups.length; i += 1) pages.push(await menuPage(data, groups[i]));
    pages.push(await summaryPage(data));
    return pages;
  }

  function base64Bytes(value) {
    var bin = atob(value);
    var out = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i += 1) out[i] = bin.charCodeAt(i);
    return out;
  }

  function concat(parts) {
    var length = parts.reduce(function (sum, part) { return sum + part.length; }, 0);
    var out = new Uint8Array(length);
    var offset = 0;
    parts.forEach(function (part) {
      out.set(part, offset);
      offset += part.length;
    });
    return out;
  }

  async function buildPdf(data) {
    var images = await renderPages(data || {});
    var N = images.length;
    var objects = [];
    function add(id, value) {
      objects.push({ id: id, parts: Array.isArray(value) ? value : [encoder.encode(value)] });
    }
    add(1, '<< /Type /Catalog /Pages 2 0 R >>');
    var pageIds = [];
    for (var p = 0; p < N; p += 1) pageIds.push(5 + p * 3);
    add(2, '<< /Type /Pages /Kids [' + pageIds.map(function (id) { return id + ' 0 R'; }).join(' ') + '] /Count ' + N + ' >>');
    for (var i = 0; i < N; i += 1) {
      var imageId = 3 + i * 3;
      var contentId = 4 + i * 3;
      var pageId = 5 + i * 3;
      var jpg = base64Bytes(images[i].base64);
      add(imageId, [
        encoder.encode('<< /Type /XObject /Subtype /Image /Width ' + images[i].width + ' /Height ' + images[i].height + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + jpg.length + ' >>\nstream\n'),
        jpg,
        encoder.encode('\nendstream')
      ]);
      var stream = 'q\n595 0 0 842 0 0 cm\n/Im0 Do\nQ\n';
      var streamBytes = encoder.encode(stream);
      add(contentId, [encoder.encode('<< /Length ' + streamBytes.length + ' >>\nstream\n'), streamBytes, encoder.encode('endstream')]);
      add(pageId, '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 595 842] /Resources << /XObject << /Im0 ' + imageId + ' 0 R >> >> /Contents ' + contentId + ' 0 R >>');
    }
    var infoId = 3 * N + 3;
    add(infoId, '<< /Producer (Flayvr Ami Real PDF Engine) /Title (Flayvr - Ami Personalised Menu) /Subject (Personalised weekly menu) >>');
    objects.sort(function (a, b) { return a.id - b.id; });
    var headerBytes = encoder.encode('%PDF-1.4\n%FLAYVR-AMI-REALPDF-V1\n');
    var parts = [headerBytes];
    var offsets = {};
    var position = headerBytes.length;
    objects.forEach(function (object) {
      offsets[object.id] = position;
      var open = encoder.encode(object.id + ' 0 obj\n');
      var close = encoder.encode('\nendobj\n');
      parts.push(open);
      object.parts.forEach(function (part) { parts.push(part); });
      parts.push(close);
      position += open.length + close.length + object.parts.reduce(function (sum, part) { return sum + part.length; }, 0);
    });
    var xref = position;
    var maxId = Math.max.apply(Math, objects.map(function (object) { return object.id; }));
    var trailer = 'xref\n0 ' + (maxId + 1) + '\n0000000000 65535 f \n';
    for (var id = 1; id <= maxId; id += 1) trailer += String(offsets[id] || 0).padStart(10, '0') + ' 00000 n \n';
    trailer += 'trailer\n<< /Size ' + (maxId + 1) + ' /Root 1 0 R /Info ' + infoId + ' 0 R >>\nstartxref\n' + xref + '\n%%EOF';
    parts.push(encoder.encode(trailer));
    return concat(parts);
  }

  function isAppleSafari() {
    var ua = navigator.userAgent || '';
    var ios = /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1);
    var safari = /Safari/i.test(ua) && !/Chrome|CriOS|Chromium|Edg|OPR|Android/i.test(ua);
    return ios || safari;
  }

  function removeReadyPanel() {
    var panel = document.querySelector('[data-ami-real-pdf-ready]');
    if (!panel) return;
    ['previewUrl', 'downloadUrl'].forEach(function (key) {
      var url = panel.dataset[key];
      if (url) try { URL.revokeObjectURL(url); } catch (error) {}
    });
    panel.remove();
    var style = document.querySelector('[data-ami-real-pdf-ready-style]');
    if (style) style.remove();
  }

  function appleReadyPanel(bytes, filename) {
    removeReadyPanel();
    var safe = safeName(filename);
    var pdfBlob = new Blob([bytes], { type: 'application/pdf' });
    var previewUrl = URL.createObjectURL(pdfBlob);
    var downloadUrl = URL.createObjectURL(new Blob([bytes], { type: 'application/octet-stream' }));
    var panel = document.createElement('div');
    panel.setAttribute('data-ami-real-pdf-ready', '');
    panel.dataset.previewUrl = previewUrl;
    panel.dataset.downloadUrl = downloadUrl;
    panel.innerHTML = '<div class="ami-real-pdf-card"><button type="button" data-close aria-label="Close">×</button><div class="k">Ami personalised menu</div><h3>Your PDF is ready.</h3><p>This is a real PDF document — no print page and no browser background conversion.</p><div class="a"><a class="primary" href="' + downloadUrl + '" download="' + safe + '">Download PDF</a><a href="' + previewUrl + '" target="_blank" rel="noopener">Open PDF</a></div></div>';
    var style = document.createElement('style');
    style.setAttribute('data-ami-real-pdf-ready-style', '');
    style.textContent = '[data-ami-real-pdf-ready]{position:fixed;inset:0;z-index:2147483647;background:rgba(25,25,25,.24);-webkit-backdrop-filter:blur(20px);backdrop-filter:blur(20px);display:grid;place-items:center;padding:20px}.ami-real-pdf-card{position:relative;width:min(590px,100%);background:rgba(243,240,234,.88);color:#191919;border:1px solid rgba(255,255,255,.7);border-radius:30px;padding:34px;font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;-webkit-backdrop-filter:blur(30px) saturate(1.15);backdrop-filter:blur(30px) saturate(1.15);box-shadow:0 28px 80px rgba(39,33,28,.16)}.ami-real-pdf-card [data-close]{position:absolute;right:20px;top:20px;width:42px;height:42px;border:1px solid rgba(87,80,73,.18);border-radius:50%;background:rgba(255,255,255,.32);font-size:24px;font-weight:300;line-height:1;color:#191919;cursor:pointer}.ami-real-pdf-card .k{font-size:12px;letter-spacing:.12em;text-transform:uppercase;color:#746d65}.ami-real-pdf-card h3{font-size:clamp(38px,6vw,50px);line-height:1;letter-spacing:-.05em;font-weight:300;margin:18px 62px 20px 0}.ami-real-pdf-card p{font-size:17px;line-height:1.55;color:#57524c;max-width:475px}.ami-real-pdf-card .a{display:grid;gap:11px;margin-top:30px}.ami-real-pdf-card a{min-height:58px;display:grid;place-items:center;border:1px solid rgba(94,86,79,.22);border-radius:999px;color:#191919;text-decoration:none;font-size:15px;font-weight:500;background:rgba(255,255,255,.25)}.ami-real-pdf-card a.primary{background:#E8343F;color:#fff;border-color:#E8343F}@media(max-width:600px){.ami-real-pdf-card{padding:28px 22px;border-radius:24px}.ami-real-pdf-card h3{font-size:38px}.ami-real-pdf-card p{font-size:16px}}';
    document.head.appendChild(style);
    document.body.appendChild(panel);
    panel.querySelector('[data-close]').addEventListener('click', removeReadyPanel);
    return { mode: 'apple-ready', bytes: bytes.length };
  }

  async function download(data, filename) {
    var bytes = await buildPdf(data || {});
    if (isAppleSafari()) return appleReadyPanel(bytes, filename || 'Flayvr-Ami-menu.pdf');
    var url = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
    var link = document.createElement('a');
    link.href = url;
    link.download = safeName(filename || 'Flayvr-Ami-menu.pdf');
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(function () { URL.revokeObjectURL(url); }, 30000);
    return { mode: 'downloaded', bytes: bytes.length };
  }

  window.FlayvrAmiPDFV1 = {
    version: VERSION,
    buildPdf: buildPdf,
    download: download,
    renderPages: renderPages,
    paginateDays: paginateDays
  };
})();

/* --- Existing Ami runtime follows --- */
/* FLAYVR AMI LIVE RUNTIME HOTFIX v1
   Compatibility asset: existing sections already load flayvr-ami-final-v27-7.js.
   Bundles approved meal-family rules + approvals + bullet-proof Ami core logic 2.24.0.
   No section/template/theme.liquid changes required.
*/

/* Flayvr Ami Theme-side Meal Variants v1
   No Shopify metaobject changes required.
   Proposals remain inactive until approved in flayvr-ami-variant-approvals-v1.js.
*/
(function(w){
  'use strict';
  w.FlayvrAmiMealVariants = {"masala-egg-bhurji-with-spinach-buckwheat-roti":{"name":"Masala Egg Bhurji with Spinach & Buckwheat Roti","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"egg":"tofu","eggs":"tofu"},"removeIngredients":["egg","eggs"],"addIngredients":["tofu"],"removeAllergens":["egg","eggs"],"addAllergens":["soya"],"displayName":"Masala Tofu Bhurji with Spinach & Buckwheat Roti","customerDescription":"Soft scrambled tofu with tomato, ginger, chilli and spinach, served with a gluten-free buckwheat roti.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"keto-chicken-scrambled-egg-breakfast-bowl":{"name":"Keto Chicken & Scrambled Egg Breakfast Bowl","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu","egg":"tofu"},"removeIngredients":["chicken","egg"],"addIngredients":["tofu"],"removeAllergens":["egg"],"addAllergens":["soya"],"displayName":"Keto Tofu & Greens Breakfast Bowl","customerDescription":"tofu, soft tofu and greens with turmeric, coriander and a clean chilli finish.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"turkish-eggs-with-herby-greens":{"name":"Turkish Eggs with Herby Greens","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"egg":"tofu","eggs":"tofu","yoghurt":"coconut yoghurt"},"removeIngredients":["egg","eggs","yoghurt"],"addIngredients":["tofu","coconut yoghurt"],"removeAllergens":["egg","eggs","dairy"],"addAllergens":["soya"],"displayName":"Turkish Tofu with Herby Greens","customerDescription":"Soft tofu over garlic coconut yoghurt-style sauce, greens, chilli oil and herbs.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false},{"code":"DF","label":"DF","group":"dairy","satisfies":["Dairy-free"],"dietAdd":["Dairy-free"],"replace":{"yoghurt":"dairy-free yoghurt"},"removeIngredients":["yoghurt","milk","dairy"],"addIngredients":["dairy-free yoghurt"],"removeAllergens":["dairy","milk"],"addAllergens":[],"customerNote":"Made with the approved dairy-free components.","kitchenInstruction":"Verify the dairy-free ingredient specification and cross-contact controls before approval.","approved":false,"safetyReviewed":false}]},"miso-mushroom-omelette-with-greens":{"name":"Miso Mushroom Omelette with Greens","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"omelette":"chickpea omelette","egg":"chickpea batter","eggs":"chickpea batter"},"removeIngredients":["egg","eggs"],"addIngredients":["chickpea flour"],"removeAllergens":["egg"],"addAllergens":[],"displayName":"Miso Mushroom Chickpea Omelette with Greens","customerDescription":"chickpea omelette with miso mushrooms, spring onion and greens for a savoury breakfast plate.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"smoked-salmon-egg-avocado-box":{"name":"Smoked Salmon, Egg & Avocado Box","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"smoked salmon":"smoked tofu","salmon":"tofu","egg":"tofu"},"removeIngredients":["smoked salmon","salmon","egg"],"addIngredients":["smoked tofu","tofu"],"removeAllergens":["egg","fish"],"addAllergens":["soya"],"displayName":"Smoked Tofu & Avocado Box","customerDescription":"smoked tofu, boiled tofu, avocado, cucumber and lemon-herb dressing.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"shakshuka-with-spinach-buckwheat-flatbread":{"name":"Shakshuka with Spinach & Buckwheat Flatbread","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"egg":"chickpeas","eggs":"chickpeas"},"removeIngredients":["egg","eggs"],"addIngredients":["chickpeas"],"removeAllergens":["egg","eggs"],"addAllergens":[],"displayName":"Shakshuka with Chickpeas & Buckwheat Flatbread","customerDescription":"chickpeas in a spiced tomato and pepper sauce with spinach and buckwheat flatbread.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"chicken-sweet-potato-greens-hash":{"name":"Chicken Sweet Potato & Greens Hash","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":[],"addAllergens":["soya"],"displayName":"tofu Sweet Potato & Greens Hash","customerDescription":"tofu, sweet potato, kale and herbs with a light breakfast hash finish.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"sardine-potato-breakfast-plate":{"name":"Sardine Potato Breakfast Plate","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"sardine":"smoked tofu","sardines":"smoked tofu"},"removeIngredients":["sardine","sardines"],"addIngredients":["smoked tofu"],"removeAllergens":["fish"],"addAllergens":["soya"],"displayName":"smoked tofu Potato Breakfast Plate","customerDescription":"smoked tofu with baby potatoes, greens, lemon and parsley.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"oat-idli-with-sambar":{"name":"Oat Idli with Sambar","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{},"removeIngredients":[],"addIngredients":[],"removeAllergens":[],"addAllergens":[],"displayName":"Vegan Oat Idli with Sambar","customerDescription":"Steamed gluten-free oat idli with lentil sambar and curry leaf tempering.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"salmon-kedgeree-with-buckwheat":{"name":"Salmon Kedgeree with Buckwheat","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"smoked salmon":"smoked tofu","salmon":"tofu","egg":"tofu"},"removeIngredients":["smoked salmon","salmon","egg"],"addIngredients":["smoked tofu","tofu"],"removeAllergens":["egg","fish"],"addAllergens":["soya"],"displayName":"tofu Kedgeree with Buckwheat","customerDescription":"smoked tofu, tofu, buckwheat and gentle curry spices with parsley and lemon.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"turkey-keema-breakfast-bowl-with-buckwheat":{"name":"Turkey Keema Breakfast Bowl with Buckwheat","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"turkey":"plant mince"},"removeIngredients":["turkey"],"addIngredients":["plant mince"],"removeAllergens":[],"addAllergens":[],"displayName":"plant mince Keema Breakfast Bowl with Buckwheat","customerDescription":"Lean plant mince keema with peas, tomato, ginger and toasted buckwheat.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"mushroom-spinach-frittata":{"name":"Mushroom Spinach Frittata","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"frittata":"chickpea bake","egg":"chickpea batter","eggs":"chickpea batter"},"removeIngredients":["egg","eggs"],"addIngredients":["chickpea flour"],"removeAllergens":["egg"],"addAllergens":[],"displayName":"Mushroom Spinach Chickpea Bake","customerDescription":"chickpea batter chickpea bake with mushrooms, spinach, herbs and a soft oven-baked finish.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"blueberry-lemon-quinoa-breakfast-pot":{"name":"Blueberry Lemon Quinoa Breakfast Pot","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{"oat ":"certified gluten-free oat "},"removeIngredients":["oat ","wheat","gluten"],"addIngredients":["certified gluten-free oat "],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"apple-tahini-buckwheat-oats":{"name":"Apple Tahini Buckwheat Oats","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{"oats":"certified gluten-free oats"},"removeIngredients":["oats","wheat","gluten"],"addIngredients":["certified gluten-free oats"],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"smoky-black-bean-breakfast-hash":{"name":"Smoky Black Bean Breakfast Hash","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"sweet-potato-tofu-breakfast-bowl":{"name":"Sweet Potato Tofu Breakfast Bowl","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"raspberry-almond-chia-oat-pot":{"name":"Raspberry Almond Chia Oat Pot","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{"overnight oats":"certified gluten-free overnight oats","oats":"certified gluten-free oats","oat ":"certified gluten-free oat "},"removeIngredients":["overnight oats","oats","oat ","wheat","gluten"],"addIngredients":["certified gluten-free overnight oats","certified gluten-free oats","certified gluten-free oat "],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"miso-edamame-breakfast-rice-bowl":{"name":"Miso Edamame Breakfast Rice Bowl","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{"miso":"gluten-free miso"},"removeIngredients":["miso","wheat","gluten"],"addIngredients":["gluten-free miso"],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"carrot-cake-overnight-oats":{"name":"Carrot Cake Overnight Oats","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{"overnight oats":"certified gluten-free overnight oats","oats":"certified gluten-free oats"},"removeIngredients":["overnight oats","oats","wheat","gluten"],"addIngredients":["certified gluten-free overnight oats","certified gluten-free oats"],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"tomato-white-bean-breakfast-stew":{"name":"Tomato White Bean Breakfast Stew","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"banana-hemp-protein-buckwheat-pot":{"name":"Banana Hemp Protein Buckwheat Pot","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{"oat ":"certified gluten-free oat "},"removeIngredients":["oat ","wheat","gluten"],"addIngredients":["certified gluten-free oat "],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"courgette-herb-chickpea-breakfast-bake":{"name":"Courgette Herb Chickpea Breakfast Bake","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"jerk-chicken-rice-greens-bowl":{"name":"Jerk Chicken Rice & Greens Bowl","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":[],"addAllergens":["soya"],"displayName":"Jerk tofu Rice & Greens Bowl","customerDescription":"Jerk-spiced tofu with rice, greens, pineapple slaw and lime.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"salmon-herby-rice-greens-lemon-dressing":{"name":"Salmon Herby Rice Greens & Lemon Dressing","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"salmon":"tofu"},"removeIngredients":["salmon"],"addIngredients":["tofu"],"removeAllergens":["fish"],"addAllergens":["soya"],"displayName":"tofu Herby Rice Greens & Lemon Dressing","customerDescription":"Roasted tofu with herby rice, greens, cucumber and lemon dressing.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"turkey-chilli-sweet-potato-slaw":{"name":"Turkey Chilli, Sweet Potato & Slaw","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"turkey":"plant mince"},"removeIngredients":["turkey"],"addIngredients":["plant mince"],"removeAllergens":[],"addAllergens":[],"displayName":"plant mince Chilli, Sweet Potato & Slaw","customerDescription":"Lean plant mince chilli with sweet potato, tomato, beans and crunchy slaw.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"chicken-caesar-style-salad-with-dairy-free-dressing":{"name":"Chicken Caesar-Style Salad with Dairy-Free Dressing","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":["dairy"],"addAllergens":["soya"],"displayName":"tofu Caesar-Style Salad with Dairy-Free Dressing","customerDescription":"Grilled tofu, crisp leaves, cucumber, seeds and Caesar-style dairy-free dressing.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"prawn-coconut-curry-with-lime-buckwheat":{"name":"Prawn Coconut Curry with Lime Buckwheat","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"prawn":"tofu","prawns":"tofu","milk":"oat drink"},"removeIngredients":["prawn","prawns","milk"],"addIngredients":["tofu","oat drink"],"removeAllergens":["shellfish","milk"],"addAllergens":["soya"],"displayName":"tofu Coconut Curry with Lime Buckwheat","customerDescription":"tofu in coconut, turmeric and lime with toasted buckwheat.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"harissa-chicken-quinoa-bowl":{"name":"Harissa Chicken Quinoa Bowl","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":[],"addAllergens":["soya"],"displayName":"Harissa tofu Quinoa Bowl","customerDescription":"Harissa tofu with quinoa, cucumber, tomato and lemon-herb dressing.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"tandoori-chicken-cucumber-salad-buckwheat":{"name":"Tandoori Chicken Cucumber Salad & Buckwheat","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":[],"addAllergens":["soya"],"displayName":"Tandoori tofu Cucumber Salad & Buckwheat","customerDescription":"Tandoori-spiced tofu with cucumber salad, mint and lemon buckwheat.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"thai-basil-turkey-rice-bowl":{"name":"Thai Basil Turkey Rice Bowl","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"turkey":"plant mince"},"removeIngredients":["turkey"],"addIngredients":["plant mince"],"removeAllergens":["fish"],"addAllergens":[],"displayName":"Thai Basil plant mince Rice Bowl","customerDescription":"plant mince mince with Thai basil, green beans, jasmine rice and lime.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"lemon-herb-chicken-buckwheat-tabbouleh":{"name":"Lemon Herb Chicken Buckwheat Tabbouleh","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":[],"addAllergens":["soya"],"displayName":"Lemon Herb tofu Buckwheat Tabbouleh","customerDescription":"Lemon-herb tofu with buckwheat tabbouleh, cucumber and parsley.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"goan-fish-curry-lunch-bowl":{"name":"Goan Fish Curry Lunch Bowl","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"fish":"tofu","milk":"oat drink"},"removeIngredients":["fish","milk"],"addIngredients":["tofu","oat drink"],"removeAllergens":["fish","milk"],"addAllergens":["soya"],"displayName":"Goan tofu Curry Lunch Bowl","customerDescription":"White tofu in coconut and tamarind curry with rice and greens.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"paneer-tikka-salad-bowl":{"name":"Paneer Tikka Salad Bowl","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"paneer":"tofu"},"removeIngredients":["paneer"],"addIngredients":["tofu"],"removeAllergens":["dairy"],"addAllergens":["soya"],"displayName":"Tofu Tikka Salad Bowl","customerDescription":"tofu tikka with leaves, cucumber, tomato, mint and a light dressing.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false},{"code":"DF","label":"DF","group":"dairy","satisfies":["Dairy-free"],"dietAdd":["Dairy-free"],"replace":{"paneer":"tofu"},"removeIngredients":["paneer","milk","dairy"],"addIngredients":["tofu"],"removeAllergens":["dairy","milk"],"addAllergens":["soya"],"customerNote":"Made with the approved dairy-free components.","kitchenInstruction":"Verify the dairy-free ingredient specification and cross-contact controls before approval.","approved":false,"safetyReviewed":false}]},"saffron-chicken-buckwheat-pilaf":{"name":"Saffron Chicken Buckwheat Pilaf","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":[],"addAllergens":["soya"],"displayName":"Saffron tofu Buckwheat Pilaf","customerDescription":"tofu with saffron buckwheat, herbs, peas and lemon.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"sicilian-tuna-white-bean-salad":{"name":"Sicilian Tuna & White Bean Salad","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"tuna":"chickpeas"},"removeIngredients":["tuna"],"addIngredients":["chickpeas"],"removeAllergens":["fish"],"addAllergens":[],"displayName":"Sicilian chickpeas & White Bean Salad","customerDescription":"chickpeas, white beans, tomato, parsley, olives and lemon dressing.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"chicken-pho-style-rice-noodle-bowl":{"name":"Chicken Pho-Style Rice Noodle Bowl","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":["fish"],"addAllergens":["soya"],"displayName":"tofu Pho-Style Rice Noodle Bowl","customerDescription":"tofu, rice noodles, herbs, greens and light pho-style aromatics.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"pesto-chicken-gluten-free-pasta-salad":{"name":"Pesto Chicken Gluten-Free Pasta Salad","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":["dairy"],"addAllergens":["soya"],"displayName":"Pesto tofu Gluten-Free Pasta Salad","customerDescription":"tofu with gluten-free pasta, dairy-free basil pesto, rocket and tomatoes.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"chicken-satay-buckwheat-bowl":{"name":"Chicken Satay Buckwheat Bowl","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":[],"addAllergens":["soya"],"displayName":"tofu Satay Buckwheat Bowl","customerDescription":"tofu with peanut satay sauce, cucumber, greens and buckwheat.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"cajun-prawn-sweet-potato-bowl":{"name":"Cajun Prawn Sweet Potato Bowl","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"prawn":"tofu","prawns":"tofu"},"removeIngredients":["prawn","prawns"],"addIngredients":["tofu"],"removeAllergens":["shellfish"],"addAllergens":["soya"],"displayName":"Cajun tofu Sweet Potato Bowl","customerDescription":"Cajun tofu with sweet potato, greens, tomato salsa and lime.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"ginger-tamari-chicken-buckwheat-bowl":{"name":"Ginger Tamari Chicken Buckwheat Bowl","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":[],"addAllergens":["soya"],"displayName":"Ginger Tamari tofu Buckwheat Bowl","customerDescription":"tofu with ginger tamari glaze, buckwheat, greens and spring onion.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"pepper-chicken-coconut-rice-bowl":{"name":"Pepper Chicken Coconut Rice Bowl","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":[],"addAllergens":["soya"],"displayName":"Pepper tofu Coconut Rice Bowl","customerDescription":"Black pepper tofu with coconut rice, curry leaves and greens.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"tempeh-peanut-satay-rice-bowl":{"name":"Tempeh Peanut Satay Rice Bowl","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"smoky-lentil-sweet-potato-chilli":{"name":"Smoky Lentil Sweet Potato Chilli","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"lemon-herb-white-bean-quinoa-salad":{"name":"Lemon Herb White Bean Quinoa Salad","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"tofu-tikka-millet-bowl":{"name":"Tofu Tikka Millet Bowl","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"black-bean-pineapple-jerk-bowl":{"name":"Black Bean Pineapple Jerk Bowl","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"thai-red-lentil-coconut-soup":{"name":"Thai Red Lentil Coconut Soup","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"edamame-buckwheat-soba-sesame-salad":{"name":"Edamame Buckwheat Soba Sesame Salad","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{"soba":"100% buckwheat soba"},"removeIngredients":["soba","wheat","gluten"],"addIngredients":["100% buckwheat soba"],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"roasted-cauliflower-chickpea-tahini-bowl":{"name":"Roasted Cauliflower Chickpea Tahini Bowl","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"three-bean-tomato-buckwheat-stew":{"name":"Three Bean Tomato Buckwheat Stew","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"harissa-tofu-apricot-millet-bowl":{"name":"Harissa Tofu Apricot Millet Bowl","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"miso-salmon-jasmine-rice-sesame-greens":{"name":"Miso Salmon, Jasmine Rice & Sesame Greens","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"salmon":"tofu"},"removeIngredients":["salmon"],"addIngredients":["tofu"],"removeAllergens":["fish"],"addAllergens":["soya"],"displayName":"Miso tofu, Jasmine Rice & Sesame Greens","customerDescription":"Miso tofu with jasmine rice, sesame greens and spring onion.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"garlic-herb-chicken-with-greens":{"name":"Garlic Herb Chicken with Greens","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":[],"addAllergens":["soya"],"displayName":"Garlic Herb tofu with Greens","customerDescription":"Garlic-herb tofu with roasted vegetables, greens and lemon dressing.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"turkey-kofta-tomato-ragu-with-cauliflower-mash":{"name":"Turkey Kofta Tomato Ragu with Cauliflower Mash","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"turkey":"plant mince"},"removeIngredients":["turkey"],"addIngredients":["plant mince"],"removeAllergens":[],"addAllergens":[],"displayName":"plant mince Kofta Tomato Ragu with Cauliflower Mash","customerDescription":"plant mince kofta in tomato ragu with cauliflower mash and herbs.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"goan-prawn-curry-with-basmati-rice":{"name":"Goan Prawn Curry with Basmati Rice","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"prawn":"tofu","prawns":"tofu","milk":"oat drink"},"removeIngredients":["prawn","prawns","milk"],"addIngredients":["tofu","oat drink"],"removeAllergens":["shellfish","milk"],"addAllergens":["soya"],"displayName":"Goan tofu Curry with Basmati Rice","customerDescription":"tofu in coconut, tamarind and turmeric sauce with basmati rice.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"charred-tandoori-chicken-with-cucumber-salad-buckwheat":{"name":"Charred Tandoori Chicken with Cucumber Salad & Buckwheat","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":[],"addAllergens":["soya"],"displayName":"Charred Tandoori tofu with Cucumber Salad & Buckwheat","customerDescription":"Charred tandoori tofu with cucumber salad, mint and lemon buckwheat.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"thai-green-chicken-curry-with-greens":{"name":"Thai Green Chicken Curry with Greens","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu","milk":"oat drink"},"removeIngredients":["chicken","milk"],"addIngredients":["tofu","oat drink"],"removeAllergens":["fish","milk"],"addAllergens":["soya"],"displayName":"Thai Green tofu Curry with Greens","customerDescription":"tofu and greens in coconut green curry sauce with jasmine rice.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"kerala-nadan-chicken-curry-with-buckwheat":{"name":"Kerala Nadan Chicken Curry with Buckwheat","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":[],"addAllergens":["soya"],"displayName":"Kerala Nadan tofu Curry with Buckwheat","customerDescription":"tofu in roasted coconut, curry leaves and black pepper with buckwheat.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"chettinad-pepper-chicken-with-lemon-rice":{"name":"Chettinad Pepper Chicken with Lemon Rice","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":[],"addAllergens":["soya"],"displayName":"Chettinad Pepper tofu with Lemon Rice","customerDescription":"Pepper tofu with curry leaves, roasted spice and lemon rice.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"bengali-fish-muitha-curry-with-buckwheat":{"name":"Bengali Fish Muitha Curry with Buckwheat","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"fish":"tofu"},"removeIngredients":["fish"],"addIngredients":["tofu"],"removeAllergens":["fish"],"addAllergens":["soya"],"displayName":"Bengali tofu Muitha Curry with Buckwheat","customerDescription":"Boneless tofu dumplings in tomato-mustard curry with toasted buckwheat.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"vietnamese-lemongrass-chicken-rice-noodles":{"name":"Vietnamese Lemongrass Chicken Rice Noodles","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":["fish"],"addAllergens":["soya"],"displayName":"Vietnamese Lemongrass tofu Rice Noodles","customerDescription":"Lemongrass tofu with rice noodles, herbs, cucumber and lime dressing.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"harissa-cod-with-chickpea-stew":{"name":"Harissa Cod with Chickpea Stew","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"cod":"tofu"},"removeIngredients":["cod"],"addIngredients":["tofu"],"removeAllergens":["fish"],"addAllergens":["soya"],"displayName":"Harissa tofu with Chickpea Stew","customerDescription":"tofu with harissa chickpea stew, tomato, peppers and herbs.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"mediterranean-chicken-traybake-with-buckwheat":{"name":"Mediterranean Chicken Traybake with Buckwheat","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":[],"addAllergens":["soya"],"displayName":"Mediterranean tofu Traybake with Buckwheat","customerDescription":"tofu with peppers, courgette, olives, tomato and buckwheat.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"turkey-bolognese-with-lentil-pasta":{"name":"Turkey Bolognese with Lentil Pasta","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"turkey":"plant mince"},"removeIngredients":["turkey"],"addIngredients":["plant mince"],"removeAllergens":[],"addAllergens":[],"displayName":"plant mince Bolognese with Lentil Pasta","customerDescription":"Lean plant mince bolognese with tomato, herbs and gluten-free lentil pasta.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"prawn-moilee-with-buckwheat-beans":{"name":"Prawn Moilee with Buckwheat & Beans","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"prawn":"tofu","prawns":"tofu","milk":"oat drink"},"removeIngredients":["prawn","prawns","milk"],"addIngredients":["tofu","oat drink"],"removeAllergens":["shellfish","milk"],"addAllergens":["soya"],"displayName":"tofu Moilee with Buckwheat & Beans","customerDescription":"tofu in coconut, turmeric and lime with buckwheat and green beans.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"lemon-dill-salmon-with-potato-greens":{"name":"Lemon Dill Salmon with Potato Greens","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"salmon":"tofu"},"removeIngredients":["salmon"],"addIngredients":["tofu"],"removeAllergens":["fish"],"addAllergens":["soya"],"displayName":"Lemon Dill tofu with Potato Greens","customerDescription":"tofu with lemon, dill, baby potatoes and seasonal greens.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"chicken-cacciatore-with-white-beans":{"name":"Chicken Cacciatore with White Beans","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":[],"addAllergens":["soya"],"displayName":"tofu Cacciatore with White Beans","customerDescription":"tofu in tomato, peppers and herb sauce with white beans.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"salmon-teriyaki-with-100-buckwheat-soba":{"name":"Salmon Teriyaki with 100% Buckwheat Soba","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"salmon":"tofu"},"removeIngredients":["salmon"],"addIngredients":["tofu"],"removeAllergens":["fish"],"addAllergens":["soya"],"displayName":"tofu Teriyaki with 100% Buckwheat Soba","customerDescription":"tofu with tamari teriyaki glaze, buckwheat soba and greens.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"moroccan-chicken-with-apricot-millet":{"name":"Moroccan Chicken with Apricot Millet","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":[],"addAllergens":["soya"],"displayName":"Moroccan tofu with Apricot Millet","customerDescription":"tofu with tomato, apricot, spices, herbs and millet.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"cod-coconut-tamarind-curry-with-buckwheat":{"name":"Cod Coconut Tamarind Curry with Buckwheat","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"cod":"tofu","milk":"oat drink"},"removeIngredients":["cod","milk"],"addIngredients":["tofu","oat drink"],"removeAllergens":["fish","milk"],"addAllergens":["soya"],"displayName":"tofu Coconut Tamarind Curry with Buckwheat","customerDescription":"tofu in coconut tamarind curry with curry leaves and buckwheat.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"turkey-meatballs-harissa-tomato-with-polenta":{"name":"Turkey Meatballs Harissa Tomato with Polenta","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"turkey":"plant mince"},"removeIngredients":["turkey"],"addIngredients":["plant mince"],"removeAllergens":[],"addAllergens":[],"displayName":"plant mince Meatballs Harissa Tomato with Polenta","customerDescription":"plant mince meatballs in harissa tomato sauce with soft polenta.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"chicken-walnut-pomegranate-with-buckwheat":{"name":"Chicken Walnut Pomegranate with Buckwheat","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":[],"addAllergens":["soya"],"displayName":"tofu Walnut Pomegranate with Buckwheat","customerDescription":"tofu in walnut and pomegranate-style sauce with buckwheat and herbs.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"vegan-bolognese-with-lentil-pasta":{"name":"Vegan Bolognese with Lentil Pasta","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{"lentil pasta":"certified gluten-free lentil pasta"},"removeIngredients":["lentil pasta","wheat","gluten"],"addIngredients":["certified gluten-free lentil pasta"],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"butter-bean-korma-with-millet":{"name":"Butter Bean Korma with Millet","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"tempeh-black-bean-chilli-with-lime-rice":{"name":"Tempeh Black Bean Chilli with Lime Rice","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"tofu-panang-curry-with-jasmine-rice":{"name":"Tofu Panang Curry with Jasmine Rice","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"aubergine-lentil-lasagne-bowl":{"name":"Aubergine Lentil Lasagne Bowl","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{"lasagne":"gluten-free lasagne"},"removeIngredients":["lasagne","wheat","gluten"],"addIngredients":["gluten-free lasagne"],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"mushroom-black-lentil-bourguignon":{"name":"Mushroom Black Lentil Bourguignon","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"jackfruit-black-bean-enchilada-bowl":{"name":"Jackfruit Black Bean Enchilada Bowl","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"creamy-cashew-spinach-chickpea-curry":{"name":"Creamy Cashew Spinach Chickpea Curry","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"miso-tempeh-glazed-aubergine-with-rice":{"name":"Miso Tempeh Glazed Aubergine with Rice","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{"miso":"gluten-free miso"},"removeIngredients":["miso","wheat","gluten"],"addIngredients":["gluten-free miso"],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"smoky-three-bean-shepherd-s-pie":{"name":"Smoky Three Bean Shepherd’s Pie","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"kimchi-pot":{"name":"Kimchi Pot","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"fish":"tofu"},"removeIngredients":["fish"],"addIngredients":["tofu"],"removeAllergens":["fish"],"addAllergens":["soya"],"displayName":"Vegan Kimchi Pot","customerDescription":"Fermented napa cabbage with chilli, garlic and ginger. A sharp snack pot, never a dinner item.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"chicken-mushroom-broth-cup":{"name":"Chicken & Mushroom Broth Cup","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":[],"addAllergens":["soya"],"displayName":"tofu & Mushroom Broth Cup","customerDescription":"Light tofu and mushroom broth with ginger and herbs.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"boiled-egg-chilli-salt-box":{"name":"Boiled Egg Chilli Salt Box","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"egg":"tofu","eggs":"tofu"},"removeIngredients":["egg","eggs"],"addIngredients":["tofu"],"removeAllergens":["egg","eggs"],"addAllergens":["soya"],"displayName":"Chilli Salt Tofu Bites","customerDescription":"Boiled tofu with chilli salt, cucumber and lemon.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"smoked-chicken-lettuce-cups":{"name":"Smoked Chicken Lettuce Cups","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"smoked chicken":"smoked tofu","chicken":"tofu"},"removeIngredients":["smoked chicken","chicken"],"addIngredients":["smoked tofu","tofu"],"removeAllergens":[],"addAllergens":["soya"],"displayName":"smoked tofu Lettuce Cups","customerDescription":"smoked tofu with lettuce cups, cucumber and herb dressing.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"turmeric-ginger-chicken-broth":{"name":"Turmeric Ginger Chicken Broth","rules":[{"code":"VG","label":"VG","group":"protein","satisfies":["Vegan"],"dietAdd":["Vegan","Vegetarian","Dairy-free"],"supportAdd":["plant_based"],"replace":{"chicken":"tofu"},"removeIngredients":["chicken"],"addIngredients":["tofu"],"removeAllergens":[],"addAllergens":["soya"],"displayName":"Turmeric Ginger tofu Broth","customerDescription":"tofu broth with turmeric, ginger and black pepper.","customerNote":"Made as the approved vegan version.","kitchenInstruction":"Use the proposed plant version shown in this rule. Kitchen and allergen review required before approval.","approved":false,"safetyReviewed":false}]},"peanut-cacao-protein-bites":{"name":"Peanut Cacao Protein Bites","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{"oats":"certified gluten-free oats","oat ":"certified gluten-free oat "},"removeIngredients":["oats","oat ","wheat","gluten"],"addIngredients":["certified gluten-free oats","certified gluten-free oat "],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"lemon-coconut-cashew-bites":{"name":"Lemon Coconut Cashew Bites","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"roasted-broad-bean-paprika-pot":{"name":"Roasted Broad Bean Paprika Pot","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"tahini-date-seed-bars":{"name":"Tahini Date Seed Bars","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"strawberry-chia-yoghurt-pot":{"name":"Strawberry Chia Yoghurt Pot","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"savoury-tofu-herb-bites":{"name":"Savoury Tofu Herb Bites","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"cinnamon-apple-oat-energy-balls":{"name":"Cinnamon Apple Oat Energy Balls","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{"oats":"certified gluten-free oats","oat ":"certified gluten-free oat "},"removeIngredients":["oats","oat ","wheat","gluten"],"addIngredients":["certified gluten-free oats","certified gluten-free oat "],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"chilli-lime-corn-chickpea-cup":{"name":"Chilli Lime Corn Chickpea Cup","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"edamame-avocado-nori-pot":{"name":"Edamame Avocado Nori Pot","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{},"removeIngredients":["wheat","gluten"],"addIngredients":[],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]},"beetroot-hummus-seed-cracker-box":{"name":"Beetroot Hummus & Seed Cracker Box","rules":[{"code":"GF","label":"GF","group":"gluten","satisfies":["Gluten-free"],"dietAdd":["Gluten-free"],"replace":{"cracker":"gluten-free cracker"},"removeIngredients":["cracker","wheat","gluten"],"addIngredients":["gluten-free cracker"],"removeAllergens":["gluten","wheat"],"addAllergens":[],"customerNote":"Made with the approved gluten-free components.","kitchenInstruction":"Verify every ingredient specification and cross-contact control for the GF version before approval.","approved":false,"safetyReviewed":false}]}};
})(window);


/* Flayvr Ami Variant Approvals v1 — ALL PROPOSED RULES ENABLED */
window.FlayvrAmiVariantApprovals = {
  "masala-egg-bhurji-with-spinach-buckwheat-roti::VG": true,
  "keto-chicken-scrambled-egg-breakfast-bowl::VG": true,
  "turkish-eggs-with-herby-greens::VG": true,
  "turkish-eggs-with-herby-greens::DF": true,
  "miso-mushroom-omelette-with-greens::VG": true,
  "smoked-salmon-egg-avocado-box::VG": true,
  "shakshuka-with-spinach-buckwheat-flatbread::VG": true,
  "chicken-sweet-potato-greens-hash::VG": true,
  "sardine-potato-breakfast-plate::VG": true,
  "oat-idli-with-sambar::VG": true,
  "salmon-kedgeree-with-buckwheat::VG": true,
  "turkey-keema-breakfast-bowl-with-buckwheat::VG": true,
  "mushroom-spinach-frittata::VG": true,
  "blueberry-lemon-quinoa-breakfast-pot::GF": true,
  "apple-tahini-buckwheat-oats::GF": true,
  "smoky-black-bean-breakfast-hash::GF": true,
  "sweet-potato-tofu-breakfast-bowl::GF": true,
  "raspberry-almond-chia-oat-pot::GF": true,
  "miso-edamame-breakfast-rice-bowl::GF": true,
  "carrot-cake-overnight-oats::GF": true,
  "tomato-white-bean-breakfast-stew::GF": true,
  "banana-hemp-protein-buckwheat-pot::GF": true,
  "courgette-herb-chickpea-breakfast-bake::GF": true,
  "jerk-chicken-rice-greens-bowl::VG": true,
  "salmon-herby-rice-greens-lemon-dressing::VG": true,
  "turkey-chilli-sweet-potato-slaw::VG": true,
  "chicken-caesar-style-salad-with-dairy-free-dressing::VG": true,
  "prawn-coconut-curry-with-lime-buckwheat::VG": true,
  "harissa-chicken-quinoa-bowl::VG": true,
  "tandoori-chicken-cucumber-salad-buckwheat::VG": true,
  "thai-basil-turkey-rice-bowl::VG": true,
  "lemon-herb-chicken-buckwheat-tabbouleh::VG": true,
  "goan-fish-curry-lunch-bowl::VG": true,
  "paneer-tikka-salad-bowl::VG": true,
  "paneer-tikka-salad-bowl::DF": true,
  "saffron-chicken-buckwheat-pilaf::VG": true,
  "sicilian-tuna-white-bean-salad::VG": true,
  "chicken-pho-style-rice-noodle-bowl::VG": true,
  "pesto-chicken-gluten-free-pasta-salad::VG": true,
  "chicken-satay-buckwheat-bowl::VG": true,
  "cajun-prawn-sweet-potato-bowl::VG": true,
  "ginger-tamari-chicken-buckwheat-bowl::VG": true,
  "pepper-chicken-coconut-rice-bowl::VG": true,
  "tempeh-peanut-satay-rice-bowl::GF": true,
  "smoky-lentil-sweet-potato-chilli::GF": true,
  "lemon-herb-white-bean-quinoa-salad::GF": true,
  "tofu-tikka-millet-bowl::GF": true,
  "black-bean-pineapple-jerk-bowl::GF": true,
  "thai-red-lentil-coconut-soup::GF": true,
  "edamame-buckwheat-soba-sesame-salad::GF": true,
  "roasted-cauliflower-chickpea-tahini-bowl::GF": true,
  "three-bean-tomato-buckwheat-stew::GF": true,
  "harissa-tofu-apricot-millet-bowl::GF": true,
  "miso-salmon-jasmine-rice-sesame-greens::VG": true,
  "garlic-herb-chicken-with-greens::VG": true,
  "turkey-kofta-tomato-ragu-with-cauliflower-mash::VG": true,
  "goan-prawn-curry-with-basmati-rice::VG": true,
  "charred-tandoori-chicken-with-cucumber-salad-buckwheat::VG": true,
  "thai-green-chicken-curry-with-greens::VG": true,
  "kerala-nadan-chicken-curry-with-buckwheat::VG": true,
  "chettinad-pepper-chicken-with-lemon-rice::VG": true,
  "bengali-fish-muitha-curry-with-buckwheat::VG": true,
  "vietnamese-lemongrass-chicken-rice-noodles::VG": true,
  "harissa-cod-with-chickpea-stew::VG": true,
  "mediterranean-chicken-traybake-with-buckwheat::VG": true,
  "turkey-bolognese-with-lentil-pasta::VG": true,
  "prawn-moilee-with-buckwheat-beans::VG": true,
  "lemon-dill-salmon-with-potato-greens::VG": true,
  "chicken-cacciatore-with-white-beans::VG": true,
  "salmon-teriyaki-with-100-buckwheat-soba::VG": true,
  "moroccan-chicken-with-apricot-millet::VG": true,
  "cod-coconut-tamarind-curry-with-buckwheat::VG": true,
  "turkey-meatballs-harissa-tomato-with-polenta::VG": true,
  "chicken-walnut-pomegranate-with-buckwheat::VG": true,
  "vegan-bolognese-with-lentil-pasta::GF": true,
  "butter-bean-korma-with-millet::GF": true,
  "tempeh-black-bean-chilli-with-lime-rice::GF": true,
  "tofu-panang-curry-with-jasmine-rice::GF": true,
  "aubergine-lentil-lasagne-bowl::GF": true,
  "mushroom-black-lentil-bourguignon::GF": true,
  "jackfruit-black-bean-enchilada-bowl::GF": true,
  "creamy-cashew-spinach-chickpea-curry::GF": true,
  "miso-tempeh-glazed-aubergine-with-rice::GF": true,
  "smoky-three-bean-shepherd-s-pie::GF": true,
  "kimchi-pot::VG": true,
  "chicken-mushroom-broth-cup::VG": true,
  "boiled-egg-chilli-salt-box::VG": true,
  "smoked-chicken-lettuce-cups::VG": true,
  "turmeric-ginger-chicken-broth::VG": true,
  "peanut-cacao-protein-bites::GF": true,
  "lemon-coconut-cashew-bites::GF": true,
  "roasted-broad-bean-paprika-pot::GF": true,
  "tahini-date-seed-bars::GF": true,
  "strawberry-chia-yoghurt-pot::GF": true,
  "savoury-tofu-herb-bites::GF": true,
  "cinnamon-apple-oat-energy-balls::GF": true,
  "chilli-lime-corn-chickpea-cup::GF": true,
  "edamame-avocado-nori-pot::GF": true,
  "beetroot-hummus-seed-cracker-box::GF": true
};


/*
 * Flayvr Ami v27
 * Logic-only replacement for sections/flayvr-ami-home-v27.liquid.
 * Uses the existing flayvr-ami-final-v25.css without modifying design styles.
 */
(function () {
  'use strict';

  var VERSION = '2.27.7';

  var fallbackBucketLoading = {};
  var fallbackBucketFailed = {};

  function fallbackBucketKey(currentState) {
    var rawDiets = currentState && Array.isArray(currentState.diet) ? currentState.diet : [];
    var diets = rawDiets.map(function (value) {
      return String(value || '').trim().toLowerCase();
    });
    var vegan = diets.indexOf('vegan') >= 0;
    var vegetarian = diets.indexOf('vegetarian') >= 0;
    var pesc = diets.indexOf('pescatarian') >= 0;
    var gf = diets.indexOf('gluten-free') >= 0 || diets.indexOf('gluten free') >= 0;
    var df = diets.indexOf('dairy-free') >= 0 || diets.indexOf('dairy free') >= 0;

    var base = 'general';
    if (vegan && pesc) base = 'vegan_pesc';
    else if (vegan) base = 'vegan';
    else if (vegetarian) base = 'vegetarian';
    else if (pesc) base = 'pesc';

    if (gf && df) return base + '_gf_df';
    if (gf) return base + '_gf';
    if (df) return base + '_df';
    return base;
  }

  function fallbackBucketAssetUrl(key) {
    var scripts = Array.prototype.slice.call(document.scripts || []);
    var current = scripts.find(function (script) {
      return String(script.src || '').indexOf('flayvr-ami-final-v27-7.js') >= 0;
    });
    if (!current || !current.src) return '';
    return String(current.src).replace(
      /flayvr-ami-final-v27-7\.js(?:\?.*)?$/,
      'flayvr-ami-fallback-' + key + '.js'
    );
  }

  function loadedFallbackBucket(key) {
    var all = window.FlayvrAmiFallbackBuckets || {};
    return all[key] || null;
  }

  function ensureFallbackBucket(key, callback) {
    callback = typeof callback === 'function' ? callback : function () {};
    if (loadedFallbackBucket(key)) {
      callback(true);
      return;
    }
    if (fallbackBucketFailed[key]) {
      callback(false);
      return;
    }
    if (fallbackBucketLoading[key]) {
      fallbackBucketLoading[key].push(callback);
      return;
    }

    var url = fallbackBucketAssetUrl(key);
    if (!url) {
      fallbackBucketFailed[key] = true;
      callback(false);
      return;
    }

    fallbackBucketLoading[key] = [callback];

    function finish(ok) {
      var queue = fallbackBucketLoading[key] || [];
      delete fallbackBucketLoading[key];
      if (!ok) fallbackBucketFailed[key] = true;
      queue.forEach(function (fn) {
        try { fn(ok); }
        catch (error) { console.error('[Flayvr Ami v27] Fallback bucket callback failed.', error); }
      });
    }

    var script = document.createElement('script');
    var settled = false;
    var timeoutId = window.setTimeout(function () {
      if (settled) return;
      settled = true;
      finish(false);
    }, 4500);

    script.async = true;
    script.src = url;
    script.onload = function () {
      if (settled) return;
      settled = true;
      window.clearTimeout(timeoutId);
      finish(Boolean(loadedFallbackBucket(key)));
    };
    script.onerror = function () {
      if (settled) return;
      settled = true;
      window.clearTimeout(timeoutId);
      finish(false);
    };
    document.head.appendChild(script);
  }

  function yieldToBrowser(callback) {
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () { window.setTimeout(callback, 0); });
      return;
    }
    window.setTimeout(callback, 0);
  }
  var STORAGE_KEY = 'flayvr_ami_final_v27';
  var LEGACY_KEYS = [
    'flayvr_ami_final_v26',
    'flayvr_ami_final_v2114',
    'flayvr:ami-ai-chatbot:v8',
    'flayvr:ami-ai-chatbot:v7',
    'flayvr:ami-ai-chatbot:v6',
    'flayvr:ami-ai-chatbot:v5',
    'flayvr:ami-ai-chatbot:v4',
    'flayvr:ami-ai-chatbot:v3'
  ];
  var MEMORY_MS = 30 * 24 * 60 * 60 * 1000;
  var TASTE_KEY = 'flayvr_taste_v420';
  var TASTE_PROFILE_HISTORY_KEY = 'taste_profile_history';
  var TASTE_PROFILE_INTELLIGENCE_KEY = 'taste_profile_intelligence';
  var TASTE_DIMENSIONS = ['adv', 'heat', 'intensity', 'acid', 'texture', 'sweet'];
  var TASTE_MATCH_WEIGHTS = { adv: 1.2, heat: 1.05, intensity: 1.15, acid: 0.9, texture: 0.75, sweet: 0.65 };

  function safeJsonStorage(key, fallback) {
    try {
      var value = JSON.parse(localStorage.getItem(key) || 'null');
      return value == null ? fallback : value;
    } catch (error) {
      return fallback;
    }
  }

  function numericTasteProfile(profile) {
    if (!profile || typeof profile !== 'object') return null;
    var out = {};
    var valid = true;
    TASTE_DIMENSIONS.forEach(function (key) {
      var value = Number(profile[key]);
      if (!Number.isFinite(value) || value < 0 || value > 100) valid = false;
      out[key] = Math.max(0, Math.min(100, value || 0));
    });
    if (!valid) return null;
    out.key = String(profile.key || '');
    out.firstName = String(profile.firstName || '');
    out.name = String(profile.name || '');
    return out;
  }

  function sameTasteOwner(left, right) {
    left = cleanText(left || '');
    right = cleanText(right || '');
    return !left || !right || left === right;
  }

  function sameTasteBaseline(left, right) {
    left = numericTasteProfile(left);
    right = numericTasteProfile(right);
    if (!left || !right) return false;
    if (left.key && right.key && left.key !== right.key) return false;
    return TASTE_DIMENSIONS.every(function (key) {
      return Math.abs(left[key] - right[key]) <= 1;
    });
  }

  function readTasteProfileContext(personName) {
    var directHandoff = window.FlayvrAmiFullProfile && window.FlayvrAmiFullProfile.profile;
    var directProfile = numericTasteProfile(directHandoff);
    if (directProfile && (!personName || sameTasteOwner(personName, directProfile.firstName))) {
      return {
        testProfile: directProfile,
        currentProfile: directProfile,
        confidence: {},
        source: 'full_profile_handoff',
        completedAt: Number(window.FlayvrAmiFullProfile && window.FlayvrAmiFullProfile.completedAt || 0),
        evidenceCount: 0
      };
    }
    var history = safeJsonStorage(TASTE_PROFILE_HISTORY_KEY, []);
    var intelligence = safeJsonStorage(TASTE_PROFILE_INTELLIGENCE_KEY, {});
    if (!Array.isArray(history) || !history.length) return null;

    var wantedName = cleanText(personName || '');
    var selected = null;
    history.some(function (row) {
      var profile = numericTasteProfile(row && row.profile);
      if (!profile) return false;
      if (wantedName && profile.firstName && !sameTasteOwner(wantedName, profile.firstName)) return false;
      selected = { row: row, profile: profile };
      return true;
    });
    if (!selected) return null;

    var state = null;
    Object.keys(intelligence || {}).some(function (key) {
      var candidate = intelligence[key] || {};
      if (sameTasteBaseline(candidate.testProfile, selected.profile)) {
        state = candidate;
        return true;
      }
      return false;
    });

    var current = numericTasteProfile(state && state.currentProfile) || selected.profile;
    var test = numericTasteProfile(state && state.testProfile) || selected.profile;
    var confidence = state && state.confidence && state.confidence.dims ? state.confidence.dims : {};
    var changed = TASTE_DIMENSIONS.some(function (key) { return Math.abs(current[key] - test[key]) >= 1; });

    return {
      testProfile: test,
      currentProfile: current,
      confidence: confidence,
      source: changed ? 'current_taste' : 'taste_profile_test',
      completedAt: Number(selected.row && selected.row.completedAt || 0),
      evidenceCount: Number(state && state.currentEvidence && state.currentEvidence.count || 0)
    };
  }

  function tasteEnhancementContext(personName) {
    var context = readTasteProfileContext(personName);
    if (!context) return null;
    var direct = window.FlayvrAmiFullProfile && window.FlayvrAmiFullProfile.profile;
    if (direct && sameTasteBaseline(direct, context.testProfile)) {
      context.importedByFullProfileHandoff = true;
      return context;
    }
    var history = safeJsonStorage(TASTE_PROFILE_HISTORY_KEY, []);
    if (!Array.isArray(history)) return null;
    var wantedName = cleanText(personName || '');
    var uploaded = history.some(function (row) {
      if (!row || row.source !== 'ami_upload') return false;
      var profile = numericTasteProfile(row.profile);
      if (!profile) return false;
      if (wantedName && profile.firstName && !sameTasteOwner(wantedName, profile.firstName)) return false;
      return sameTasteBaseline(profile, context.testProfile);
    });
    if (!uploaded) return null;
    context.importedByAmiPdf = true;
    return context;
  }

  function clampTasteScore(value) {
    value = Number(value);
    if (!Number.isFinite(value)) return 50;
    return Math.max(8, Math.min(95, Math.round(value)));
  }

  function derivedMealTasteVector(meal) {
    if (!meal) return null;

    var name = String(meal.name || meal.displayName || '');
    var description = String(meal.customerDescription || meal.description || '');
    var cuisine = String(meal.cuisine || '');
    var ingredients = Array.isArray(meal.ingredients) ? meal.ingredients.join(' ') : String(meal.ingredients || '');
    var support = Array.isArray(meal.supportTags) ? meal.supportTags.join(' ') : String(meal.supportTags || '');
    var text = cleanText([name, description, cuisine, ingredients, support].join(' '));

    /* Neutral starting point. These values describe the dish, not the customer.
       Safety/diet matching remains completely separate. */
    var vector = {
      adv: 48,
      heat: 18,
      intensity: 50,
      acid: 44,
      texture: 50,
      sweet: 32
    };

    var spice = Number(meal.spiceLevel || 0);
    if (Number.isFinite(spice) && spice > 0) {
      vector.heat = ({1:32, 2:52, 3:72, 4:88, 5:94})[Math.min(5, Math.round(spice))] || vector.heat;
    }

    function has(pattern) { return pattern.test(text); }
    function bump(key, amount) { vector[key] += amount; }

    /* Heat */
    if (has(/\b(chilli|chili|jalapeno|jalapeño|harissa|gochujang|sriracha|chipotle|cayenne|hot sauce|scotch bonnet|bird'?s eye|chettinad)\b/)) bump('heat', 18);
    if (has(/\b(peppery|black pepper|ginger|mustard|wasabi)\b/)) bump('heat', 8);
    if (has(/\b(mild|cooling)\b/)) bump('heat', -10);

    /* Savoury intensity / depth */
    if (has(/\b(miso|tamari|soy|umami|gochujang|harissa|curry|masala|chettinad|smoky|smoked|charred|roasted|caramelised|caramelized|garlic|parmesan|anchovy|mushroom|stock|broth)\b/)) bump('intensity', 14);
    if (has(/\b(sesame|tahini|toasted|peppery|spiced|fermented)\b/)) bump('intensity', 7);
    if (has(/\b(light|delicate|gentle|simple)\b/)) bump('intensity', -8);

    /* Acidity / brightness */
    if (has(/\b(lemon|lime|vinegar|tamarind|pickled|pickle|citrus|sumac|yoghurt|yogurt|tomato|tomatoes|pomegranate|bright|sharp|tangy)\b/)) bump('acid', 16);
    if (has(/\b(herb dressing|vinaigrette|salsa)\b/)) bump('acid', 8);
    if (has(/\b(creamy|rich|buttery)\b/)) bump('acid', -5);

    /* Texture / contrast */
    if (has(/\b(crispy|crisp|crunchy|crunch|toasted|seeds|nuts|slaw|raw|charred|buckwheat|granola|crumb|breadcrumbs|roast potatoes|roasted potatoes)\b/)) bump('texture', 16);
    if (has(/\b(layered|contrast|sesame|fennel|cabbage|spring onion)\b/)) bump('texture', 7);
    if (has(/\b(puree|purée|smooth|soup|stew|soft)\b/)) bump('texture', -8);

    /* Sweetness */
    if (has(/\b(honey|maple|caramel|caramelised|caramelized|pineapple|mango|date|dates|sweet potato|coconut|teriyaki|sweet chilli|sweet chili)\b/)) bump('sweet', 16);
    if (has(/\b(fruit|fruity|raisins|apricot)\b/)) bump('sweet', 8);
    if (has(/\b(savoury|savory|peppery|sharp|tangy)\b/)) bump('sweet', -5);

    /* Discovery potential: based on technique/ingredient complexity, not geography. */
    if (has(/\b(fermented|miso|gochujang|harissa|tamarind|sumac|tahini|kimchi|black garlic|seaweed|zaatar|za'atar|buckwheat|adzuki|edamame)\b/)) bump('adv', 15);
    if (has(/\b(smoked|charred|pickled|sesame|spiced|glazed|crusted)\b/)) bump('adv', 7);
    if (text.split(/\s+/).length >= 18) bump('adv', 5);

    Object.keys(vector).forEach(function (key) {
      vector[key] = clampTasteScore(vector[key]);
    });
    return vector;
  }

  function mealTasteVector(meal) {
    if (!meal) return null;

    var derived = derivedMealTasteVector(meal);
    if (!derived) return null;

    var explicit = {
      adv: Number(meal.tasteAdventure),
      heat: Number(meal.tasteHeat),
      intensity: Number(meal.tasteIntensity),
      acid: Number(meal.tasteAcid),
      texture: Number(meal.tasteTexture),
      sweet: Number(meal.tasteSweet)
    };

    /* Explicit Food Library scores always win. Missing dimensions are filled
       deterministically from existing meal metadata so Taste Match can still
       be calculated while the library is progressively enriched. */
    TASTE_DIMENSIONS.forEach(function (key) {
      if (Number.isFinite(explicit[key]) && explicit[key] > 0 && explicit[key] <= 100) {
        derived[key] = explicit[key];
      }
    });
    return derived;
  }

  function tasteMatchForMeal(meal, personName) {
    var context = readTasteProfileContext(personName);
    var vector = mealTasteVector(meal);
    if (!context || !vector) return null;
    var profile = context.currentProfile;
    var totalWeight = 0;
    var weightedDistance = 0;
    TASTE_DIMENSIONS.forEach(function (key) {
      var confidence = Number(context.confidence && context.confidence[key]);
      var confidenceFactor = Number.isFinite(confidence) ? (0.65 + 0.35 * Math.max(0, Math.min(100, confidence)) / 100) : 1;
      var weight = TASTE_MATCH_WEIGHTS[key] * confidenceFactor;
      totalWeight += weight;
      weightedDistance += Math.abs(profile[key] - vector[key]) * weight;
    });
    if (!totalWeight) return null;
    var match = 100 - (weightedDistance / totalWeight) * 0.72;
    return Math.max(50, Math.min(99, Math.round(match * 10) / 10));
  }

  function tasteRankBoost(meal, personName) {
    var match = tasteMatchForMeal(meal, personName);
    return match == null ? 0 : (match - 75) * 2.4;
  }

  function readTasteMemory() {
    try {
      var taste = JSON.parse(localStorage.getItem(TASTE_KEY) || 'null');
      if (!taste || typeof taste !== 'object' || !taste.items || typeof taste.items !== 'object') {
        return { items: {} };
      }
      return taste;
    } catch (error) {
      return { items: {} };
    }
  }

  function tasteItemForMeal(meal) {
    var taste = readTasteMemory();
    var items = taste.items || {};
    var handle = String(meal && meal.handle || '').trim().toLowerCase().replace(/[_\s]+/g, '-');
    var title = cleanText(meal && meal.name || '');
    var item = (handle && items['h:' + handle]) || (title && items['t:' + title]);

    if (!item) {
      Object.keys(items).some(function (key) {
        var candidate = items[key] || {};
        var candidateHandle = String(candidate.handle || '').trim().toLowerCase().replace(/[_\s]+/g, '-');
        var candidateTitle = cleanText(candidate.title || '');
        if ((handle && candidateHandle === handle) || (title && candidateTitle === title)) {
          item = candidate;
          return true;
        }
        return false;
      });
    }
    return item || null;
  }

  function tasteRatingForMeal(meal) {
    var item = tasteItemForMeal(meal);
    return item && item.rating ? String(item.rating) : '';
  }

  function postPurchaseSignals() {
    var taste = readTasteMemory();
    var counts = {};
    Object.keys(taste.items || {}).forEach(function (key) {
      var item = taste.items[key] || {};
      if (!item.purchaseConfirmed || !Array.isArray(item.feedback)) return;
      item.feedback.forEach(function (signal) {
        signal = String(signal || '');
        if (signal) counts[signal] = (counts[signal] || 0) + 1;
      });
    });
    return counts;
  }

  function matchesTaste(meal) {
    return tasteRatingForMeal(meal) !== 'not-again';
  }

  var COVERAGE = {
    '40': {
      label: 'Weekday dinners',
      detail: 'Five dinners, Monday to Friday',
      price: 40,
      slots: { Dinner: 5 }
    },
    '80': {
      label: 'Weekday lunch + dinner',
      detail: 'Lunch and dinner, Monday to Friday',
      price: 80,
      slots: { Lunch: 5, Dinner: 5 }
    },
    '120': {
      label: 'Full seven-day plan',
      detail: 'Breakfast, lunch, dinner and snacks for all seven days',
      price: 120,
      slots: { Breakfast: 7, Lunch: 7, Dinner: 7, Snack: 7 }
    }
  };

  var STEPS = [
    {
      id: 'name',
      question: 'What should I call you?',
      type: 'text',
      skippable: true,
      persistence: 'stable',
      placeholder: 'Your first name, or tap Skip'
    },
    {
      id: 'people',
      question: 'How many people am I feeding?',
      type: 'single',
      persistence: 'stable',
      choices: ['Just me', 'Two of us', 'Family (3–4)']
    },
    {
      id: 'coverage',
      question: 'How much of the week do you want me to take care of?',
      type: 'coverage',
      persistence: 'remembered-default'
    },
    {
      id: 'allergies',
      question: 'Any allergies or intolerances I must treat as a hard rule?',
      type: 'multi',
      persistence: 'locked-hard-filter',
      noneChoice: 'None',
      autoAdvanceDelay: 1400,
      placeholder: 'Tap all that apply, or type another allergy',
      choices: [
        'None',
        'Gluten',
        'Dairy',
        'Eggs',
        'Peanuts',
        'Tree nuts',
        'Sesame',
        'Soya',
        'Fish',
        'Shellfish'
      ]
    },
    {
      id: 'diet',
      question: 'Any food rules I should use for this order?',
      type: 'multi',
      persistence: 'reconfirm-each-order',
      noneChoice: 'No restrictions',
      autoAdvanceDelay: 1400,
      choices: [
        'No restrictions',
        'Vegetarian',
        'Vegan',
        'Pescatarian',
        'Gluten-free',
        'Dairy-free'
      ]
    },
    {
      id: 'dislikes',
      question: 'Anything you would rather not see on the menu?',
      type: 'multi',
      persistence: 'remembered-soft-filter',
      noneChoice: 'Nothing in particular',
      autoAdvanceDelay: 1300,
      placeholder: 'Tap a dislike, or type another',
      choices: [
        'Nothing in particular',
        'Mushrooms',
        'Aubergine',
        'Olives',
        'Coriander',
        'Coconut',
        'Sweet-forward dishes',
        'Very rich dishes'
      ]
    },
    {
      id: 'spice',
      question: 'How do you like your spice?',
      type: 'single',
      persistence: 'remembered-soft-medium',
      choices: ['Medium', 'Hot', 'Extra Hot']
    },
    {
      id: 'mood',
      question: 'What should your food do for you this week?',
      type: 'single',
      persistence: 'order-only',
      choices: [
        'Keep me steady',
        'Feel lighter',
        'More comforting',
        'More energising',
        'Keep it interesting',
        'Make life easy'
      ]
    }
  ];

  function blankState() {
    return {
      name: '',
      people: '',
      coverage: '80',

      allergies: [],
      allergiesKnown: false,
      legacyHardAvoids: '',
      updatingAllergies: false,

      diet: [],
      dietKnown: false,

      dislikes: [],
      dislikesKnown: false,

      spice: 'Medium',

      mood: '',

      /* Customer-facing free-text instructions carried into eligibility, the final menu and PDF. */
      chefNotes: '',

      /* Legacy/current-order shortcut goals remain supported, but they are
         not part of the canonical identity questionnaire. */
      goal: [],

      /* Kept only for backward compatibility with older saved states. */
      avoids: '',

      menu: [],
      completed: [],
      currentStepId: '',
      editingCoverage: false
    };
  }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[character];
    });
  }

  function clone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function list(value) {
    if (Array.isArray(value)) {
      return value.map(function (item) {
        return String(item == null ? '' : item).trim();
      }).filter(Boolean);
    }

    if (value && typeof value === 'object') {
      if (Array.isArray(value.value)) {
        return list(value.value);
      }
      if (value.value != null && typeof value.value !== 'object') {
        return list(value.value);
      }
    }

    return String(value == null ? '' : value)
      .split(/[,;|]+/)
      .map(function (item) { return item.trim(); })
      .filter(Boolean);
  }

  function lower(value) {
    return list(value).map(function (item) { return item.toLowerCase(); });
  }

  function firstName(value) {
    return String(value || '').trim().split(/\s+/)[0].slice(0, 50);
  }

  function cleanText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function booleanValue(value, fallback) {
    if (value === true || value === false) return value;
    if (value === 1 || value === 0) return Boolean(value);

    var text = String(value == null ? '' : value).trim().toLowerCase();
    if (!text) return fallback;
    if (['false', '0', 'no', 'off', 'inactive', 'unavailable'].indexOf(text) >= 0) return false;
    if (['true', '1', 'yes', 'on', 'active', 'available'].indexOf(text) >= 0) return true;
    return fallback;
  }

  function bootAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var roots = context.querySelectorAll('[data-flayvr-ami-v27]');
    Array.prototype.forEach.call(roots, initRoot);
  }


  function initMotionRows(root) {
    var canvas = root.querySelector('.flami-visual');
    var rows = Array.prototype.map.call(
      root.querySelectorAll('[data-ami-motion-row]'),
      function (track) {
        var group = track.querySelector('[data-ami-motion-group]');
        return {
          track: track,
          group: group,
          row: track.getAttribute('data-ami-motion-row'),
          baseCards: group
            ? Array.prototype.map.call(group.children, function (card) { return card.cloneNode(true); })
            : []
        };
      }
    );

    if (!rows.length) return function () {};

    var resizeTimer = 0;

    function cardWidth() {
      var styles = window.getComputedStyle(root);
      var variable = window.matchMedia('(max-width:820px)').matches
        ? '--ami-motion-card-width-mobile'
        : '--ami-motion-card-width';
      return parseFloat(styles.getPropertyValue(variable)) || 246;
    }

    function prepare(entry) {
      if (!entry.group || !entry.baseCards.length) return;

      entry.track.classList.remove('is-ready');
      Array.prototype.forEach.call(
        entry.track.querySelectorAll('[data-ami-motion-clone]'),
        function (clone) { clone.remove(); }
      );

      entry.group.replaceChildren();
      entry.baseCards.forEach(function (card) {
        entry.group.appendChild(card.cloneNode(true));
      });

      var minimum = (canvas ? canvas.clientWidth : root.clientWidth) + (cardWidth() * 2);
      var guard = 0;

      while (entry.group.getBoundingClientRect().width < minimum && guard < 80) {
        entry.group.appendChild(entry.baseCards[guard % entry.baseCards.length].cloneNode(true));
        guard += 1;
      }

      var clone = entry.group.cloneNode(true);
      clone.removeAttribute('data-ami-motion-group');
      clone.setAttribute('data-ami-motion-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      entry.track.appendChild(clone);

      var distance = Math.ceil(entry.group.getBoundingClientRect().width);
      root.style.setProperty(
        entry.row === 'top' ? '--ami-row-top-distance' : '--ami-row-bottom-distance',
        distance + 'px'
      );

      void entry.track.offsetWidth;
      entry.track.classList.add('is-ready');
    }

    function prepareAll() {
      rows.forEach(prepare);
    }

    function schedule() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(prepareAll, 120);
    }

    prepareAll();
    window.addEventListener('load', prepareAll, { once: true });
    window.addEventListener('resize', schedule, { passive: true });

    return function () {
      window.clearTimeout(resizeTimer);
      window.removeEventListener('resize', schedule);
    };
  }

  function initRoot(root) {
    if (!root || root.dataset.amiInitialised === VERSION) return;
    root.dataset.amiInitialised = VERSION;

    initMotionRows(root);

    var chat = root.querySelector('[data-ami-chat]');
    var input = root.querySelector('[data-ami-input]');
    var send = root.querySelector('[data-ami-send]');
    var review = root.querySelector('[data-ami-review]');
    var memory = root.querySelector('[data-ami-memory]');
    var memoryToggle = root.querySelector('[data-ami-memory-toggle]');
    var memoryList = root.querySelector('[data-ami-memory-list]');
    var menuGroups = root.querySelector('[data-ami-menu-groups]');
    var status = root.querySelector('[data-ami-status]');
    var configNode = root.querySelector('[data-ami-config]');
    var libraryNode = root.querySelector('[data-ami-library]');
    var weeklyNode = root.querySelector('[data-ami-weekly-ids]');
    var overlay = root.querySelector('[data-ami-overlay]');
    var launch = root.querySelector('[data-ami-launch]');
    var stage = root.querySelector('[data-ami-stage]');
    var workspaceMode = root.hasAttribute('data-ami-workspace');
    var workspaceSurpriseNames = new Set();
    var workspacePreviousSnapshot = null;
    var amiBackgroundScrollY = 0;
    var amiScrollLockActive = false;
    var amiBodyStyleSnapshot = null;
    var homeComposer = root.querySelector('[data-ami-home-composer]');
    var homeInput = root.querySelector('[data-ami-home-input]');
    var homeSend = root.querySelector('[data-ami-home-send]');
    var homePlus = root.querySelector('[data-ami-home-plus]');
    var homeAddMenu = root.querySelector('[data-ami-home-add-menu]');
    var homeAddTaste = root.querySelector('[data-ami-home-add-taste]');
    var composerWrap = root.querySelector('.flami-composer-wrap');
    var chatColumn = root.querySelector('.flami-chat-column');
    var topbar = root.querySelector('.flami-topbar');
    var topbarOriginalParent = topbar ? topbar.parentNode : null;
    var topbarOriginalNextSibling = topbar ? topbar.nextSibling : null;

    /* v4.10.5 scoped portal host
       Keep the live page in place behind Ami, but move the active overlay
       into a shallow body-level host that preserves Ami's scoped CSS. */
    var portalOriginalParent = overlay.parentNode;
    var portalOriginalNextSibling = overlay.nextSibling;
    var portalPlaceholder = document.createComment('flayvr-ami-overlay-portal');
    var portalHost = null;
    var portalActive = false;

    if (!chat || !input || !send || !review || !memory || !memoryToggle || !memoryList || !menuGroups || !status || !configNode || !libraryNode || !overlay || !launch || !stage) {
      console.error('[Flayvr Ami v27] Required section markup is missing.');
      return;
    }

    var config = {};
    try {
      config = JSON.parse(configNode.textContent || '{}');
    } catch (error) {
      console.error('[Flayvr Ami v27] Invalid configuration JSON.', error);
    }

    var state = blankState();
    var savedRecord = null;
    var awaitingResume = false;

    function stepComplete(id) {
      return state.completed.indexOf(id) >= 0;
    }

    function markComplete(id) {
      if (!stepComplete(id)) state.completed.push(id);
    }

    function firstIncomplete() {
      for (var index = 0; index < STEPS.length; index += 1) {
        if (!stepComplete(STEPS[index].id)) return STEPS[index];
      }
      return null;
    }

    function coveragePlan() {
      return COVERAGE[String(state.coverage)] || COVERAGE['80'];
    }

    function save() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          state: clone(state),
          savedAt: Date.now(),
          version: VERSION
        }));

        LEGACY_KEYS.forEach(function (key) {
          localStorage.removeItem(key);
        });
      } catch (error) {
        console.warn('[Flayvr Ami v27] Could not save memory.', error);
      }
      renderMemory();
    }

    function clearSaved() {
      try {
        [STORAGE_KEY].concat(LEGACY_KEYS).forEach(function (key) {
          localStorage.removeItem(key);
        });
      } catch (error) {
        console.warn('[Flayvr Ami v27] Could not clear memory.', error);
      }
    }

    function migrateSaved(source) {
      var restored = blankState();
      var raw = source && source.state && typeof source.state === 'object' ? source.state : (source || {});

      restored.name = firstName(raw.name || raw.recipientName || raw.customerName || raw.firstName || '');
      restored.people = String(raw.people || raw.householdSize || raw.household || raw.serves || '').trim();

      restored.coverage = COVERAGE[String(raw.coverage || raw.rhythm || raw.budget)]
        ? String(raw.coverage || raw.rhythm || raw.budget)
        : '80';

      restored.allergies = list(raw.allergies || raw.hardAllergies || raw.intolerances);
      restored.allergiesKnown = Boolean(
        raw.allergiesKnown ||
        raw.allergiesConfirmed ||
        raw.allergyProfileConfirmed ||
        restored.allergies.length
      );

      /* Older Ami versions mixed allergies and dislikes inside `avoids`.
         Preserve those conservatively as a hard legacy avoid until the
         customer explicitly updates the new structured allergy question. */
      var legacyAvoid = Array.isArray(raw.legacyHardAvoids)
        ? raw.legacyHardAvoids.join(', ')
        : String(raw.legacyHardAvoids || raw.avoids || raw.avoidances || '');
      restored.legacyHardAvoids = legacyAvoid.trim();

      restored.diet = list(raw.diet || raw.diets);
      restored.dietKnown = Boolean(
        raw.dietKnown ||
        restored.diet.length ||
        (Array.isArray(raw.completed) && raw.completed.indexOf('diet') >= 0)
      );

      restored.dislikes = list(raw.dislikes || raw.softDislikes);
      if (!restored.dislikes.length && legacyAvoid) restored.dislikes = list(legacyAvoid);
      restored.dislikesKnown = Boolean(
        raw.dislikesKnown ||
        restored.dislikes.length ||
        (Array.isArray(raw.completed) && (raw.completed.indexOf('dislikes') >= 0 || raw.completed.indexOf('avoids') >= 0))
      );

      restored.spice = String(raw.spice || raw.heat || 'Medium');

      /* Mood is deliberately order-level. Older goal data stays in the
         compatibility goal field, but never becomes the new mood identity. */
      restored.mood = String(raw.mood || raw.orderMood || '').trim();
      restored.chefNotes = String(raw.chefNotes || raw.chefNote || raw.notesToChef || raw.customerNotes || '').trim();
      restored.goal = list(raw.goal || raw.goals || raw.optimise || raw.support);

      restored.avoids = String(raw.avoids || '');

      restored.menu = Array.isArray(raw.menu)
        ? raw.menu
        : Array.isArray(source && source.currentMenu)
          ? source.currentMenu
          : [];

      restored.completed = Array.isArray(raw.completed)
        ? raw.completed.map(function (id) {
            return id === 'avoids' ? 'dislikes' : id === 'goal' ? 'mood' : id;
          }).filter(function (id) {
            return STEPS.some(function (step) { return step.id === id; });
          })
        : Array.isArray(source && source.completedSteps)
          ? source.completedSteps.map(function (id) {
              return id === 'avoids' ? 'dislikes' : id === 'goal' ? 'mood' : id;
            }).filter(function (id) {
              return STEPS.some(function (step) { return step.id === id; });
            })
          : [];

      if (!restored.completed.length && Number.isFinite(Number(raw.step))) {
        var legacyOrder = ['name', 'diet', 'dislikes', 'coverage', 'spice'];
        restored.completed = legacyOrder.slice(0, Math.max(0, Math.min(legacyOrder.length, Number(raw.step))));
      }

      if (!restored.completed.length) {
        if (raw.name || raw.recipientName || Number(raw.stepIndex) > 0) restored.completed.push('name');
        if (restored.people) restored.completed.push('people');
        if (raw.coverage || raw.rhythm || raw.budget) restored.completed.push('coverage');
        if (restored.dietKnown) restored.completed.push('diet');
        if (restored.dislikesKnown) restored.completed.push('dislikes');
        if (raw.spice || raw.heat || Number(raw.stepIndex) >= 7) restored.completed.push('spice');
      }

      /* A legacy hard avoid must be reconfirmed through the new allergy step. */
      restored.completed = restored.completed.filter(function (id) {
        return id !== 'allergies' || restored.allergiesKnown;
      });

      restored.updatingAllergies = false;
      restored.editingCoverage = false;
      return restored;
    }

    function readSaved() {
      var keys = [STORAGE_KEY].concat(LEGACY_KEYS);

      for (var index = 0; index < keys.length; index += 1) {
        var key = keys[index];
        try {
          var parsed = JSON.parse(localStorage.getItem(key) || 'null');
          if (!parsed) continue;

          var savedAt = Number(parsed.savedAt || parsed.updatedAt || 0);
          if (!savedAt || Date.now() - savedAt > MEMORY_MS) {
            localStorage.removeItem(key);
            continue;
          }

          return {
            state: migrateSaved(parsed),
            savedAt: savedAt,
            key: key
          };
        } catch (error) {
          try { localStorage.removeItem(key); } catch (ignore) {}
        }
      }

      return null;
    }

    function applySaved(record) {
      Object.assign(state, blankState(), clone(record.state));
      state.people = String(state.people || '').trim();
      state.allergies = list(state.allergies);
      state.legacyHardAvoids = String(state.legacyHardAvoids || '').trim();
      state.diet = list(state.diet);
      state.dislikes = list(state.dislikes);
      state.spice = String(state.spice || 'Medium');
      state.mood = String(state.mood || '');
      state.chefNotes = String(state.chefNotes || '').trim();
      state.goal = list(state.goal);
      state.completed = list(state.completed);
      state.menu = Array.isArray(state.menu) ? state.menu : [];
      state.updatingAllergies = false;
      state.editingCoverage = false;
    }

    function clearChat() {
      chat.innerHTML = '';
    }

    function makePortalHost() {
      var host = document.createElement('div');
      host.className = 'flami-portal-host is-open';

      /* Recreate only the selector/variable context needed by Ami CSS.
         Do not move or duplicate the real page content. */
      host.setAttribute('data-flayvr-ami-v27', '');
      if (workspaceMode) host.setAttribute('data-ami-workspace', '');
      if (root.hasAttribute('data-ami-dedicated-page')) host.setAttribute('data-ami-dedicated-page', '');
      if (root.hasAttribute('data-flayvr-ami-home-v2116')) host.setAttribute('data-flayvr-ami-home-v2116', '');

      host.style.cssText = root.style.cssText || '';
      return host;
    }

    function mountContainedTopbar() {
      if (!topbar || !chatColumn) return;
      if (topbar.parentNode !== chatColumn) chatColumn.insertBefore(topbar, chatColumn.firstChild);
    }

    function restoreTopbarPosition() {
      if (!topbar || !topbarOriginalParent) return;
      if (topbarOriginalNextSibling && topbarOriginalNextSibling.parentNode === topbarOriginalParent) {
        topbarOriginalParent.insertBefore(topbar, topbarOriginalNextSibling);
      } else {
        topbarOriginalParent.appendChild(topbar);
      }
    }

    function syncPortalReviewState() {
      if (portalHost) {
        portalHost.classList.toggle('is-reviewing', root.classList.contains('is-reviewing'));
      }
    }

    function mountAmiPortal() {
      if (portalActive) {
        syncPortalReviewState();
        return;
      }

      portalOriginalParent = overlay.parentNode || portalOriginalParent;
      portalOriginalNextSibling = overlay.nextSibling;

      if (portalOriginalParent && portalPlaceholder.parentNode !== portalOriginalParent) {
        portalOriginalParent.insertBefore(portalPlaceholder, overlay);
      }

      portalHost = makePortalHost();
      document.body.appendChild(portalHost);
      portalHost.appendChild(overlay);

      overlay.classList.add('flami-portal-overlay');
      overlay.setAttribute('data-ami-portal-open', '');
      root.classList.add('flami-portal-source');

      portalActive = true;
      mountContainedTopbar();
      syncPortalReviewState();
    }

    function unmountAmiPortal() {
      if (!portalActive) return;

      restoreTopbarPosition();

      overlay.classList.remove('flami-portal-overlay');
      overlay.removeAttribute('data-ami-portal-open');

      if (portalPlaceholder.parentNode) {
        portalPlaceholder.parentNode.insertBefore(overlay, portalPlaceholder);
        portalPlaceholder.remove();
      } else if (portalOriginalParent) {
        if (portalOriginalNextSibling && portalOriginalNextSibling.parentNode === portalOriginalParent) {
          portalOriginalParent.insertBefore(overlay, portalOriginalNextSibling);
        } else {
          portalOriginalParent.appendChild(overlay);
        }
      }

      if (portalHost && portalHost.parentNode) portalHost.parentNode.removeChild(portalHost);
      portalHost = null;
      root.classList.remove('flami-portal-source');
      portalActive = false;
    }

    function scrollConversationToLatest() {
      if (!root.classList.contains('is-open')) return;

      var activeOverlay = overlay;
      window.requestAnimationFrame(function () {
        if (!root.classList.contains('is-open')) return;
        if (!activeOverlay) return;

        var targetTop = Math.max(0, activeOverlay.scrollHeight - activeOverlay.clientHeight);
        activeOverlay.scrollTo({ top: targetTop, left: 0, behavior: 'smooth' });
      });
    }

    function addMessage(text, who) {
      var row = document.createElement('div');
      row.className = 'flami-msg flami-msg--' + (who === 'user' ? 'user' : 'ami');
      row.innerHTML = '<div class="flami-bubble">' + esc(text) + '</div>';
      chat.appendChild(row);
      scrollConversationToLatest();
      return row;
    }

    function runThinkingCycle(phases, interval) {
      phases = Array.isArray(phases) && phases.length ? phases : ['Thinking…'];
      interval = Math.max(560, Number(interval || 720));

      /* Only one live thinking turn at a time. */
      Array.prototype.forEach.call(chat.querySelectorAll('.flami-thinking-turn'), function (node) {
        node.remove();
      });

      var row = document.createElement('div');
      row.className = 'flami-thinking-turn';
      row.setAttribute('data-ami-thinking', '');
      row.innerHTML =
        '<div class="flami-thinking-avatar">A</div>' +
        '<div class="flami-thinking-body">' +
          '<div class="flami-thinking-status">' +
            '<span class="flami-fluid-dots" aria-hidden="true">' +
              '<i></i><i></i><i></i><i></i><i></i><i></i>' +
            '</span>' +
            '<span data-thinking-text></span>' +
          '</div>' +
        '</div>';

      var text = row.querySelector('[data-thinking-text]');
      chat.appendChild(row);

      var index = 0;
      var startedAt = Date.now();
      text.textContent = phases[0];
      scrollConversationToLatest();

      return new Promise(function (resolve) {
        function finish() {
          /* Keep the approved loader visible long enough to register visually,
             even for a single quick phase. */
          var elapsed = Date.now() - startedAt;
          var remaining = Math.max(360, 1150 - elapsed);
          window.setTimeout(function () {
            row.remove();
            resolve();
            scrollConversationToLatest();
          }, remaining);
        }

        function next() {
          index += 1;
          if (index >= phases.length) {
            finish();
            return;
          }

          text.classList.add('is-changing');
          window.setTimeout(function () {
            text.textContent = phases[index];
            text.classList.remove('is-changing');
            scrollConversationToLatest();
            window.setTimeout(next, interval);
          }, 160);
        }

        window.setTimeout(next, interval);
      });
    }

    function choiceHostForLatestAmiMessage() {
      var rows = chat.querySelectorAll('.flami-msg--ami');
      var row = rows.length ? rows[rows.length - 1] : null;
      var bubble = row ? row.querySelector('.flami-bubble') : null;
      return bubble || chat;
    }

    function addActionButtons(actions) {
      var box = document.createElement('div');
      box.className = 'flami-choices';

      actions.forEach(function (action) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'flami-choice';
        button.textContent = action[0];
        button.addEventListener('click', action[1]);
        box.appendChild(button);
      });

      choiceHostForLatestAmiMessage().appendChild(box);
      scrollConversationToLatest();
      return box;
    }

    function setStepValue(step, value) {
      if (step.id === 'name') state.name = firstName(value);
      if (step.id === 'people') state.people = String(value || '').trim();
      if (step.id === 'coverage') state.coverage = String(value);

      if (step.id === 'allergies') {
        var allergyValues = list(value).filter(function (item) { return cleanText(item) !== 'none'; });
        state.allergies = allergyValues;
        state.allergiesKnown = true;
        state.legacyHardAvoids = '';
        state.updatingAllergies = false;
      }

      if (step.id === 'diet') {
        state.diet = list(value).filter(function (item) { return cleanText(item) !== 'no restrictions'; });
        state.dietKnown = true;
      }

      if (step.id === 'dislikes') {
        state.dislikes = list(value).filter(function (item) { return cleanText(item) !== 'nothing in particular'; });
        state.dislikesKnown = true;
      }

      if (step.id === 'spice') state.spice = String(value || 'Medium');
      if (step.id === 'mood') state.mood = String(value || '').trim();

      if (['people', 'coverage', 'allergies', 'diet', 'dislikes', 'spice', 'mood'].indexOf(step.id) >= 0) {
        state.menu = [];
      }

      markComplete(step.id);
      state.currentStepId = '';
      save();
    }

    function thinkingPhasesForStep(step, value) {
      var id = step && step.id;
      if (id === 'name') return ['Taking that in…', 'Getting your week ready…'];
      if (id === 'people') return ['Thinking about portions…', 'Shaping the week around your household…'];
      if (id === 'coverage') return ['Thinking about your week…', 'Balancing convenience and variety…'];
      if (id === 'allergies') return ['Locking your safety rules…', 'Checking this week’s ingredients…'];
      if (id === 'diet') return ['Checking your food rules…', 'Filtering this week safely…'];
      if (id === 'dislikes') return ['Learning what to push down…', 'Keeping stronger matches higher…'];
      if (id === 'spice') return ['Checking flavour intensity…', 'Matching the heat level…'];
      if (id === 'mood') return ['Turning that into a plate direction…', 'Balancing the week around it…'];
      return ['Thinking about that…', 'Checking it against what you’ve already told me…'];
    }

    function acknowledgementForStep(step, value) {
      if (!step) return '';
      var id = step.id;
      var values = list(value);
      var joined = values.join(', ');

      if (id === 'name') {
        return state.name
          ? 'Nice to meet you, ' + state.name + '. I’ll keep the week focused on what actually works for you.'
          : '';
      }

      if (id === 'people') {
        if (String(value) === 'Just me') return 'Perfect — I’m planning this around one person.';
        if (String(value) === 'Two of us') return 'Got it — I’m feeding two, so I’ll shape the week around both of you.';
        if (String(value).indexOf('Family') === 0) return 'Family it is. I’ll plan with shared meals and enough variety across the week.';
      }

      if (id === 'coverage') {
        if (String(value) === '40') return 'Perfect — I’ll take care of the five weekday dinners.';
        if (String(value) === '80') return 'Got it — weekday lunch and dinner are covered.';
        if (String(value) === '120') return 'Great — I’m taking care of the full seven-day plan.';
      }

      if (id === 'allergies') {
        if (!values.length || values.some(function (item) { return cleanText(item) === 'none'; })) {
          return 'Thanks — I don’t have any allergies or intolerances marked as hard rules.';
        }
        return 'Locked. I’ll treat ' + joined + ' as a hard safety rule and I won’t relax it during matching.';
      }

      if (id === 'diet') {
        if (!values.length || values.some(function (item) { return cleanText(item) === 'no restrictions'; })) {
          return 'No dietary rules for this order — that gives me the full safe menu to work with.';
        }
        return 'Understood — I’ll only build from meals that fit ' + joined + '.';
      }

      if (id === 'dislikes') {
        if (!values.length || values.some(function (item) { return cleanText(item) === 'nothing in particular'; })) {
          return 'Great — I won’t push anything down for dislike reasons.';
        }
        return 'Got it. I’ll push ' + joined + ' down the ranking rather than treating it like a safety rule.';
      }

      if (id === 'spice') {
        if (String(value) === 'Medium') return 'Medium works. I’ll keep flavour high without making heat the main event.';
        if (String(value) === 'Hot') return 'Hot it is. I’ll favour the dishes where that level makes sense.';
        if (String(value) === 'Extra Hot') return 'Extra Hot — noted. I’ll move the bolder dishes higher.';
      }

      if (id === 'mood') {
        if (String(value) === 'Keep me steady') return 'Steady is the lever this week — balanced, sustaining and not too heavy.';
        if (String(value) === 'Feel lighter') return 'Lighter is the direction — fresher, cleaner and still satisfying.';
        if (String(value) === 'More comforting') return 'Comfort is the direction — warmer, more reassuring plates.';
        if (String(value) === 'More energising') return 'More energising — I’ll lean toward meals with stronger sustaining signals.';
        if (String(value) === 'Keep it interesting') return 'Got it — I’ll turn the discovery dial up without breaking your food rules.';
        if (String(value) === 'Make life easy') return 'Easy is the brief — I’ll favour familiar, reliable choices and minimise decision-making.';
      }

      return '';
    }

    function finishStep(step, value, label) {
      addMessage(label, 'user');
      setStepValue(step, value);

      var acknowledgement = acknowledgementForStep(step, value);
      var phases = thinkingPhasesForStep(step, value);

      runThinkingCycle(phases, 560).then(function () {
        if (state.editingCoverage) {
          state.editingCoverage = false;
          if (acknowledgement) addMessage(acknowledgement, 'ami');
          runThinkingCycle(['Re-checking this week…', 'Rebalancing the menu…'], 520).then(buildMenu);
          return;
        }

        var next = firstIncomplete();
        if (next) {
          askStep(acknowledgement);
          return;
        }

        var finalAck = acknowledgement;
        if (finalAck) finalAck += '\n\n';
        var household = state.people ? state.people.toLowerCase() : 'your household';
        var dietSummary = state.diet.length ? state.diet.join(' + ').toLowerCase() : 'no dietary restrictions';
        var moodSummary = state.mood ? state.mood.toLowerCase() : 'a practical week';
        finalAck += 'Okay — I’m planning for ' + household + ', covering ' + coveragePlan().label.toLowerCase() + ', with ' + dietSummary + ' and "' + moodSummary + '" as this order’s direction. I’ve got enough to build your week.';
        addMessage(finalAck, 'ami');

        runThinkingCycle([
          'Scanning this week’s meals…',
          'Checking your dietary rules…',
          'Ranking the strongest matches…',
          'Balancing variety across the week…',
          'Finalising your menu…'
        ], 520).then(function () {
          window.setTimeout(function () {
            try {
              buildMenu({ announceSuccess: true });
            } catch (error) {
              console.error('[Flayvr Ami v27] Final menu handoff failed.', error);
              status.textContent = '';
              addMessage('I hit a problem displaying your menu. Your answers are saved — please try Plan my week again.', 'ami');
            }
          }, 220);
        });
      });
    }

    function skipStep(step) {
      if (!step || !step.skippable) return;
      finishStep(step, step.type === 'multi' ? [] : '', 'Skip');
    }

    function currentValuesForStep(step) {
      if (!step) return [];
      if (step.id === 'allergies') return list(state.allergies);
      if (step.id === 'diet') {
        if (state.diet.length) return list(state.diet);
        return state.dietKnown ? ['No restrictions'] : [];
      }
      if (step.id === 'dislikes') {
        if (state.dislikes.length) return list(state.dislikes);
        return state.dislikesKnown ? ['Nothing in particular'] : [];
      }
      return [];
    }

    function allergySummary() {
      var parts = list(state.allergies);
      if (state.legacyHardAvoids) parts = parts.concat(list(state.legacyHardAvoids));
      var seen = Object.create(null);
      parts = parts.filter(function (item) {
        var key = cleanText(item);
        if (!key || seen[key]) return false;
        seen[key] = true;
        return true;
      });
      return parts.length ? parts.join(', ') : 'no allergies or intolerances';
    }

    function completeConfirmedAllergies(step) {
      addMessage('Still correct', 'user');
      state.allergiesKnown = true;
      markComplete('allergies');
      state.currentStepId = '';
      save();
      runThinkingCycle(thinkingPhasesForStep(step, state.allergies), 520).then(function () {
        askStep('Perfect — I’ll keep those safety rules locked.');
      });
    }

    function updateSavedAllergies(step) {
      addMessage('Update', 'user');
      state.updatingAllergies = true;
      addMessage('Select every allergy or intolerance I must treat as a hard rule. You can also type another one.', 'ami');
      input.placeholder = step.placeholder || 'Message Ami…';
      addChoices(step);
    }

    function addChoices(step) {
      var box = document.createElement('div');
      box.className = 'flami-choices';
      var prefilled = currentValuesForStep(step);
      var prefilledKeys = prefilled.map(cleanText);

      if (step.type === 'coverage') {
        Object.keys(COVERAGE).forEach(function (key) {
          var plan = COVERAGE[key];
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'flami-choice flami-choice--plan' + (String(state.coverage) === key ? ' is-selected' : '');
          button.dataset.value = key;
          button.innerHTML = '<strong>£' + plan.price + ' · ' + esc(plan.label) + '</strong><small>' + esc(plan.detail) + '</small>';
          button.addEventListener('click', function () {
            Array.prototype.forEach.call(box.querySelectorAll('button'), function (node) { node.disabled = true; });
            finishStep(step, key, plan.label);
          });
          box.appendChild(button);
        });
      } else if (step.choices) {
        step.choices.forEach(function (choice) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'flami-choice';
          button.textContent = choice;

          if (prefilledKeys.indexOf(cleanText(choice)) >= 0) {
            button.classList.add('is-selected');
            button.dataset.prefilled = 'true';
          }

          if (step.type === 'multi') {
            button.addEventListener('click', function () {
              var wasPrefilled = button.dataset.prefilled === 'true' && !box._amiTouched;

              /* Tapping an unchanged pre-filled value confirms it in one tap.
                 Any other interaction switches into normal editable selection. */
              if (!wasPrefilled) button.classList.toggle('is-selected');
              box._amiTouched = true;
              Array.prototype.forEach.call(box.querySelectorAll('[data-prefilled]'), function (node) {
                node.removeAttribute('data-prefilled');
              });

              var noneChoice = cleanText(step.noneChoice || '');
              if (cleanText(choice) === noneChoice && button.classList.contains('is-selected')) {
                Array.prototype.forEach.call(box.querySelectorAll('.flami-choice'), function (node) {
                  if (node !== button) node.classList.remove('is-selected');
                });
              } else if (cleanText(choice) !== noneChoice && button.classList.contains('is-selected')) {
                Array.prototype.forEach.call(box.querySelectorAll('.flami-choice'), function (node) {
                  if (cleanText(node.textContent) === noneChoice) node.classList.remove('is-selected');
                });
              }

              window.clearTimeout(box._amiMultiCommitTimer);
              var selected = box.querySelectorAll('.flami-choice.is-selected');
              if (!selected.length) return;

              var delay = cleanText(choice) === noneChoice
                ? 520
                : Number(step.autoAdvanceDelay || 1000);

              box._amiMultiCommitTimer = window.setTimeout(function () {
                var values = Array.prototype.map.call(
                  box.querySelectorAll('.flami-choice.is-selected'),
                  function (node) { return node.textContent; }
                );
                if (!values.length) return;
                Array.prototype.forEach.call(box.querySelectorAll('button'), function (node) { node.disabled = true; });
                finishStep(step, values, values.join(', '));
              }, delay);
            });
          } else {
            if (
              (step.id === 'spice' && cleanText(state.spice) === cleanText(choice)) ||
              (step.id === 'people' && cleanText(state.people) === cleanText(choice))
            ) {
              button.classList.add('is-selected');
            }

            button.addEventListener('click', function () {
              Array.prototype.forEach.call(box.querySelectorAll('button'), function (node) { node.disabled = true; });
              finishStep(step, choice, choice);
            });
          }

          box.appendChild(button);
        });
      }

      if (step.skippable) {
        var skip = document.createElement('button');
        skip.type = 'button';
        skip.className = 'flami-choice';
        skip.textContent = 'Skip';
        skip.addEventListener('click', function () { skipStep(step); });
        box.appendChild(skip);
      }

      choiceHostForLatestAmiMessage().appendChild(box);
      scrollConversationToLatest();
    }

    function askStep(preface) {
      var step = firstIncomplete();
      if (!step) {
        buildMenu();
        return;
      }

      state.currentStepId = step.id;
      save();

      if (step.id === 'allergies' && state.allergiesKnown && !state.updatingAllergies) {
        addMessage(
          (preface ? preface + '\n\n' : '') +
          'I still have ' + allergySummary() + ' marked as your hard safety rule' +
          (allergySummary() === 'no allergies or intolerances' ? '.' : 's.') +
          ' Has anything changed?',
          'ami'
        );
        addActionButtons([
          ['Still correct', function () { completeConfirmedAllergies(step); }],
          ['Update', function () { updateSavedAllergies(step); }]
        ]);
        input.placeholder = 'Message Ami…';
        return;
      }

      addMessage((preface ? preface + '\n\n' : '') + step.question, 'ami');
      input.placeholder = step.placeholder || 'Message Ami…';

      if (step.type !== 'text' || step.skippable) addChoices(step);
      input.focus({ preventScroll: true });
    }

    function matchPeople(value) {
      var text = cleanText(value);
      if (!text) return null;
      if (/\b(just me|for me|myself|one person|1 person|one of us|1)\b/.test(text)) return 'Just me';
      if (/\b(two of us|for two|two people|2 people|couple|2)\b/.test(text)) return 'Two of us';
      if (/\b(family|three people|3 people|four people|4 people|3|4)\b/.test(text)) return 'Family (3–4)';
      return null;
    }

    function matchCoverage(value) {      var text = String(value || '').toLowerCase();
      if (/(^|\D)120(\D|$)/.test(text) || text.indexOf('full week') >= 0 || text.indexOf('seven day') >= 0 || text.indexOf('7 day') >= 0 || text.indexOf('breakfast') >= 0) return '120';
      if (/(^|\D)40(\D|$)/.test(text) || text.indexOf('weekday dinner') >= 0 || text.indexOf('dinners only') >= 0) return '40';
      if (/(^|\D)80(\D|$)/.test(text) || (text.indexOf('lunch') >= 0 && text.indexOf('dinner') >= 0)) return '80';
      return null;
    }

    function submitText() {
      var value = input.value.trim();
      if (!value) return;
      input.value = '';

      if (awaitingResume) {
        var typed = value.toLowerCase();
        if (/continue|resume|carry on/.test(typed)) {
          resumePlan();
          return;
        }
        if (/fresh|new plan|start again/.test(typed)) {
          startFresh();
          return;
        }
        addMessage('Choose Continue my plan or Start fresh.', 'ami');
        return;
      }

      if (state.editingCoverage) {
        var editedCoverage = matchCoverage(value);
        addMessage(value, 'user');
        if (!editedCoverage) {
          addMessage('Choose weekday dinners, weekday lunch and dinner, or the full seven-day plan.', 'ami');
          return;
        }
        setStepValue(STEPS.find(function (step) { return step.id === 'coverage'; }), editedCoverage);
        state.editingCoverage = false;
        buildMenu();
        return;
      }

      if (root.classList.contains('is-reviewing')) {
        enterConversationMode();
        addMessage(value, 'user');
        state.dislikes = state.dislikes.concat([value]).filter(Boolean);
        state.dislikesKnown = true;
        state.menu = [];
        save();
        addMessage('I’ve kept the rest of your profile and added that as a soft dislike.', 'ami');
        buildMenu();
        return;
      }

      var step = firstIncomplete();
      if (!step) {
        addMessage(value, 'user');
        state.dislikes = state.dislikes.concat([value]).filter(Boolean);
        state.dislikesKnown = true;
        state.menu = [];
        save();
        buildMenu();
        return;
      }

      if (step.type === 'coverage') {
        var matched = matchCoverage(value);
        if (!matched) {
          addMessage(value, 'user');
          addMessage('Choose weekday dinners, weekday lunch and dinner, or the full seven-day plan.', 'ami');
          return;
        }
        finishStep(step, matched, value);
        return;
      }

      finishStep(step, step.type === 'multi' ? [value] : value, value);
    }

    function weeklyMealIds() {
      if (!weeklyNode) return new Set();

      try {
        var parsed = JSON.parse(weeklyNode.textContent || '[]') || [];
        return new Set(parsed.map(function (value) { return String(value || ''); }).filter(Boolean));
      } catch (error) {
        console.warn('[Flayvr Ami v27] Invalid weekly-menu ID JSON.', error);
        return new Set();
      }
    }

    function rawLibrary() {
      try {
        var parsed = JSON.parse(libraryNode.textContent || '[]') || [];
        var weeklyIds = weeklyMealIds();
        var orderedKeys = [];
        var byKey = Object.create(null);

        function union(left, right) {
          var seen = Object.create(null);
          return list(left).concat(list(right)).filter(function (item) {
            var key = cleanText(item);
            if (!key || seen[key]) return false;
            seen[key] = true;
            return true;
          });
        }

        parsed.forEach(function (meal, index) {
          var normalised = {
            id: String(meal.id || ''),
            handle: String(meal.handle || ''),
            name: String(meal.name || '').trim(),
            description: String(meal.description || '').trim(),
            customerDescription: String(meal.customerDescription || '').trim(),
            image: String(meal.image || '').trim(),
            diet: list(meal.diet),
            ingredients: list(meal.ingredients),
            allergens: list(meal.allergens),
            supportTags: list(meal.supportTags),
            plan: list(meal.plan),
            mealType: list(meal.mealType),
            active: booleanValue(meal.active, true),
            availableFlag: booleanValue(meal.availableFlag, false),
            weeklySelected: weeklyIds.has(String(meal.id || '')),
            priority: Number(meal.priority || 0),
            calories: Number(meal.calories || 0),
            protein: Number(meal.protein || 0),
            fibre: Number(meal.fibre || 0),
            carbs: Number(meal.carbs || 0),
            fat: Number(meal.fat || 0),
            cuisine: String(meal.cuisine || ''),
            spiceLevel: Number(meal.spiceLevel || 0),
            chefSpecial: booleanValue(meal.chefSpecial, false),
            tasteAdventure: Number(meal.tasteAdventure || 0),
            tasteHeat: Number(meal.tasteHeat || 0),
            tasteIntensity: Number(meal.tasteIntensity || 0),
            tasteAcid: Number(meal.tasteAcid || 0),
            tasteTexture: Number(meal.tasteTexture || 0),
            tasteSweet: Number(meal.tasteSweet || 0),
            displayName: String(meal.displayName || meal.name || '').trim(),
            baseMealKey: cleanText(String(meal.baseMealKey || meal.handle || meal.name || '')),
            versionCode: String(meal.versionCode || '').trim(),
            versionLabel: String(meal.versionLabel || '').trim(),
            adaptationNote: String(meal.adaptationNote || '').trim(),
            kitchenInstruction: String(meal.kitchenInstruction || '').trim(),
            adapted: booleanValue(meal.adapted, false),
            variantApproved: booleanValue(meal.variantApproved, true),
            safetyReviewed: booleanValue(meal.safetyReviewed, false),
            adaptationRulesRaw: meal.adaptationRules || ''
          };

          var key = normalised.id ||
            normalised.handle ||
            cleanText(normalised.name) ||
            String(index);

          if (!byKey[key]) {
            byKey[key] = normalised;
            orderedKeys.push(key);
            return;
          }

          var existing = byKey[key];

          if (!existing.handle && normalised.handle) existing.handle = normalised.handle;
          if (!existing.name && normalised.name) existing.name = normalised.name;
          if (!existing.description && normalised.description) existing.description = normalised.description;
          if (!existing.customerDescription && normalised.customerDescription) existing.customerDescription = normalised.customerDescription;
          if (!existing.image && normalised.image) existing.image = normalised.image;

          existing.diet = union(existing.diet, normalised.diet);
          existing.ingredients = union(existing.ingredients, normalised.ingredients);
          existing.allergens = union(existing.allergens, normalised.allergens);
          existing.supportTags = union(existing.supportTags, normalised.supportTags);
          existing.plan = union(existing.plan, normalised.plan);
          existing.mealType = union(existing.mealType, normalised.mealType);

          existing.active = existing.active && normalised.active;
          existing.availableFlag = existing.availableFlag || normalised.availableFlag;
          existing.weeklySelected = existing.weeklySelected || normalised.weeklySelected;
          existing.priority = Math.max(existing.priority, normalised.priority);
          existing.calories = existing.calories || normalised.calories;
          existing.protein = existing.protein || normalised.protein;
          existing.fibre = existing.fibre || normalised.fibre;
          existing.carbs = existing.carbs || normalised.carbs;
          existing.fat = existing.fat || normalised.fat;
          existing.chefSpecial = existing.chefSpecial || normalised.chefSpecial;
          existing.cuisine = existing.cuisine || normalised.cuisine;
          existing.spiceLevel = existing.spiceLevel || normalised.spiceLevel;
          existing.tasteAdventure = existing.tasteAdventure || normalised.tasteAdventure;
          existing.tasteHeat = existing.tasteHeat || normalised.tasteHeat;
          existing.tasteIntensity = existing.tasteIntensity || normalised.tasteIntensity;
          existing.tasteAcid = existing.tasteAcid || normalised.tasteAcid;
          existing.tasteTexture = existing.tasteTexture || normalised.tasteTexture;
          existing.tasteSweet = existing.tasteSweet || normalised.tasteSweet;
          existing.displayName = existing.displayName || normalised.displayName;
          existing.baseMealKey = existing.baseMealKey || normalised.baseMealKey;
          existing.versionCode = existing.versionCode || normalised.versionCode;
          existing.versionLabel = existing.versionLabel || normalised.versionLabel;
          existing.adaptationNote = existing.adaptationNote || normalised.adaptationNote;
          existing.kitchenInstruction = existing.kitchenInstruction || normalised.kitchenInstruction;
          existing.adapted = existing.adapted || normalised.adapted;
          existing.variantApproved = existing.variantApproved && normalised.variantApproved;
          existing.safetyReviewed = existing.safetyReviewed || normalised.safetyReviewed;
          if (!existing.adaptationRulesRaw && normalised.adaptationRulesRaw) existing.adaptationRulesRaw = normalised.adaptationRulesRaw;
        });

        return orderedKeys.map(function (key) { return byKey[key]; });
      } catch (error) {
        console.error('[Flayvr Ami v27] Invalid food-library JSON.', error);
        return [];
      }
    }


    /*
     * Approved family-variant engine.
     *
     * One Food Library meal can expose several kitchen-approved transforms
     * through adaptation_rules / approved_swaps / variant_matrix.
     *
     * Rules are NEVER inferred by Ami. A generated version exists only when
     * every applied transform is explicitly:
     *   approved: true
     *   safetyReviewed: true
     *
     * The generated candidate is then run through the existing hard dietary
     * and allergy checks. If the approved replacements leave a conflicting
     * ingredient in the customer copy, ingredients or allergens, the version
     * simply fails eligibility rather than being guessed around.
     */
    function variantMapEntryFor(meal) {
      var map = window.FlayvrAmiMealVariants || {};
      var candidates = [
        meal && meal.baseMealKey,
        meal && meal.handle,
        meal && cleanText(meal.name).replace(/\s+/g, '-')
      ].filter(Boolean);

      for (var i = 0; i < candidates.length; i += 1) {
        var key = String(candidates[i]);
        if (map[key]) return { key: key, entry: map[key] };
      }
      return null;
    }

    function ruleApprovalKey(baseKey, rule) {
      return String(baseKey || '') + '::' + String((rule && (rule.code || rule.id || rule.versionCode)) || '');
    }

    function externallyApprovedRule(baseKey, rule) {
      var approvals = window.FlayvrAmiVariantApprovals || {};
      return approvals[ruleApprovalKey(baseKey, rule)] === true;
    }

    function parseAdaptationRules(meal) {
      var out = [];
      var external = variantMapEntryFor(meal);

      if (external && external.entry && Array.isArray(external.entry.rules)) {
        external.entry.rules.forEach(function (rule) {
          var copy = clone(rule);
          var approved = externallyApprovedRule(external.key, copy);
          copy.approved = approved;
          copy.safetyReviewed = approved;
          copy._approvalSource = approved ? 'theme-approval-map' : 'theme-proposal';
          out.push(copy);
        });
      }

      // Backwards-compatible with an optional future Shopify adaptation_rules field.
      var raw = meal && meal.adaptationRulesRaw;
      if (raw) {
        if (typeof raw === 'string') {
          var text = raw.trim();
          if (text) {
            try { raw = JSON.parse(text); }
            catch (error) {
              console.warn('[Flayvr Ami v27] Ignoring invalid adaptation_rules JSON for', meal && meal.name, error);
              raw = null;
            }
          }
        }

        var nativeRules = [];
        if (Array.isArray(raw)) nativeRules = raw;
        else if (raw && Array.isArray(raw.rules)) nativeRules = raw.rules;
        else if (raw && typeof raw === 'object') {
          nativeRules = Object.keys(raw).map(function (key) {
            var value = raw[key];
            if (!value || typeof value !== 'object') return null;
            return Object.assign({ code: key }, value);
          }).filter(Boolean);
        }
        nativeRules.forEach(function (rule) { out.push(rule); });
      }

      return out;
    }

    function uniqValues(values) {
      var seen = Object.create(null);
      return list(values).filter(function (value) {
        var key = cleanText(value);
        if (!key || seen[key]) return false;
        seen[key] = true;
        return true;
      });
    }

    function normaliseVariantRule(rule, index) {
      rule = rule && typeof rule === 'object' ? rule : {};
      var code = String(rule.code || rule.id || rule.versionCode || ('v' + (index + 1))).trim();
      var label = String(rule.label || rule.versionLabel || code).trim();
      var satisfies = uniqValues(rule.satisfies || rule.diet || rule.dietAdd || rule.addDiet);
      var dietAdd = uniqValues(rule.dietAdd || rule.addDiet || satisfies);
      var supportAdd = uniqValues(rule.supportAdd || rule.addSupportTags);
      var removeIngredients = uniqValues(rule.removeIngredients || rule.ingredientsRemove);
      var addIngredients = uniqValues(rule.addIngredients || rule.ingredientsAdd);
      var removeAllergens = uniqValues(rule.removeAllergens || rule.allergensRemove);
      var addAllergens = uniqValues(rule.addAllergens || rule.allergensAdd);
      var excludes = uniqValues(rule.excludes);
      var replacements = rule.replace || rule.replacements || {};
      if (!replacements || typeof replacements !== 'object' || Array.isArray(replacements)) replacements = {};

      return {
        code: code,
        label: label,
        group: cleanText(rule.group || ''),
        satisfies: satisfies,
        dietAdd: dietAdd,
        supportAdd: supportAdd,
        removeIngredients: removeIngredients,
        addIngredients: addIngredients,
        removeAllergens: removeAllergens,
        addAllergens: addAllergens,
        excludes: excludes,
        replacements: replacements,
        displayName: String(rule.displayName || rule.name || '').trim(),
        customerDescription: String(rule.customerDescription || rule.annaDescription || '').trim(),
        customerNote: String(rule.customerNote || rule.adaptationNote || '').trim(),
        kitchenInstruction: String(rule.kitchenInstruction || '').trim(),
        approved: booleanValue(rule.approved, false),
        safetyReviewed: booleanValue(rule.safetyReviewed, false)
      };
    }

    function replaceAllApproved(text, replacements) {
      text = String(text || '');
      Object.keys(replacements || {}).forEach(function (from) {
        var replacement = String(replacements[from] == null ? '' : replacements[from]);
        var escaped = String(from).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        if (!escaped) return;
        text = text.replace(new RegExp(escaped, 'gi'), replacement);
      });
      return text.replace(/\s{2,}/g, ' ').replace(/\s+([,.;:])/g, '$1').trim();
    }

    function removeListed(values, removals) {
      var removeKeys = uniqValues(removals).map(cleanText);
      if (!removeKeys.length) return list(values);
      return list(values).filter(function (value) {
        var key = cleanText(value);
        return !removeKeys.some(function (removeKey) {
          return key === removeKey || key.indexOf(removeKey) >= 0;
        });
      });
    }

    function addUniqueValues(values, additions) {
      return uniqValues(list(values).concat(list(additions)));
    }

    function rulesCompatible(existing, next) {
      if (!next) return false;
      if (next.group && existing.some(function (rule) { return rule.group && rule.group === next.group; })) return false;

      var existingCodes = existing.map(function (rule) { return cleanText(rule.code); });
      var nextCode = cleanText(next.code);
      if (existingCodes.indexOf(nextCode) >= 0) return false;

      if (next.excludes.some(function (code) { return existingCodes.indexOf(cleanText(code)) >= 0; })) return false;
      if (existing.some(function (rule) {
        return rule.excludes.some(function (code) { return cleanText(code) === nextCode; });
      })) return false;

      return true;
    }

    function variantRuleSets(rules) {
      var approved = rules.filter(function (rule) {
        return rule.approved === true && rule.safetyReviewed === true;
      });
      var out = [];
      var seen = Object.create(null);

      function add(set) {
        if (!set.length || set.length > 4) return;
        var key = set.map(function (rule) { return cleanText(rule.code); }).sort().join('+');
        if (!key || seen[key]) return;
        seen[key] = true;
        out.push(set.slice());
      }

      function walk(start, chosen) {
        if (chosen.length) add(chosen);
        if (chosen.length >= 4) return;
        for (var i = start; i < approved.length; i += 1) {
          if (!rulesCompatible(chosen, approved[i])) continue;
          chosen.push(approved[i]);
          walk(i + 1, chosen);
          chosen.pop();
        }
      }

      walk(0, []);
      return out;
    }

    function applyApprovedRules(baseMeal, rules) {
      var meal = clone(baseMeal);
      var allCodes = [];
      var allLabels = [];
      var customerNotes = [];
      var kitchenNotes = [];

      rules.forEach(function (rule) {
        allCodes.push(rule.code);
        if (rule.label) allLabels.push(rule.label);

        meal.name = replaceAllApproved(meal.name, rule.replacements);
        meal.displayName = replaceAllApproved(meal.displayName || meal.name, rule.replacements);
        meal.description = replaceAllApproved(meal.description, rule.replacements);
        meal.customerDescription = replaceAllApproved(meal.customerDescription, rule.replacements);
        meal.ingredients = list(meal.ingredients).map(function (value) {
          return replaceAllApproved(value, rule.replacements);
        });
        meal.allergens = list(meal.allergens).map(function (value) {
          return replaceAllApproved(value, rule.replacements);
        });

        if (rule.displayName) {
          meal.displayName = replaceAllApproved(rule.displayName, rule.replacements);
          meal.name = meal.displayName;
        }
        if (rule.customerDescription) {
          meal.customerDescription = replaceAllApproved(rule.customerDescription, rule.replacements);
        }

        meal.ingredients = removeListed(meal.ingredients, rule.removeIngredients);
        meal.ingredients = addUniqueValues(meal.ingredients, rule.addIngredients);
        meal.allergens = removeListed(meal.allergens, rule.removeAllergens);
        meal.allergens = addUniqueValues(meal.allergens, rule.addAllergens);
        meal.diet = addUniqueValues(meal.diet, rule.dietAdd);
        meal.supportTags = addUniqueValues(meal.supportTags, rule.supportAdd);

        if (rule.customerNote) customerNotes.push(rule.customerNote);
        if (rule.kitchenInstruction) kitchenNotes.push(rule.kitchenInstruction);
      });

      var codeKey = allCodes.map(cleanText).filter(Boolean).join('-');
      meal.id = String(baseMeal.id || baseMeal.handle || mealFamilyKey(baseMeal) || 'meal') + '::' + codeKey;
      meal.handle = String(baseMeal.handle || cleanText(baseMeal.name).replace(/\s+/g, '-')) + '--' + codeKey;
      meal.baseMealKey = mealFamilyKey(baseMeal);
      meal.versionCode = allCodes.join('+');
      meal.versionLabel = allLabels.join(' · ');
      meal.adaptationNote = customerNotes.join(' ');
      meal.kitchenInstruction = kitchenNotes.join(' | ');
      meal.adapted = true;
      meal.variantApproved = true;
      meal.safetyReviewed = true;
      meal.generatedVariant = true;
      meal.sourceMealId = baseMeal.id;
      return meal;
    }

    function expandApprovedMealVariants(baseMeals) {
      var out = [];
      baseMeals.forEach(function (meal) {
        out.push(meal);

        var rules = parseAdaptationRules(meal).map(normaliseVariantRule);
        if (!rules.length) return;

        variantRuleSets(rules).forEach(function (set) {
          var variant = applyApprovedRules(meal, set);
          if (variant && variant.name) out.push(variant);
        });
      });
      return out;
    }

    function parseLibrary() {
      // Shopify's Active/Draft status is the publication gate. The separate
      // available_this_week checkbox is retained for diagnostics only because
      // the 140-row import did not include that field. Weekly Menu is used as
      // a ranking preference rather than a destructive catalogue filter.
      var baseMeals = rawLibrary().filter(function (meal) {
        return meal.name && meal.active;
      });

      // Family variants are derived only from explicit, kitchen-approved,
      // safety-reviewed adaptation rules stored on the base Food Library meal.
      // No rule = no generated version.
      return expandApprovedMealVariants(baseMeals);
    }

    function libraryDiagnostics() {
      var raw = rawLibrary();
      var named = raw.filter(function (meal) { return Boolean(meal.name); });
      var active = named.filter(function (meal) { return meal.active; });
      var weekly = active.filter(function (meal) { return meal.weeklySelected; });
      var flaggedAvailable = active.filter(function (meal) { return meal.availableFlag; });

      return {
        configuredHandle: String(config.libraryHandle || ''),
        sourceUsed: String(libraryNode.dataset.amiLibrarySource || config.librarySource || ''),
        weeklyMenuLookup: String(libraryNode.dataset.amiWeeklyMenuLookup || ''),
        weekStarting: String(libraryNode.dataset.amiWeekStarting || ''),
        liquidEntryCount: Number(libraryNode.dataset.amiLibraryCount || config.libraryEntryCount || 0),
        weeklyEntryCount: Number(libraryNode.dataset.amiWeeklyEntryCount || 0),
        foodLibraryEntryCount: Number(libraryNode.dataset.amiFoodLibraryEntryCount || 0),
        rawJsonEntries: raw.length,
        namedEntries: named.length,
        activeEntries: active.length,
        expandedEntries: parseLibrary().length,
        approvedGeneratedVariants: parseLibrary().filter(function (meal) { return Boolean(meal.generatedVariant); }).length,
        themeVariantFamilies: Object.keys(window.FlayvrAmiMealVariants || {}).length,
        themeVariantApprovals: Object.keys(window.FlayvrAmiVariantApprovals || {}).filter(function (key) { return window.FlayvrAmiVariantApprovals[key] === true; }).length,
        weeklySelectedEntries: weekly.length,
        availableFlagTrueEntries: flaggedAvailable.length,
        availableFlagFalseEntries: Math.max(0, active.length - flaggedAvailable.length),
        resolvedMealTypes: active.reduce(function (counts, meal) {
          var resolved = explicitMealType(meal) || inferredMealType(meal);
          counts[resolved] = (counts[resolved] || 0) + 1;
          return counts;
        }, {})
      };
    }

    function mealTypeText(meal) {
      return cleanText(meal.mealType.concat([meal.name, meal.description]).join(' '));
    }

    function explicitMealType(meal) {
      var values = lower(meal.mealType).map(cleanText).filter(Boolean);
      var joined = values.join(' ');

      if (values.indexOf('b') >= 0 || /\bbreakfast\b/.test(joined)) return 'Breakfast';
      if (values.indexOf('l') >= 0 || /\blunch\b/.test(joined)) return 'Lunch';
      if (values.indexOf('d') >= 0 || /\bdinner\b/.test(joined)) return 'Dinner';
      if (values.indexOf('s') >= 0 || /\b(snack|side)\b/.test(joined)) return 'Snack';
      if (values.indexOf('m') >= 0 || /\b(main|meal)\b/.test(joined)) return 'Main';

      // Unknown imported codes are not used as hard exclusions.
      return '';
    }

    function inferredMealType(meal) {
      var text = mealTypeText(meal);

      if (/\b(breakfast|overnight oats|porridge|granola)\b/.test(text)) return 'Breakfast';

      if (/\b(snack|snack pot|protein pot|bites|cups|roll ups|roll-ups)\b/.test(text)) {
        return 'Snack';
      }

      if (/\b(soup|salad|bowl|wrap)\b/.test(text)) return 'Main';

      return 'Main';
    }

    function typeOf(meal) {
      var explicit = explicitMealType(meal);
      var inferred = inferredMealType(meal);
      var resolved = explicit || inferred;

      if (resolved === 'Breakfast') return 'Breakfast';
      if (resolved === 'Snack') return 'Snack';
      if (resolved === 'Lunch') return 'Lunch';
      if (resolved === 'Dinner') return 'Dinner';

      return 'Dinner';
    }

    function supportsSlot(meal, slot) {
      var explicit = explicitMealType(meal);
      var inferred = inferredMealType(meal);
      var resolved = explicit || inferred;

      if (resolved === 'Breakfast') return slot === 'Breakfast';
      if (resolved === 'Snack') return slot === 'Snack';
      if (resolved === 'Lunch') return slot === 'Lunch';
      if (resolved === 'Dinner') return slot === 'Dinner';

      // Generic mains can be placed at lunch or dinner.
      return slot === 'Lunch' || slot === 'Dinner';
    }

    function planAllows(meal) {
      var plans = list(meal.plan).map(function (value) {
        return value.replace(/[^0-9]/g, '');
      }).filter(Boolean);
      return !plans.length || plans.indexOf(String(state.coverage)) >= 0;
    }

    function exactTag(meal, patterns) {
      var tags = lower(meal.diet.concat(meal.supportTags)).map(cleanText).filter(function (tag) {
        return tag && !/^(non|not|contains)\s+/.test(tag);
      });

      return patterns.some(function (pattern) {
        var wanted = cleanText(pattern);
        return tags.some(function (tag) {
          return tag === wanted || tag.indexOf(wanted + ' ') === 0 || tag.endsWith(' ' + wanted) || tag.indexOf(' ' + wanted + ' ') >= 0;
        });
      });
    }

    function conflictText(meal) {
      return cleanText([
        meal.name,
        meal.description,
        meal.ingredients.join(' '),
        meal.allergens.join(' ')
      ].join(' '))
        .replace(/\b(vegan|plant based|meat free) (chicken|turkey|beef|lamb|pork|duck|fish|salmon|cod|prawn|shrimp|tuna|crab|lobster|sausage|sausages|bacon|ham|meat|meatball|meatballs|kofta|keema|cheese|milk|cream|butter|yogurt|yoghurt)\b/g, 'plant ingredient')
        .replace(/\b(coconut|oat|almond|soy|soya|cashew|rice|pea) (milk|cream|yogurt|yoghurt)\b/g, 'plant ingredient')
        .replace(/\bdairy free (cheese|milk|cream|butter|yogurt|yoghurt)\b/g, 'plant ingredient')
        .replace(/\bbutter beans?\b/g, 'plant ingredient');
    }

    function hasLandMeat(meal) {
      return /\b(chicken|turkey|beef|lamb|pork|bacon|ham|duck|goat|venison|chorizo|sausage|sausages|meat|meatball|meatballs|kofta|keema)\b/.test(conflictText(meal));
    }

    function hasSeafood(meal) {
      return /\b(fish|salmon|cod|haddock|prawn|prawns|shrimp|shrimps|tuna|crab|lobster|mussel|mussels|clam|clams|anchovy|anchovies|sardine|sardines|mackerel|trout|seafood)\b/.test(conflictText(meal));
    }

    function hasAnimalProducts(meal) {
      return hasLandMeat(meal) || hasSeafood(meal) || /\b(egg|eggs|honey|cheese|cheddar|feta|halloumi|mozzarella|parmesan|ricotta|paneer|milk|cream|butter|ghee|yogurt|yoghurt|whey|casein|gelatin|gelatine)\b/.test(conflictText(meal));
    }

    function matchesDiet(meal) {
      var selected = lower(state.diet).filter(function (value) {
        return ['no restrictions', 'none'].indexOf(value) < 0;
      });

      /* "Vegan + pescatarian" is treated as plant-based with seafood allowed,
         not as an impossible literal intersection. Land meat and non-seafood
         animal products remain excluded. */
      var veganPesc = selected.indexOf('vegan') >= 0 && selected.indexOf('pescatarian') >= 0;
      if (veganPesc) {
        var text = conflictText(meal);
        var hasNonSeafoodAnimal =
          hasLandMeat(meal) ||
          /\b(egg|eggs|honey|cheese|cheddar|feta|halloumi|mozzarella|parmesan|ricotta|paneer|milk|cream|butter|ghee|yogurt|yoghurt|whey|casein|gelatin|gelatine)\b/.test(text);
        var compatible = exactTag(meal, [
          'Pescatarian', 'Pescatarian-compatible', 'Fish', 'Seafood',
          'Vegetarian', 'Vegan', 'VG', 'Plant based'
        ]);
        if (!compatible || hasNonSeafoodAnimal) return false;
        selected = selected.filter(function (diet) {
          return diet !== 'vegan' && diet !== 'pescatarian';
        });
      }

      return selected.every(function (diet) {
        if (diet === 'vegan') {
          return exactTag(meal, ['Vegan', 'VG', 'Plant based']) && !hasAnimalProducts(meal);
        }
        if (diet === 'vegetarian') {
          return exactTag(meal, ['Vegetarian', 'Vegan', 'VG', 'Plant based']) && !hasLandMeat(meal) && !hasSeafood(meal);
        }
        if (diet === 'pescatarian') {
          return exactTag(meal, ['Pescatarian', 'Pescatarian-compatible', 'Fish', 'Seafood', 'Vegetarian', 'Vegan', 'VG']) && !hasLandMeat(meal);
        }
        if (diet === 'gluten-free' || diet === 'gluten free') {
          return exactTag(meal, ['Gluten-free', 'Gluten free', 'GF']);
        }
        if (diet === 'dairy-free' || diet === 'dairy free') {
          return exactTag(meal, ['Dairy-free', 'Dairy free', 'DF', 'Vegan', 'VG']);
        }
        return exactTag(meal, [diet]);
      });
    }

    function mealSafetyText(meal) {
      return cleanText([
        meal && meal.name,
        meal && meal.description,
        meal && meal.ingredients ? meal.ingredients.join(' ') : '',
        meal && meal.allergens ? meal.allergens.join(' ') : ''
      ].join(' '));
    }

    function allergyTokenMatches(allergy, text) {
      allergy = cleanText(allergy);
      text = cleanText(text);
      if (!allergy || allergy === 'none') return false;

      if (allergy === 'gluten') {
        return /\b(gluten|wheat|barley|rye|spelt|semolina|couscous)\b/.test(text);
      }
      if (allergy === 'dairy' || allergy === 'milk') {
        return /\b(dairy|milk|cheese|butter|cream|whey|casein|yoghurt|yogurt)\b/.test(text);
      }
      if (allergy === 'eggs' || allergy === 'egg') return /\beggs?\b/.test(text);
      if (allergy === 'peanuts' || allergy === 'peanut') return /\bpeanuts?\b/.test(text);
      if (allergy === 'tree nuts' || allergy === 'tree nut') {
        return /\b(almond|cashew|walnut|pistachio|hazelnut|pecan|macadamia|brazil nut|tree nut)\b/.test(text);
      }
      if (allergy === 'sesame') return /\b(sesame|tahini)\b/.test(text);
      if (allergy === 'soya' || allergy === 'soy') return /\b(soya|soy|tofu|edamame|miso|tempeh)\b/.test(text);
      if (allergy === 'fish') return /\b(fish|salmon|tuna|cod|haddock|mackerel|anchovy|anchovies|sardine|sardines|trout|sea bass|seabass)\b/.test(text);
      if (allergy === 'shellfish') return /\b(shellfish|prawn|prawns|shrimp|crab|lobster|mussel|mussels|clam|clams|oyster|oysters|scallop|scallops|crayfish)\b/.test(text);
      if (allergy === 'nuts' || allergy === 'nut') {
        return /\b(nut|nuts|peanut|almond|cashew|walnut|pistachio|hazelnut|pecan|macadamia)\b/.test(text);
      }

      return text.indexOf(allergy) >= 0;
    }

    function parseChefNotes(text) {
      var raw = String(text || '').trim();
      var normal = cleanText(raw);
      var hard = [];
      var soft = [];
      if (!normal) return { raw: '', hard: hard, soft: soft };

      var segments = raw.toLowerCase().split(/[.!?;\n]+/).map(function (part) {
        return cleanText(part);
      }).filter(Boolean);

      var major = [
        { label: 'Gluten', re: /\b(gluten|wheat|barley|rye|spelt|semolina|couscous)\b/ },
        { label: 'Dairy', re: /\b(dairy|milk|cheese|butter|cream|whey|casein|yoghurt|yogurt)\b/ },
        { label: 'Eggs', re: /\beggs?\b/ },
        { label: 'Peanuts', re: /\bpeanuts?\b/ },
        { label: 'Tree nuts', re: /\b(tree nuts?|almond|cashew|walnut|pistachio|hazelnut|pecan|macadamia|brazil nut)\b/ },
        { label: 'Sesame', re: /\b(sesame|tahini)\b/ },
        { label: 'Soya', re: /\b(soya|soy|tofu|edamame|miso|tempeh)\b/ },
        { label: 'Fish', re: /\b(fish|salmon|tuna|cod|haddock|mackerel|anchovy|sardine|trout|sea ?bass)\b/ },
        { label: 'Shellfish', re: /\b(shellfish|prawn|shrimp|crab|lobster|mussel|clam|oyster|scallop|crayfish)\b/ }
      ];

      major.forEach(function (item) {
        segments.forEach(function (segment) {
          if (!item.re.test(segment)) return;
          if (new RegExp(item.re.source + '[^ ]{0,2}\\s*(?:is|are)?\\s*(?:fine|okay|ok|allowed)|(?:fine|okay|ok)\\s+with[^.]{0,16}' + item.re.source, 'i').test(segment)) return;
          var exclusion = /\b(no|without|avoid|allerg(?:y|ic)|intoleran(?:ce|t)|severe|must avoid|cannot have|can't have|do not use|keep .* out)\b/.test(segment);
          if (exclusion) hard.push(item.label);
        });
      });

      if (/\bno nuts?\b|\bnut[- ]?free\b/.test(normal)) hard = hard.concat(['Peanuts', 'Tree nuts']);

      var softPatterns = [
        ['Mushrooms', /\bmushrooms?\b/], ['Aubergine', /\b(aubergine|eggplant)\b/],
        ['Olives', /\bolives?\b/], ['Coriander', /\b(coriander|cilantro)\b/],
        ['Coconut', /\bcoconut\b/], ['Very rich dishes', /\b(rich|heavy|creamy|lighter sauces?|light sauces?)\b/]
      ];
      softPatterns.forEach(function (item) {
        segments.forEach(function (segment) {
          if (!item[1].test(segment)) return;
          if (/\b(allerg(?:y|ic)|intoleran(?:ce|t)|severe)\b/.test(segment)) hard.push(item[0]);
          else if (/\b(no|avoid|without|leave out|keep .* out|don't|do not|prefer|lighter)\b/.test(segment)) soft.push(item[0]);
        });
      });

      function unique(values) {
        var seen = Object.create(null);
        return values.filter(function (value) { var k = cleanText(value); if (!k || seen[k]) return false; seen[k] = true; return true; });
      }
      return { raw: raw, hard: unique(hard), soft: unique(soft) };
    }

    function effectiveHardRules() {
      var hardRules = list(state.allergies);
      if (state.legacyHardAvoids) hardRules = hardRules.concat(list(state.legacyHardAvoids));
      hardRules = hardRules.concat(parseChefNotes(state.chefNotes).hard);
      return hardRules;
    }

    function effectiveDislikes() {
      return list(state.dislikes).concat(parseChefNotes(state.chefNotes).soft);
    }

    function matchesAllergies(meal) {
      var hardRules = effectiveHardRules();
      if (!hardRules.length) return true;

      var text = mealSafetyText(meal);
      return !hardRules.some(function (allergy) {
        return allergyTokenMatches(allergy, text);
      });
    }

    function dislikePenalty(meal) {
      var dislikes = lower(effectiveDislikes()).filter(function (value) {
        return ['none', 'nothing', 'nothing in particular'].indexOf(value) < 0;
      });
      if (!dislikes.length) return 0;

      var text = mealSafetyText(meal);
      var penalty = 0;

      dislikes.forEach(function (dislike) {
        var hit = false;

        if (dislike === 'mushrooms') hit = /\bmushroom(s)?\b/.test(text);
        else if (dislike === 'aubergine') hit = /\b(aubergine|eggplant)\b/.test(text);
        else if (dislike === 'olives') hit = /\bolive(s)?\b/.test(text);
        else if (dislike === 'coriander') hit = /\b(coriander|cilantro)\b/.test(text);
        else if (dislike === 'coconut') hit = /\bcoconut\b/.test(text);
        else if (dislike === 'sweet-forward dishes') {
          hit = Number(meal && meal.tasteSweet || 0) >= 60 || /\b(sweet|honey|maple|caramel|dessert)\b/.test(text);
        } else if (dislike === 'very rich dishes') {
          hit = (Number(meal && meal.calories || 0) >= 700) || /\b(rich|creamy|buttery|cream|cheese-heavy)\b/.test(text);
        } else {
          hit = text.indexOf(dislike) >= 0;
        }

        if (hit) penalty += 85;
      });

      return Math.min(220, penalty);
    }

    function mealFamilyKey(meal) {
      return cleanText(meal && (meal.baseMealKey || meal.handle || meal.name) || '');
    }

    function displayMealName(meal) {
      return String(meal && (meal.displayName || meal.name) || '').trim();
    }

    function configurationAllowed(meal) {
      return !meal || !meal.adapted || meal.variantApproved === true;
    }

    function safeFamilyCandidatesFor(slot, library) {
      var seen = new Set();
      return safeCandidatesFor(slot, library).filter(function (meal) {
        var key = mealFamilyKey(meal);
        if (!key || seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    }

    function exactMealTag(meal, values) {
      return exactTag(meal, values);
    }

    function mealBadges(meal) {
      var out = [];
      if (!meal) return out;
      if (meal.adapted && meal.versionLabel) out.push({ label: meal.versionLabel, kind: 'version' });
      if (exactMealTag(meal, ['Vegan', 'VG', 'Plant based'])) out.push({ label: 'VG', kind: 'diet' });
      else if (exactMealTag(meal, ['Vegetarian'])) out.push({ label: 'V', kind: 'diet' });
      if (exactMealTag(meal, ['Gluten-free', 'Gluten free', 'GF'])) out.push({ label: 'GF', kind: 'diet' });
      if (exactMealTag(meal, ['Dairy-free', 'Dairy free', 'DF'])) out.push({ label: 'DF', kind: 'diet' });
      if (exactMealTag(meal, ['High protein', 'High-protein', 'HP']) || (meal.safetyReviewed && meal.protein >= 30)) out.push({ label: 'HP', kind: 'goal' });
      if (exactMealTag(meal, ['Gut friendly', 'Gut-friendly', 'Gut+', 'Fibre', 'Fiber', 'Fermented'])) out.push({ label: 'Gut+', kind: 'support' });
      if (exactMealTag(meal, ['Light', 'Lighter eating', 'Lighter'])) out.push({ label: 'Light', kind: 'support' });
      var seen = new Set();
      return out.filter(function (item) {
        if (seen.has(item.label)) return false;
        seen.add(item.label);
        return true;
      }).slice(0, 6);
    }

    function tasteDimensionLabel(key) {
      return ({ adv: 'adventure', heat: 'heat', intensity: 'intensity', acid: 'acidity', texture: 'texture', sweet: 'sweetness' })[key] || key;
    }

    function tasteDimensionDisplay(key) {
      return ({ adv: 'Adventure', heat: 'Heat', intensity: 'Intensity', acid: 'Acid', texture: 'Texture', sweet: 'Sweet' })[key] || key;
    }

    function tasteRankedSignals(profile) {
      if (!profile) return [];
      return TASTE_DIMENSIONS.map(function (key) {
        return { key: key, value: Number(profile[key] || 0) };
      }).sort(function (a, b) { return b.value - a.value; });
    }

    function tasteProfileDisplayName(profile) {
      var name = String(profile && profile.name || '').trim();
      if (!name || cleanText(name) === 'taste profile' || cleanText(name) === 'imported taste test') return 'Taste Profile';
      return name;
    }

    function tasteRadarPoint(profile, key, endpoint) {
      var cx = 95, cy = 95;
      var score = Math.max(0, Math.min(100, Number(profile && profile[key] || 0))) / 100;
      return (cx + (endpoint[0] - cx) * score).toFixed(1) + ',' + (cy + (endpoint[1] - cy) * score).toFixed(1);
    }

    function tasteRadarSvg(profile) {
      var endpoints = {
        adv: [95, 18], heat: [162, 57], intensity: [162, 133],
        acid: [95, 171], texture: [28, 133], sweet: [28, 57]
      };
      var order = ['adv','heat','intensity','acid','texture','sweet'];
      var points = order.map(function (key) { return tasteRadarPoint(profile, key, endpoints[key]); }).join(' ');
      var dots = order.map(function (key) {
        var xy = tasteRadarPoint(profile, key, endpoints[key]).split(',');
        return '<circle class="flami-taste-radar__dot" cx="' + xy[0] + '" cy="' + xy[1] + '" r="2.8"></circle>';
      }).join('');
      return '<svg class="flami-taste-radar" viewBox="0 0 190 180" role="img" aria-label="Taste Profile radar chart">' +
        '<polygon class="flami-taste-radar__grid" points="95,18 162,57 162,133 95,171 28,133 28,57"></polygon>' +
        '<polygon class="flami-taste-radar__grid" points="95,40 143,68 143,122 95,150 47,122 47,68"></polygon>' +
        '<polygon class="flami-taste-radar__grid" points="95,62 124,79 124,111 95,128 66,111 66,79"></polygon>' +
        '<line class="flami-taste-radar__axis" x1="95" y1="95" x2="95" y2="18"></line>' +
        '<line class="flami-taste-radar__axis" x1="95" y1="95" x2="162" y2="57"></line>' +
        '<line class="flami-taste-radar__axis" x1="95" y1="95" x2="162" y2="133"></line>' +
        '<line class="flami-taste-radar__axis" x1="95" y1="95" x2="95" y2="171"></line>' +
        '<line class="flami-taste-radar__axis" x1="95" y1="95" x2="28" y2="133"></line>' +
        '<line class="flami-taste-radar__axis" x1="95" y1="95" x2="28" y2="57"></line>' +
        '<text class="flami-taste-radar__label" x="95" y="9" text-anchor="middle">Adventure</text>' +
        '<text class="flami-taste-radar__label" x="172" y="55">Heat</text>' +
        '<text class="flami-taste-radar__label" x="168" y="143">Intensity</text>' +
        '<text class="flami-taste-radar__label" x="95" y="179" text-anchor="middle">Acid</text>' +
        '<text class="flami-taste-radar__label" x="22" y="143" text-anchor="end">Texture</text>' +
        '<text class="flami-taste-radar__label" x="21" y="55" text-anchor="end">Sweet</text>' +
        '<polygon class="flami-taste-radar__shape" points="' + points + '"></polygon>' + dots + '</svg>';
    }

    function tasteMoveUpCopy(profile) {
      var ranked = tasteRankedSignals(profile);
      if (!ranked.length) return '';
      var action = {
        adv: 'unfamiliar dishes can move higher when the flavour payoff is clear',
        heat: 'confident chilli and spice get a positive lift',
        intensity: 'bolder savoury dishes move up the list',
        acid: 'brighter, sharper finishes get more weight',
        texture: 'crunch, contrast and layered textures get a meaningful lift',
        sweet: 'sweet-led dishes can move higher when they fit the rest of your profile'
      };
      var copy = action[ranked[0].key] + '; ' + action[ranked[1].key] + '.';
      return copy.charAt(0).toUpperCase() + copy.slice(1);
    }

    function tasteApplicationCopy(profile) {
      var ranked = tasteRankedSignals(profile);
      if (!ranked.length) return '';
      var copy = tasteMoveUpCopy(profile);
      var low = ranked[ranked.length - 1];
      if (low.key === 'sweet' && low.value <= 35) copy += ' Sweet-forward meals move down unless they have enough savoury, acidic or textural contrast.';
      else if (low.value <= 35) copy += ' Ami will avoid over-indexing on ' + tasteDimensionLabel(low.key) + ' because it is one of your weaker signals.';
      return copy;
    }

    function tasteSignalExplanation(key) {
      return ({
        adv: 'Ami can move less familiar dishes higher when the flavour payoff still feels coherent.',
        heat: 'Confident chilli and spice are a positive signal, not something to mute.',
        intensity: 'Bolder savoury dishes get more weight when they still fit the rest of your week.',
        acid: 'Brighter, sharper finishes get more weight when a dish needs lift.',
        texture: 'Crunch, contrast and layered textures get a meaningful lift.',
        sweet: 'Sweet-led dishes move higher only when they fit the rest of your profile.'
      })[key] || '';
    }

    function tasteProfileCardHtml(profile, mode) {
      var ranked = tasteRankedSignals(profile);
      if (!ranked.length) return '';
      var strongest = ranked[0], second = ranked[1], third = ranked[2], lowest = ranked[ranked.length - 1];

      if (mode === 'review') {
        var lowCopy = 'Ami avoids over-indexing on ' + tasteDimensionLabel(lowest.key) + ' compared with your stronger signals.';
        if (lowest.key === 'sweet' && lowest.value <= 35) {
          lowCopy = 'sweet-forward meals without enough savoury, acidic or textural contrast. Sweetness scored just ' + Math.round(lowest.value) + '%.';
        }
        return '<div class="flami-taste-card flami-taste-card--review flami-taste-card--standard">' +
          '<div class="flami-taste-card__head"><div class="flami-taste-card__review-title"><i></i><div><h3>Your Taste Test shaped this week.</h3><p>These are the signals Ami used after checking your dietary rules and this week’s availability.</p></div></div>' +
          '<span class="flami-taste-card__profile">' + esc(tasteProfileDisplayName(profile)) + '</span></div>' +
          '<div class="flami-taste-standard-body"><div class="flami-taste-card__radar">' + tasteRadarSvg(profile) + '</div>' +
          '<div class="flami-taste-standard-stats">' +
            '<div><span>Strongest signal</span><strong>' + esc(tasteDimensionDisplay(strongest.key)) + ' · ' + Math.round(strongest.value) + '%</strong><p>' + esc(tasteSignalExplanation(strongest.key)) + '</p></div>' +
            '<div><span>' + esc(tasteDimensionDisplay(second.key)) + '</span><strong>' + Math.round(second.value) + '%</strong><p>' + esc(tasteSignalExplanation(second.key)) + '</p></div>' +
            '<div><span>' + esc(tasteDimensionDisplay(third.key)) + '</span><strong>' + Math.round(third.value) + '%</strong><p>' + esc(tasteSignalExplanation(third.key)) + '</p></div>' +
            '<div class="flami-taste-standard-rule"><strong>What moved down:</strong> ' + esc(lowCopy) + '</div>' +
          '</div></div></div>';
      }

      var rows = TASTE_DIMENSIONS.map(function (key) {
        var value = Math.round(Number(profile[key] || 0));
        return '<div class="flami-taste-signal flami-taste-signal--' + esc(key) + '">' +
          '<span>' + esc(tasteDimensionDisplay(key)) + '</span>' +
          '<i><b style="--taste-score:' + value + '%"></b></i>' +
          '<strong>' + value + '%</strong>' +
        '</div>';
      }).join('');
      return '<div class="flami-taste-card flami-taste-card--chat">' +
        '<div class="flami-taste-card__head"><div><div class="flami-taste-card__kicker"><i></i>Taste Test connected · 6 signals read</div>' +
          '<h3>Your Taste Profile, in action.</h3><p>Ami is now using these signals as ranking weights for this week’s menu.</p></div>' +
          '<span class="flami-taste-card__profile">' + esc(tasteProfileDisplayName(profile)) + '</span></div>' +
        '<div class="flami-taste-card__body"><div class="flami-taste-card__radar">' + tasteRadarSvg(profile) + '</div><div class="flami-taste-card__signals">' + rows + '</div></div>' +
        '<div class="flami-taste-card__insights">' +
          '<div><span>Strongest</span><strong>' + esc(tasteDimensionDisplay(strongest.key)) + ' · ' + Math.round(strongest.value) + '%</strong></div>' +
          '<div><span>Also high</span><strong>' + esc(tasteDimensionDisplay(second.key)) + ' · ' + Math.round(second.value) + '% + ' + esc(tasteDimensionDisplay(third.key)) + ' · ' + Math.round(third.value) + '%</strong></div>' +
          '<div><span>Pull back</span><strong>' + esc(tasteDimensionDisplay(lowest.key)) + ' · ' + Math.round(lowest.value) + '%</strong></div>' +
        '</div>' +
        '<div class="flami-taste-card__apply"><strong>What Ami is changing:</strong> ' + esc(tasteApplicationCopy(profile)) + '</div>' +
      '</div>';
    }

    function renderTasteAnalysisCard(profile) {
      if (!chat || !profile) return null;
      var old = chat.querySelector('[data-ami-taste-analysis]');
      if (old) old.remove();
      var row = document.createElement('div');
      row.className = 'flami-msg flami-msg--ami flami-msg--taste-analysis';
      row.setAttribute('data-ami-taste-analysis', '');
      row.innerHTML = tasteProfileCardHtml(profile, 'chat');
      chat.appendChild(row);
      window.requestAnimationFrame(function () {
        var card = row.querySelector('.flami-taste-card');
        if (card) card.classList.add('is-visible');
      });
      scrollConversationToLatest();
      return row;
    }

    function tasteReasonForMeal(meal) {
      var context = readTasteProfileContext(state.name);
      var vector = mealTasteVector(meal);
      if (!context || !vector) return null;
      var profile = context.currentProfile;
      var ranked = TASTE_DIMENSIONS.map(function (key) {
        var diff = Math.abs(Number(profile[key]) - Number(vector[key]));
        return { key: key, diff: diff, score: Number(profile[key]) };
      }).sort(function (a, b) {
        var aValue = a.score - a.diff * 1.15;
        var bValue = b.score - b.diff * 1.15;
        return bValue - aValue || a.diff - b.diff;
      });
      var chosen = ranked.filter(function (item) { return item.score >= 55 && item.diff <= 30; }).slice(0, 2);
      if (!chosen.length) chosen = ranked.slice(0, 1);
      var phrases = {
        adv: 'gives you the discovery and unfamiliarity your Adventure score points toward',
        heat: 'sits comfortably inside the confident heat range your profile favours',
        intensity: 'brings the savoury intensity your profile responds to',
        acid: 'keeps enough brightness in the finish to suit your Acid preference',
        texture: 'brings the crunch, contrast or layered texture your profile responds to',
        sweet: 'uses sweetness in a way that still fits the rest of your profile'
      };
      var text = chosen.map(function (item) { return phrases[item.key]; }).join(' and ');
      if (Number(profile.sweet) <= 35 && Number(vector.sweet) <= 45) text += (text ? ', while it ' : 'It ') + 'keeps sweetness in the background';
      if (!text) return null;
      text = text.charAt(0).toUpperCase() + text.slice(1) + '.';
      return {
        text: text,
        chips: chosen.map(function (item) { return tasteDimensionDisplay(item.key) + ' ' + Math.round(item.score) + '%'; })
      };
    }

    function renderReviewTastePanel() {
      if (!review) return;
      var old = review.querySelector('[data-ami-review-taste]');
      var context = tasteEnhancementContext(state.name);
      if (!context) {
        if (old) old.remove();
        return;
      }
      var panel = old || document.createElement('section');
      panel.setAttribute('data-ami-review-taste', '');
      panel.className = 'flami-review-taste';
      panel.innerHTML = tasteProfileCardHtml(context.currentProfile, 'review');
      if (!old) {
        var host = review.querySelector('[data-ami-review-taste-host]');
        if (host) host.appendChild(panel);
        else { var summary = review.querySelector('.flami-plan-summary'); if (summary && summary.parentNode) summary.parentNode.insertBefore(panel, summary.nextSibling); }
        if (!panel.parentNode) { if (menuGroups && menuGroups.parentNode) menuGroups.parentNode.insertBefore(panel, menuGroups); else review.appendChild(panel); }
      }
      window.requestAnimationFrame(function () {
        var card = panel.querySelector('.flami-taste-card');
        if (card) card.classList.add('is-visible');
      });
    }

    function renderReviewTasteSummary() {
      if (!review) return;
      var old = review.querySelector('[data-ami-taste-week-summary]');
      var context = tasteEnhancementContext(state.name);
      if (!context) {
        if (old) old.remove();
        return;
      }
      var profile = context.currentProfile;
      var ranked = tasteRankedSignals(profile);
      var strongest = ranked.slice(0, 3).map(function (item) { return tasteDimensionDisplay(item.key).toLowerCase(); });
      var lowest = ranked[ranked.length - 1];
      var section = old || document.createElement('section');
      section.setAttribute('data-ami-taste-week-summary', '');
      section.className = 'flami-taste-week-summary';
      section.innerHTML =
        '<div class="flami-taste-week-summary__main"><small>Why this week works</small><h3>Ami didn’t just choose the highest-scoring dishes.</h3>' +
        '<p>Your Taste Test is a ranking signal, not a command to make every meal taste the same. Ami kept ' + esc(strongest.join(', ')) + ' visible, then varied cuisine, heat and meal shape so the week still feels planned rather than repetitive.</p>' +
        '<dl><div><dt>Moved up</dt><dd>' + esc(tasteMoveUpCopy(profile)) + '</dd></div><div><dt>Moved down</dt><dd>Ami avoids over-indexing on ' + esc(tasteDimensionLabel(lowest.key)) + ' compared with your stronger signals.</dd></div><div><dt>Balanced</dt><dd>At least one calmer meal can stay in the week when it creates useful contrast without losing your core profile.</dd></div></dl></div>' +
        '<div class="flami-taste-week-summary__safety"><small>Food profile</small><h3>Taste never overrides safety.</h3><p>Dietary requirements, allergies, dislikes and availability are checked first. Taste Test scores only help Ami rank the meals that are already suitable for you.</p></div>';
      if (!old) {
        var summaryHost = review.querySelector('[data-ami-results-summary-host]');
        if (summaryHost) { summaryHost.appendChild(section); return; }
        var notes = review.querySelector('[data-ami-chef-notes-host]');
        if (notes && notes.parentNode) notes.parentNode.insertBefore(section, notes);
        else {
          var actions = review.querySelector('.flami-review-actions');
          if (actions && actions.parentNode) actions.parentNode.insertBefore(section, actions);
          else review.appendChild(section);
        }
      }
    }

    function customerBuildExplanation(meal) {
      if (!meal) return '';
      var stage = meal.buildStage || buildStageForMeal(meal);
      if (stage === 'TRANSFORM') {
        return 'Ami adapted this one. ' + (meal.adaptationNote || 'The original idea still holds, just reshaped around your brief.');
      }
      if (stage === 'CUSTOM_BUILD') {
        return 'Ami built this around your brief. The closest standard version needed more than one approved change to fit you properly.';
      }
      if (stage === 'RESERVE') {
        return 'Ami brought this in because it gives your week more variety while still fitting your brief.';
      }
      return chefReasonForMeal(meal);
    }

    function chefReasonForMeal(meal) {
      if (!meal) return 'Ami chose this as one of the strongest safe fits for your week.';
      var context = readTasteProfileContext(state.name);
      var vector = mealTasteVector(meal);
      var pieces = [];
      if (context && vector) {
        var profile = context.currentProfile;
        var ranked = TASTE_DIMENSIONS.map(function (key) {
          return { key: key, diff: Math.abs(profile[key] - vector[key]), score: profile[key] };
        }).sort(function (a, b) {
          return a.diff - b.diff || b.score - a.score;
        });
        var first = ranked[0];
        var second = ranked[1];
        if (first && first.diff <= 24) pieces.push('lands close to your ' + tasteDimensionLabel(first.key) + ' preference');
        if (second && second.diff <= 20) pieces.push('also fits your ' + tasteDimensionLabel(second.key) + ' range');
        if (profile.sweet <= 35 && vector.sweet <= 45) pieces.push('keeps sweetness in the background');
      }
      var text = cleanText([meal.name, meal.description, meal.supportTags.join(' ')].join(' '));
      var mood = cleanText(state.mood || '');
      if (mood === 'feel lighter' && (/light|lighter|fresh|salad/.test(text) || (meal.calories > 0 && meal.calories < 560))) pieces.push('fits the lighter plate direction you chose this week');
      else if (mood === 'more comforting' && /comfort|warming|curry|dal|ragu|broth|stew/.test(text)) pieces.push('brings the comfort note you asked for this week');
      else if (mood === 'more energising' && (meal.protein >= 30 || /energy|quinoa|buckwheat|lentil|bean/.test(text))) pieces.push('supports the more energising direction you chose');
      else if (mood === 'keep it interesting' && Number(meal.tasteAdventure || 0) >= 70) pieces.push('turns the discovery dial up for this week');

      lower(state.goal).some(function (goal) {
        if (goal.indexOf('protein') >= 0 && (/high protein/.test(text) || (meal.safetyReviewed && meal.protein >= 30))) { pieces.push('supports the higher-protein week you asked for'); return true; }
        if (goal.indexOf('gut') >= 0 && /gut|fibre|fiber|fermented|miso|kimchi|lentil|bean/.test(text)) { pieces.push('adds one of the gut-supportive signals you asked Ami to favour'); return true; }
        if (goal.indexOf('lighter') >= 0 && /light|lighter|fresh/.test(text)) { pieces.push('keeps this part of the week lighter'); return true; }
        if (goal.indexOf('comfort') >= 0 && /comfort|warming|curry|dal|ragu|broth/.test(text)) { pieces.push('brings the comfort note you asked for'); return true; }
        return false;
      });
      if (!pieces.length) pieces.push('is one of the strongest safe matches after your food rules are applied');
      return pieces.slice(0, 2).join(' and ') + '.';
    }

    function chefWeekNote() {
      var context = readTasteProfileContext(state.name);
      var intro = 'I built this around your food rules first';
      if (context) {
        var profile = context.currentProfile;
        var strongest = TASTE_DIMENSIONS.slice().sort(function (a, b) { return profile[b] - profile[a]; }).slice(0, 2);
        intro += ', then leaned into your ' + tasteDimensionLabel(strongest[0]) + ' and ' + tasteDimensionLabel(strongest[1]) + ' preferences';
      }
      if (state.mood) intro += ', using "' + state.mood.toLowerCase() + '" as this week’s direction';
      if (state.goal.length) intro += ', while also prioritising ' + state.goal.join(' and ').toLowerCase();
      return intro + '. I kept the week varied without moving outside your food rules.';
    }

    function safeVariantsForMeal(item) {
      var library = parseLibrary();
      var family = mealFamilyKey(item);
      if (!family) return [];
      return library.filter(function (meal) {
        return mealFamilyKey(meal) === family &&
          configurationAllowed(meal) &&
          supportsSlot(meal, item.slot) &&
          planAllows(meal) &&
          matchesDiet(meal) &&
          matchesAllergies(meal) &&
          matchesTaste(meal);
      }).sort(function (a, b) {
        return scoreMeal(b) - scoreMeal(a) || displayMealName(a).localeCompare(displayMealName(b));
      });
    }

    function swapMenuMeal(menuIndex) {
      var current = state.menu[menuIndex];
      if (!current) return false;

      var library = parseLibrary();
      var currentFamily = mealFamilyKey(current);
      var familiesElsewhere = new Set();

      state.menu.forEach(function (item, index) {
        if (index === menuIndex) return;
        var family = mealFamilyKey(item);
        if (family) familiesElsewhere.add(family);
      });

      var candidates = safeFamilyCandidatesFor(current.slot, library).filter(function (meal) {
        return mealFamilyKey(meal) !== currentFamily;
      });

      // Prefer a genuinely new family for the week. If the weekly library is
      // too small, still allow another safe family already used elsewhere
      // rather than disabling Swap entirely.
      var source = candidates.find(function (meal) {
        return !familiesElsewhere.has(mealFamilyKey(meal));
      }) || candidates[0];

      if (!source) return false;
      return applyVariantToMenu(menuIndex, source);
    }

    function applyVariantToMenu(menuIndex, source) {
      var current = state.menu[menuIndex];
      if (!current || !source || !configurationAllowed(source)) return false;
      if (!supportsSlot(source, current.slot) || !planAllows(source) || !matchesDiet(source) || !matchesAllergies(source) || !matchesTaste(source)) return false;
      state.menu[menuIndex] = {
        id: source.id,
        handle: source.handle,
        slot: current.slot,
        day: current.day,
        name: source.name,
        displayName: displayMealName(source),
        description: annaDescriptionForMeal(source),
        calories: source.calories,
        protein: source.protein,
        fibre: source.fibre,
        diet: clone(source.diet),
        supportTags: clone(source.supportTags),
        baseMealKey: mealFamilyKey(source),
        versionCode: source.versionCode,
        versionLabel: source.versionLabel,
        adaptationNote: source.adaptationNote,
        kitchenInstruction: source.kitchenInstruction,
        adapted: source.adapted,
        variantApproved: source.variantApproved,
        tasteMatch: tasteMatchForMeal(source, state.name),
        repeated: current.repeated
      };
      save();
      renderMenu();
      return true;
    }

    function scoreMeal(meal) {
      var score = Number(meal.priority || 0) + (meal.weeklySelected ? 500 : 0);
      var text = cleanText([meal.name, meal.description, meal.supportTags.join(' ')].join(' '));
      var tasteItem = tasteItemForMeal(meal);
      var tasteRating = tasteItem && tasteItem.rating ? String(tasteItem.rating) : '';
      var learned = postPurchaseSignals();
      var ownFeedback = tasteItem && Array.isArray(tasteItem.feedback) ? tasteItem.feedback : [];

      if (tasteRating === 'loved') score += 140;
      if (tasteRating === 'fine') score += 8;
      if (workspaceSurpriseNames.has(cleanText(meal.name))) score -= 220;
      if (ownFeedback.indexOf('surprise-me') >= 0) score -= 70;

      // Phase 4.7: Taste Profile / Current Taste is a soft ranker only.
      // It never overrides diet, allergies, plan eligibility or Not again.
      // The current six-axis Taste profile is preferred when behavioural
      // learning exists; otherwise Ami uses the latest completed Test Profile.
      score += tasteRankBoost(meal, state.name);

      // Phase 4.4: post-purchase tuning is deliberately a soft ranker.
      // Dietary rules, allergies and Not again remain hard filters.
      if (learned['more-protein']) {
        if (/\b(high protein|high-protein|protein led|protein-led)\b/.test(text) || (meal.safetyReviewed && meal.protein >= 30)) score += Math.min(24, 8 + learned['more-protein'] * 4);
      }
      if (learned.lighter && /\b(light|lighter|fresh)\b/.test(text)) score += Math.min(20, 7 + learned.lighter * 4);
      if (learned['more-spice']) {
        if (meal.spiceLevel >= 3 || /\b(hot|spicy|fiery)\b/.test(text)) score += Math.min(14, 5 + learned['more-spice'] * 3);
      }
      if (learned['less-spice']) {
        if ((meal.spiceLevel > 0 && meal.spiceLevel <= 1) || /\b(mild|gentle)\b/.test(text)) score += Math.min(14, 5 + learned['less-spice'] * 3);
        if (meal.spiceLevel >= 3 || /\b(hot|fiery)\b/.test(text)) score -= 6;
      }

      /* Remembered dislikes are SOFT only: push down, never safety-filter. */
      score -= dislikePenalty(meal);

      /* Spice is a soft-to-medium preference. */
      var spicePreference = cleanText(state.spice || 'Medium');
      var mealHeat = Number(meal.spiceLevel || 0);
      if (spicePreference === 'extra hot') {
        if (mealHeat >= 4) score += 22;
        else if (mealHeat >= 3) score += 10;
        else if (mealHeat > 0 && mealHeat <= 1) score -= 10;
      } else if (spicePreference === 'hot') {
        if (mealHeat >= 3) score += 18;
        else if (mealHeat > 0 && mealHeat <= 1) score -= 6;
      } else {
        if (mealHeat > 0 && mealHeat <= 2) score += 12;
        if (mealHeat >= 4) score -= 12;
      }

      /* Mood -> plate lever is current-order only. */
      var mood = cleanText(state.mood || '');
      if (mood === 'keep me steady') {
        if ((meal.protein >= 25 && meal.fibre >= 6) || /\b(steady|quinoa|buckwheat|lentil|bean|wholegrain)\b/.test(text)) score += 18;
      } else if (mood === 'feel lighter') {
        if ((meal.calories > 0 && meal.calories < 560) || /\b(light|lighter|fresh|salad|greens)\b/.test(text)) score += 20;
        if (meal.calories >= 750) score -= 8;
      } else if (mood === 'more comforting') {
        if (/\b(comfort|warming|curry|dal|ragu|broth|stew|bake)\b/.test(text)) score += 20;
      } else if (mood === 'more energising') {
        if (meal.protein >= 30 || /\b(energy|energising|quinoa|buckwheat|bean|lentil)\b/.test(text)) score += 18;
      } else if (mood === 'keep it interesting') {
        if (Number(meal.tasteAdventure || 0) >= 70) score += 20;
        if (Number(meal.tasteIntensity || 0) >= 70) score += 8;
      } else if (mood === 'make life easy') {
        if (tasteRating === 'loved') score += 18;
        if (tasteRating === 'fine') score += 8;
        if (meal.weeklySelected) score += 8;
      }

      lower(state.goal).forEach(function (goal) {
        if (text.indexOf(goal) >= 0) score += 20;
        if (goal.indexOf('protein') >= 0 && (meal.protein >= 30 || /high protein/.test(text))) score += 18;
        if (goal.indexOf('gut') >= 0 && /gut|fibre|fiber|fermented|miso|kimchi|lentil|bean/.test(text)) score += 16;
        if (goal.indexOf('energy') >= 0 && /energy|steady|buckwheat|quinoa/.test(text)) score += 14;
        if (goal.indexOf('lighter') >= 0 && ((meal.calories > 0 && meal.calories < 560) || /lighter|fresh/.test(text))) score += 12;
        if (goal.indexOf('comfort') >= 0 && /comfort|warming|curry|dal|ragu|broth/.test(text)) score += 12;
      });

      return score;
    }

    function eligibilityDiagnostics(slot, library) {
      var catalogue = library || parseLibrary();
      var bySlot = catalogue.filter(function (meal) { return supportsSlot(meal, slot); });
      var byPlan = bySlot.filter(planAllows);
      var byDiet = byPlan.filter(matchesDiet);
      var byAllergies = byDiet.filter(matchesAllergies);
      var byTaste = byAllergies.filter(matchesTaste);

      return {
        slot: slot,
        catalogue: catalogue.length,
        supportsSlot: bySlot.length,
        allowsPlan: byPlan.length,
        matchesDiet: byDiet.length,
        matchesAllergies: byAllergies.length,
        matchesTaste: byTaste.length,
        selectedDiet: clone(state.diet),
        selectedCoverage: String(state.coverage),
        sampleDietTags: byPlan.slice(0, 12).map(function (meal) {
          return {
            name: meal.name,
            mealType: clone(meal.mealType),
            diet: clone(meal.diet),
            plan: clone(meal.plan),
            weeklySelected: meal.weeklySelected
          };
        })
      };
    }

    function safeCandidatesFor(slot, library) {
      return (library || parseLibrary()).filter(function (meal) {
        return configurationAllowed(meal) &&
          supportsSlot(meal, slot) &&
          planAllows(meal) &&
          matchesDiet(meal) &&
          matchesAllergies(meal) &&
          matchesTaste(meal);
      }).sort(function (a, b) {
        return scoreMeal(b) - scoreMeal(a) || a.name.localeCompare(b.name);
      });
    }

    function eligibleFor(slot, usedFamilies, library) {
      return safeFamilyCandidatesFor(slot, library).filter(function (meal) {
        return !usedFamilies.has(mealFamilyKey(meal));
      });
    }

    function shortageText(shortages) {
      return 'I can’t safely finish this week from the approved meals and versions I have right now. ' +
        shortages.map(function (item) {
          return item.slot.toLowerCase() + ': ' + item.available + ' safe option' + (item.available === 1 ? '' : 's');
        }).join('; ') +
        '. I’ve kept every hard food rule in place. Try changing one of the hard rules, or check again when the menu changes.';
    }

    function buildStageForMeal(meal) {
      var weekly = Boolean(meal && meal.weeklySelected);
      var adapted = Boolean(meal && meal.adapted);
      var transforms = String(meal && meal.versionCode || '').split('+').filter(Boolean).length;
      if (weekly && !adapted) return 'LIVE_MENU';
      if (weekly && adapted && transforms <= 1) return 'TRANSFORM';
      if (weekly && adapted) return 'CUSTOM_BUILD';
      if (!weekly && !adapted) return 'RESERVE';
      return transforms > 1 ? 'CUSTOM_BUILD' : 'RESERVE';
    }


    function fallbackRecordToMeal(record) {
      return {
        id: String(record.id || ''),
        handle: 'ami-fallback-' + String(record.id || '').replace(/[^a-z0-9-]+/gi, '-').toLowerCase(),
        name: String(record.name || '').trim(),
        description: String(record.short_description || '').trim(),
        customerDescription: String(record.short_description || '').trim(),
        image: '',
        diet: clone(record.diets || []),
        ingredients: clone(record.core_ingredients || []),
        allergens: clone(record.proposed_allergens || []),
        supportTags: clone(record.support_tags || []).concat(['archive fallback']),
        plan: [],
        mealType: [String(record.meal_type || '').replace(/^./, function (c) { return c.toUpperCase(); })],
        active: true,
        availableFlag: true,
        weeklySelected: false,
        priority: 38,
        calories: 0,
        protein: 0,
        fibre: 0,
        carbs: 0,
        fat: 0,
        chefSpecial: false,
        cuisine: String(record.cuisine || ''),
        spiceLevel: 0,
        tasteAdventure: 0,
        tasteHeat: 0,
        tasteIntensity: 0,
        tasteAcid: 0,
        tasteTexture: 0,
        tasteSweet: 0,
        displayName: String(record.name || '').trim(),
        baseMealKey: 'fallback-' + String(record.id || cleanText(record.name)),
        versionCode: '',
        versionLabel: '',
        adaptationNote: '',
        kitchenInstruction: '',
        adapted: false,
        variantApproved: true,
        safetyReviewed: true,
        archiveFallback: true,
        primaryFamily: String(record.primary_family || '')
      };
    }

    function fallbackCandidatesFor(slot) {
      var bucket = loadedFallbackBucket(fallbackBucketKey(state));
      if (!bucket || !bucket.slots) return [];
      return clone(bucket.slots[String(slot || '').toLowerCase()] || []).map(fallbackRecordToMeal).filter(function (meal) {
        return meal.name &&
          supportsSlot(meal, slot) &&
          matchesDiet(meal) &&
          matchesAllergies(meal) &&
          matchesTaste(meal);
      });
    }

    function chooseDiverseMeals(candidates, count, usedFamilies, usedIngredients) {
      var chosen = [];
      var remainder = candidates.filter(function (meal) {
        return !usedFamilies.has(mealFamilyKey(meal));
      });

      function family(meal) {
        return String(meal.primaryFamily || '').toLowerCase();
      }

      function familyCount(fam) {
        return fam ? Number(usedIngredients.get(fam) || 0) : 0;
      }

      function useFamily(fam) {
        if (fam) usedIngredients.set(fam, familyCount(fam) + 1);
      }

      /* First pass: prefer ingredient families not yet used this week. */
      remainder.forEach(function (meal) {
        if (chosen.length >= count) return;
        var fam = family(meal);
        if (fam && familyCount(fam) > 0) return;
        chosen.push(meal);
        useFamily(fam);
      });

      /* Second pass: permit one repeat before any family appears a third time. */
      remainder.forEach(function (meal) {
        if (chosen.length >= count || chosen.indexOf(meal) >= 0) return;
        var fam = family(meal);
        if (fam && familyCount(fam) >= 2) return;
        chosen.push(meal);
        useFamily(fam);
      });

      /* Final safety fill only when the eligible pool is genuinely narrow. */
      remainder.forEach(function (meal) {
        if (chosen.length >= count || chosen.indexOf(meal) >= 0) return;
        chosen.push(meal);
        useFamily(family(meal));
      });

      return chosen.slice(0, count);
    }

    function stagedSafeFamilyCandidates(slot, library) {
      var order = { LIVE_MENU: 0, TRANSFORM: 1, CUSTOM_BUILD: 2, RESERVE: 3 };
      var seen = new Set();
      var combined = safeCandidatesFor(slot, library);

      if (loadedFallbackBucket(fallbackBucketKey(state))) {
        combined = combined.concat(fallbackCandidatesFor(slot));
      }

      return combined.sort(function (a, b) {
        var sa = order[buildStageForMeal(a)], sb = order[buildStageForMeal(b)];
        if (sa !== sb) return sa - sb;
        return scoreMeal(b) - scoreMeal(a) || displayMealName(a).localeCompare(displayMealName(b));
      }).filter(function (meal) {
        var key = mealFamilyKey(meal);
        if (!key || seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    }

    function buildMenu(options) {
      options = options || {};
      var plan = coveragePlan();
      var nextMenu = [];
      var shortages = [];
      var usedFamilies = new Set();
      var usedIngredients = new Map();
      var diagnostics = libraryDiagnostics();
      var library = parseLibrary();
      var fullWeek = String(state.coverage) === '120';

      if (!library.length) {
        state.menu = [];
        save();
        root.classList.remove('is-reviewing');

        console.warn('[Flayvr Ami v27] Food library returned no usable storefront entries.', diagnostics);

        addMessage(
          'I can’t reach the current menu properly right now. Your answers are saved, so please try building the week again in a moment.',
          'ami'
        );
        status.textContent = '';
        return false;
      }

      Object.keys(plan.slots).forEach(function (slot) {
        var count = plan.slots[slot];
        var allSafeCandidates = stagedSafeFamilyCandidates(slot, library);
        var chosen = chooseDiverseMeals(allSafeCandidates, count, usedFamilies, usedIngredients);

        var minimumRepeatPool = fullWeek ? 3 : 2;
        if (chosen.length < count && allSafeCandidates.length >= minimumRepeatPool) {
          var repeatCursor = 0;
          while (chosen.length < count) {
            chosen.push(allSafeCandidates[repeatCursor % allSafeCandidates.length]);
            repeatCursor += 1;
          }
        }

        if (chosen.length < count) {
          shortages.push({
            slot: slot,
            available: allSafeCandidates.length,
            needed: minimumRepeatPool
          });
          return;
        }

        chosen.forEach(function (meal, index) {
          usedFamilies.add(mealFamilyKey(meal));
          nextMenu.push({
            id: meal.id,
            handle: meal.handle,
            slot: slot,
            day: index + 1,
            name: meal.name,
            displayName: displayMealName(meal),
            /* Anna copy is generated only after the final meal has been selected. */
            description: annaDescriptionForMeal(meal),
            calories: meal.calories,
            protein: meal.protein,
            fibre: meal.fibre,
            diet: clone(meal.diet),
            supportTags: clone(meal.supportTags),
            baseMealKey: mealFamilyKey(meal),
            versionCode: meal.versionCode,
            versionLabel: meal.versionLabel,
            adaptationNote: meal.adaptationNote,
            kitchenInstruction: meal.kitchenInstruction,
            adapted: meal.adapted,
            variantApproved: meal.variantApproved,
            tasteMatch: tasteMatchForMeal(meal, state.name),
            buildStage: buildStageForMeal(meal),
            archiveFallback: Boolean(meal.archiveFallback),
            primaryFamily: String(meal.primaryFamily || ''),
            repeated: chosen.slice(0, index).some(function (previous) {
              return mealFamilyKey(previous) === mealFamilyKey(meal);
            })
          });
        });
      });

      if (shortages.length && !loadedFallbackBucket(fallbackBucketKey(state)) && !fallbackBucketFailed[fallbackBucketKey(state)]) {
        status.textContent = 'Searching our chefs’ recipe archive…';
        ensureFallbackBucket(fallbackBucketKey(state), function (ok) {
          if (!ok) {
            status.textContent = '';
            addMessage(shortageText(shortages), 'ami');
            return;
          }
          yieldToBrowser(function () {
            status.textContent = 'Balancing the week…';
            yieldToBrowser(function () {
              buildMenu(options);
            });
          });
        });
        return false;
      }

      if (shortages.length) {
        state.menu = [];
        save();
        root.classList.remove('is-reviewing');

        console.warn('[Flayvr Ami v27] Meal eligibility shortage.', {
          library: diagnostics,
          slots: shortages.map(function (item) {
            return eligibilityDiagnostics(item.slot, library);
          })
        });

        addMessage(shortageText(shortages), 'ami');
        status.textContent = '';
        return false;
      }

      state.menu = nextMenu;
      save();

      /* The selected meals have just passed the live safety/eligibility path.
         Render this exact selection directly. Saved/restored menus still go
         through menuStillValid() on subsequent visits. */
      status.textContent = '';
      try {
        showReview({ freshBuild: true });
        if (options.announceSuccess) {
          /* Only call the week finished after the review has been entered. */
          console.info('[Flayvr Ami v27] Menu built and review entered.', {
            meals: state.menu.length,
            fallback: state.menu.filter(function (meal) { return meal.archiveFallback; }).length
          });
        }
        return true;
      } catch (error) {
        console.error('[Flayvr Ami v27] Menu render failed.', error);
        status.textContent = '';
        if (!menuGroups || !menuGroups.querySelector('.flami-chef-meal')) {
          root.classList.remove('is-reviewing');
          try { syncPortalReviewState(); } catch (syncError) {}
          try { setDedicatedConversationLock(false); } catch (lockError) {}
          addMessage('Your menu was built, but I couldn’t display it just now. Your answers are still saved — tap Plan my week to try the display again.', 'ami');
        }
        return false;
      }
    }

    function findSource(item, library) {
      var source = library.find(function (meal) {
        return String(meal.id) === String(item.id) ||
          (item.handle && meal.handle === item.handle) ||
          meal.name.toLowerCase() === String(item.name || '').toLowerCase();
      });
      if (source) return source;

      var bucket = loadedFallbackBucket(fallbackBucketKey(state));
      if (!bucket || !bucket.slots) return null;

      var record = null;
      Object.keys(bucket.slots).some(function (slot) {
        record = (bucket.slots[slot] || []).find(function (entry) {
          return String(entry.id) === String(item.id) ||
            String(entry.name || '').toLowerCase() === String(item.name || '').toLowerCase();
        }) || null;
        return Boolean(record);
      });

      return record ? fallbackRecordToMeal(record) : null;
    }

    function menuStillValid(menu) {
      if (!Array.isArray(menu) || !menu.length) return false;

      var library = parseLibrary();
      var plan = coveragePlan();
      var counts = {};
      var seen = new Set();

      for (var index = 0; index < menu.length; index += 1) {
        var item = menu[index];
        var source = findSource(item, library);
        if (!source || !configurationAllowed(source) || !matchesDiet(source) || !matchesAllergies(source) || !planAllows(source)) return false;

        var slot = plan.slots[item.slot] && supportsSlot(source, item.slot)
          ? item.slot
          : typeOf(source);
        if (!plan.slots[slot] || !supportsSlot(source, slot)) return false;
        counts[slot] = (counts[slot] || 0) + 1;

        item.id = source.id;
        item.handle = source.handle;
        item.slot = slot;
        item.name = source.name;
        item.displayName = displayMealName(source);
        item.description = annaDescriptionForMeal(source);
        item.calories = source.calories;
        item.protein = source.protein;
        item.fibre = source.fibre;
        item.diet = clone(source.diet);
        item.supportTags = clone(source.supportTags);
        item.baseMealKey = mealFamilyKey(source);
        item.versionCode = source.versionCode;
        item.versionLabel = source.versionLabel;
        item.adaptationNote = source.adaptationNote;
        item.kitchenInstruction = source.kitchenInstruction;
        item.adapted = source.adapted;
        item.variantApproved = source.variantApproved;
        item.tasteMatch = tasteMatchForMeal(source, state.name);
        item.buildStage = buildStageForMeal(source);
      }

      return Object.keys(plan.slots).every(function (slot) {
        return counts[slot] === plan.slots[slot];
      });
    }

    function annaPolishDescription(meal) {
      if (!meal) return '';

      var raw = String(meal.description || '').replace(/\s+/g, ' ').trim();
      if (!raw) return '';

      var key = cleanText(meal.name || '');

      /* Exact approved examples — all wording remains grounded in the
         Food Library facts already supplied for these dishes. */
      if (key === 'edamame buckwheat soba sesame salad') {
        return 'Nutty buckwheat soba with edamame, crisp cucumber and greens, finished with a savoury sesame-tamari dressing.';
      }
      if (key === 'black bean pineapple jerk bowl') {
        return 'Jerk-spiced black beans with rice, bright pineapple slaw, greens and a fresh hit of lime.';
      }
      if (key === 'adzuki bean teriyaki bowl') {
        return 'Adzuki beans in a glossy tamari teriyaki-style sauce with rice, greens and a sesame finish.';
      }
      if (key === 'ginger tamari chicken buckwheat bowl') {
        return 'Chicken with a gingery tamari glaze, buckwheat, greens and spring onion for a savoury finish.';
      }

      /* Anna's generic polish is intentionally conservative:
         adjective/flow edits only; no new ingredient nouns are introduced. */
      var polished = raw
        .replace(/\bwith sesame-tamari dressing\b/ig, 'finished with a savoury sesame-tamari dressing')
        .replace(/\bwith tamari teriyaki-style sauce\b/ig, 'in a glossy tamari teriyaki-style sauce')
        .replace(/\bwith ginger tamari glaze\b/ig, 'with a gingery tamari glaze')
        .replace(/\bwith lime\b/ig, 'with a fresh hit of lime')
        .replace(/\bwith lemon\b/ig, 'with a bright lemon finish')
        .replace(/\band lime\b/ig, 'and a fresh hit of lime')
        .replace(/\band lemon\b/ig, 'and a bright lemon finish')
        .replace(/\bwith sesame\.$/ig, 'with a sesame finish.')
        .replace(/\band sesame\.$/ig, 'and a sesame finish.')
        .replace(/\bwith herbs\.$/ig, 'with a fresh herb finish.')
        .replace(/\band herbs\.$/ig, 'and a fresh herb finish.')
        .replace(/\bwith chilli\.$/ig, 'with a clean chilli finish.')
        .replace(/\band chilli\.$/ig, 'and a clean chilli finish.');

      return polished;
    }

    function annaDescriptionForMeal(meal) {
      if (!meal) return '';
      var explicit = String(meal.customerDescription || '').replace(/\s+/g, ' ').trim();
      return explicit || annaPolishDescription(meal);
    }

    function spiceLabelForMeal(meal) {
      var level = Number(meal && meal.spiceLevel || 0);
      if (level >= 4) return 'Extra Hot';
      if (level >= 3) return 'Hot';
      if (level > 0) return 'Medium';
      var preference = cleanText(state.spice || 'Medium');
      if (preference.indexOf('extra hot') >= 0) return 'Extra Hot';
      if (preference.indexOf('hot') >= 0) return 'Hot';
      return 'Medium';
    }

    function chefSpecialForMeal(meal) {
      if (!meal) return false;
      if (meal.chefSpecial) return true;
      return list(meal.supportTags).some(function (tag) {
        var value = cleanText(tag);
        return value === 'chef special' || value === "chef's special" || value === 'chefs special';
      });
    }

    function customerCustomisationText(meal) {
      return customerBuildExplanation(meal);
    }

    function plainMealMeta(meal) {
      var items = [];
      if (meal && meal.protein > 0) items.push(Math.round(meal.protein) + 'g protein');
      if (meal && meal.calories > 0) items.push(Math.round(meal.calories) + ' kcal');
      items.push(spiceLabelForMeal(meal));
      list(meal && meal.diet).slice(0, 3).forEach(function (tag) {
        var value = String(tag || '').trim();
        if (value) items.push(value);
      });
      return items;
    }

    function markMealNotAgain(meal) {
      if (!meal) return;
      var taste = readTasteMemory();
      var items = taste.items || {};
      var handle = String(meal.handle || '').trim().toLowerCase().replace(/[_\\s]+/g, '-');
      var key = handle ? 'h:' + handle : 't:' + cleanText(meal.name || '');
      items[key] = Object.assign({}, items[key] || {}, { handle: meal.handle || '', title: meal.name || '', rating: 'not-again', updatedAt: Date.now() });
      taste.items = items;
      try { localStorage.setItem(TASTE_KEY, JSON.stringify(taste)); } catch (error) {}
    }

    function nutritionHtml(meal) {
      var metrics = [];
      if (meal.calories > 0) metrics.push('<div><strong>' + Math.round(meal.calories) + '</strong><span>kcal</span></div>');
      if (meal.protein > 0) metrics.push('<div><strong>' + Math.round(meal.protein) + 'g</strong><span>protein</span></div>');
      if (meal.carbs > 0) metrics.push('<div><strong>' + Math.round(meal.carbs) + 'g</strong><span>carbs</span></div>');
      if (meal.fat > 0) metrics.push('<div><strong>' + Math.round(meal.fat) + 'g</strong><span>fat</span></div>');
      if (meal.fibre > 0) metrics.push('<div><strong>' + Math.round(meal.fibre) + 'g</strong><span>fibre</span></div>');
      return metrics.length ? '<div class="flami-chef-info__nutrition">' + metrics.join('') + '</div>' : '<p>Nutrition data is not available for this meal yet.</p>';
    }

    function infoPanelHtml(meal) {
      var ingredients = list(meal.ingredients).join(', ');
      var allergens = list(meal.allergens).join(', ');
      return '<div class="flami-chef-info" hidden>' +
        '<div class="flami-chef-info__head"><strong>Meal information</strong><button type="button" data-chef-info-close aria-label="Close meal information">×</button></div>' +
        '<section><h4>Your customisations</h4><p>' + esc(customerCustomisationText(meal) || 'No additional customisations are needed for this meal.') + '</p></section>' +
        '<section><h4>Ingredients</h4><p>' + esc(ingredients || 'Ingredients are not available for this meal yet.') + '</p></section>' +
        (allergens ? '<section><h4>Allergens</h4><p>' + esc(allergens) + '</p></section>' : '') +
        '<section><h4>Nutrition</h4>' + nutritionHtml(meal) + '</section></div>';
    }

    function ensureReviewPolishStyles() {
      if (document.getElementById('flayvr-ami-review-polish-v1')) return;
      var style = document.createElement('style');
      style.id = 'flayvr-ami-review-polish-v1';
      style.textContent =
        '[data-flayvr-ami-v27] .flami-chef-meal h3.is-long-name{' +
          'font-size:clamp(18px,1.55vw,23px);line-height:1.08;letter-spacing:-.035em;overflow-wrap:anywhere;' +
        '}' +
        '@media(max-width:720px){[data-flayvr-ami-v27] .flami-chef-meal h3.is-long-name{font-size:17px;line-height:1.1}}';
      document.head.appendChild(style);
    }

    function renderMenuLegacy() {
      if (!menuGroups) throw new Error('Ami menu container is not available.');
      ensureReviewPolishStyles();
      menuGroups.innerHTML = '';
      var library = parseLibrary();
      var slotOrder = ['Breakfast', 'Lunch', 'Dinner', 'Snack'];
      var renderedCount = 0;

      var intro = document.createElement('section');
      intro.className = 'flami-chef-note';
      intro.innerHTML = '<div class="flami-chef-note__label">Ami\'s note</div><div class="flami-chef-note__body"><p>' + esc(chefWeekNote()) + '</p></div>';
      menuGroups.appendChild(intro);

      function minimalMealCard(meal, source, error) {
        var article = document.createElement('article');
        article.className = 'flami-chef-meal';
        article.setAttribute('data-ami-safe-fallback-card', '');
        article.innerHTML =
          '<div class="flami-chef-meal__top"><div><small>Day ' + esc(String(meal.day || '')) + '</small>' +
          '<h3 class="' + (String((source && (source.displayName || source.name)) || meal.displayName || meal.name || 'Meal').length > 34 ? 'is-long-name' : '') + '">' + esc(String((source && (source.displayName || source.name)) || meal.displayName || meal.name || 'Meal')) + '</h3>' +
          '<p>' + esc(String((source && (source.customerDescription || source.description)) || meal.description || 'Selected as a safe fit for your week.')) + '</p></div></div>' +
          '<div class="flami-chef-actions"><button type="button" data-chef-not-again>Not again</button></div>';
        var notAgain = article.querySelector('[data-chef-not-again]');
        if (notAgain) notAgain.addEventListener('click', function () {
          markMealNotAgain(source || meal);
        });
        console.warn('[Flayvr Ami v27] Rendered minimal safe card after card renderer error.', error, meal);
        return article;
      }

      slotOrder.forEach(function (slot) {
        var meals = state.menu.filter(function (meal) { return meal.slot === slot; }).sort(function (a,b) { return Number(a.day||0)-Number(b.day||0); });
        if (!meals.length) return;

        var section = document.createElement('section');
        section.className = 'flami-chef-slot';
        section.innerHTML = '<div class="flami-chef-slot__head"><h3>' + esc(slot) + '</h3><span>' + meals.length + ' meal' + (meals.length === 1 ? '' : 's') + '</span></div><div class="flami-chef-slot__grid"></div>';
        var grid = section.querySelector('.flami-chef-slot__grid');
        menuGroups.appendChild(section);
        if (!grid) return;

        meals.forEach(function (meal) {
          var menuIndex = state.menu.indexOf(meal);
          var source = findSource(meal, library);
          if (!source && meal.archiveFallback) source = meal;
          if (!source) source = meal;

          try {
            var variants = meal.archiveFallback ? [] : safeVariantsForMeal(meal);
            var meta = plainMealMeta(source);
            var tasteReason = tasteEnhancementContext(state.name) ? tasteReasonForMeal(source) : null;
            var article = document.createElement('article');
            article.className = 'flami-chef-meal' + (chefSpecialForMeal(source) ? ' is-chef-special' : '');
            article.innerHTML =
              (chefSpecialForMeal(source) ? '<div class="flami-chef-special">Chef\'s Special</div>' : '') +
              '<div class="flami-chef-meal__top"><div><small>Day ' + esc(String(meal.day || '')) + '</small><h3 class="' + ((displayMealName(source) || meal.displayName || meal.name || '').length > 34 ? 'is-long-name' : '') + '">' + esc(displayMealName(source) || meal.displayName || meal.name) + '</h3><p>' + esc(annaDescriptionForMeal(source) || meal.description || '') + '</p></div>' +
              (tasteEnhancementContext(state.name) && tasteMatchForMeal(source, state.name) != null ? '<div class="flami-chef-match"><strong>' + Math.round(tasteMatchForMeal(source, state.name)) + '%</strong><span>Taste match</span></div>' : '') + '</div>' +
              '<div class="flami-chef-meta">' + meta.map(function (item) { return '<span>' + esc(item) + '</span>'; }).join('') + '</div>' +
              (tasteReason ? '<div class="flami-chef-why"><button type="button" data-chef-why aria-expanded="false"><span>Why Ami picked this</span><i>+</i></button><div class="flami-chef-why__body" data-chef-why-body hidden><p>' + esc(tasteReason.text) + '</p><div>' + tasteReason.chips.map(function(chip){return '<span>' + esc(chip) + '</span>';}).join('') + '</div></div></div>' : '') +
              '<div class="flami-chef-actions"><button type="button" data-chef-swap>Swap dish</button>' +
              (variants.length > 1 ? '<button type="button" data-chef-adjust>Adjust version</button>' : '') +
              '<button type="button" data-chef-not-again>Not again</button></div>' +
              '<button type="button" class="flami-chef-info-button" data-chef-info aria-label="Meal information">i</button>' + infoPanelHtml(source) +
              (variants.length > 1 ? '<div class="flami-chef-versions" hidden></div>' : '');

            var swap=article.querySelector('[data-chef-swap]');
            if(swap) swap.addEventListener('click',function(){var original=swap.textContent;if(swapMenuMeal(menuIndex))return;swap.disabled=true;swap.textContent='No other safe dish';window.setTimeout(function(){swap.disabled=false;swap.textContent=original;},1800);});
            var notAgain=article.querySelector('[data-chef-not-again]');
            if(notAgain) notAgain.addEventListener('click',function(){markMealNotAgain(source);if(!swapMenuMeal(menuIndex)){state.menu=[];save();buildMenu();}});
            var whyButton=article.querySelector('[data-chef-why]'), whyBody=article.querySelector('[data-chef-why-body]');
            if(whyButton&&whyBody){whyButton.addEventListener('click',function(){var opening=whyBody.hasAttribute('hidden');if(opening)whyBody.removeAttribute('hidden');else whyBody.setAttribute('hidden','');whyButton.setAttribute('aria-expanded',opening?'true':'false');article.classList.toggle('is-taste-reason-open',opening);});}
            var infoButton=article.querySelector('[data-chef-info]'), infoPanel=article.querySelector('.flami-chef-info'), infoClose=article.querySelector('[data-chef-info-close]');
            function setInfo(open){if(!infoPanel)return;if(open)infoPanel.removeAttribute('hidden');else infoPanel.setAttribute('hidden','');article.classList.toggle('is-info-open',open);}
            if(infoButton) infoButton.addEventListener('click',function(){setInfo(true);});
            if(infoClose) infoClose.addEventListener('click',function(){setInfo(false);});
            var adjust=article.querySelector('[data-chef-adjust]'), picker=article.querySelector('.flami-chef-versions');
            if(adjust&&picker){adjust.addEventListener('click',function(){var opening=picker.hasAttribute('hidden');if(opening){picker.removeAttribute('hidden');adjust.textContent='Close versions';}else{picker.setAttribute('hidden','');adjust.textContent='Adjust version';}});variants.forEach(function(variant){var option=document.createElement('button');option.type='button';option.className='flami-chef-version'+(String(variant.id)===String(meal.id)?' is-current':'');option.innerHTML='<strong>'+esc(variant.versionLabel||displayMealName(variant))+'</strong><span>'+esc(variant.adaptationNote||annaDescriptionForMeal(variant))+'</span>';option.addEventListener('click',function(){applyVariantToMenu(menuIndex,variant);});picker.appendChild(option);});}

            grid.appendChild(article);
            renderedCount += 1;
          } catch (error) {
            grid.appendChild(minimalMealCard(meal, source, error));
            renderedCount += 1;
          }
        });
      });

      if (!renderedCount && state.menu.length) {
        throw new Error('Ami had a menu but rendered zero meal cards.');
      }
      return renderedCount;
    }


    function resultsDayName(day) {
      return ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'][Number(day || 0) - 1] || ('Day ' + day);
    }

    function renderMenuStandard() {
      if (!menuGroups) throw new Error('Ami menu container is not available.');
      ensureReviewPolishStyles();
      menuGroups.innerHTML = '';
      var library = parseLibrary();
      var slotOrder = { Breakfast: 0, Lunch: 1, Dinner: 2, Snack: 3 };
      var tasteContext = tasteEnhancementContext(state.name);
      var days = [];
      state.menu.forEach(function (meal) {
        var day = Number(meal.day || 0);
        if (day > 0 && days.indexOf(day) < 0) days.push(day);
      });
      days.sort(function (a,b) { return a-b; });
      var renderedCount = 0;

      function buildCard(meal) {
        var menuIndex = state.menu.indexOf(meal);
        var source = findSource(meal, library);
        if (!source && meal.archiveFallback) source = meal;
        if (!source) source = meal;
        var variants = meal.archiveFallback ? [] : safeVariantsForMeal(meal);
        var meta = plainMealMeta(source);
        var tasteReason = tasteContext ? tasteReasonForMeal(source) : null;
        var tasteMatch = tasteContext ? tasteMatchForMeal(source, state.name) : null;
        if (tasteMatch != null) meal.tasteMatch = tasteMatch;
        var article = document.createElement('article');
        article.className = 'flami-chef-meal flami-results-meal' + (chefSpecialForMeal(source) ? ' is-chef-special' : '');
        article.innerHTML =
          '<div class="flami-chef-meal__top"><div><small>' + esc(meal.slot || '') + '</small><h3 class="' + ((displayMealName(source) || meal.displayName || meal.name || '').length > 34 ? 'is-long-name' : '') + '">' + esc(displayMealName(source) || meal.displayName || meal.name) + '</h3><p>' + esc(annaDescriptionForMeal(source) || meal.description || '') + '</p></div>' +
          (tasteMatch != null ? '<div class="flami-chef-match"><strong>' + Math.round(tasteMatch) + '%</strong><span>Taste match</span></div>' : '') + '</div>' +
          '<div class="flami-chef-meta">' + meta.map(function (item) { return '<span>' + esc(item) + '</span>'; }).join('') + '</div>' +
          (tasteReason ? '<div class="flami-chef-why"><button type="button" data-chef-why aria-expanded="false"><span>Why Ami picked this</span><i>+</i></button><div class="flami-chef-why__body" data-chef-why-body hidden><p>' + esc(tasteReason.text) + '</p><div>' + tasteReason.chips.map(function(chip){return '<span>' + esc(chip) + '</span>';}).join('') + '</div></div></div>' : '') +
          '<div class="flami-chef-actions"><button type="button" data-chef-swap>Swap dish</button>' +
          (variants.length > 1 ? '<button type="button" data-chef-adjust>Adjust version</button>' : '') +
          '<button type="button" data-chef-not-again>Not again</button></div>' +
          '<button type="button" class="flami-chef-info-button" data-chef-info aria-label="Meal information">i</button>' + infoPanelHtml(source) +
          (variants.length > 1 ? '<div class="flami-chef-versions" hidden></div>' : '');

        var swap=article.querySelector('[data-chef-swap]');
        if(swap) swap.addEventListener('click',function(){var original=swap.textContent;if(swapMenuMeal(menuIndex))return;swap.disabled=true;swap.textContent='No other safe dish';window.setTimeout(function(){swap.disabled=false;swap.textContent=original;},1800);});
        var notAgain=article.querySelector('[data-chef-not-again]');
        if(notAgain) notAgain.addEventListener('click',function(){markMealNotAgain(source);if(!swapMenuMeal(menuIndex)){state.menu=[];save();buildMenu();}});
        var whyButton=article.querySelector('[data-chef-why]'), whyBody=article.querySelector('[data-chef-why-body]');
        if(whyButton&&whyBody){whyButton.addEventListener('click',function(){var opening=whyBody.hasAttribute('hidden');if(opening)whyBody.removeAttribute('hidden');else whyBody.setAttribute('hidden','');whyButton.setAttribute('aria-expanded',opening?'true':'false');article.classList.toggle('is-taste-reason-open',opening);});}
        var infoButton=article.querySelector('[data-chef-info]'), infoPanel=article.querySelector('.flami-chef-info'), infoClose=article.querySelector('[data-chef-info-close]');
        function setInfo(open){if(!infoPanel)return;if(open)infoPanel.removeAttribute('hidden');else infoPanel.setAttribute('hidden','');article.classList.toggle('is-info-open',open);}
        if(infoButton) infoButton.addEventListener('click',function(){setInfo(true);});
        if(infoClose) infoClose.addEventListener('click',function(){setInfo(false);});
        var adjust=article.querySelector('[data-chef-adjust]'), picker=article.querySelector('.flami-chef-versions');
        if(adjust&&picker){adjust.addEventListener('click',function(){var opening=picker.hasAttribute('hidden');if(opening){picker.removeAttribute('hidden');adjust.textContent='Close versions';}else{picker.setAttribute('hidden','');adjust.textContent='Adjust version';}});variants.forEach(function(variant){var option=document.createElement('button');option.type='button';option.className='flami-chef-version'+(String(variant.id)===String(meal.id)?' is-current':'');option.innerHTML='<strong>'+esc(variant.versionLabel||displayMealName(variant))+'</strong><span>'+esc(variant.adaptationNote||annaDescriptionForMeal(variant))+'</span>';option.addEventListener('click',function(){applyVariantToMenu(menuIndex,variant);});picker.appendChild(option);});}
        return article;
      }

      days.forEach(function (day) {
        var meals = state.menu.filter(function (meal) { return Number(meal.day || 0) === day; }).sort(function (a,b) { return (slotOrder[a.slot] != null ? slotOrder[a.slot] : 99) - (slotOrder[b.slot] != null ? slotOrder[b.slot] : 99); });
        if (!meals.length) return;
        var section = document.createElement('section');
        section.className = 'flami-results-day';
        var slotLabel = meals.map(function(meal){ return meal.slot; }).filter(function(value,index,array){ return array.indexOf(value)===index; }).join(' + ');
        section.innerHTML = '<div class="flami-results-day__head"><strong>' + esc(resultsDayName(day)) + '</strong><span>' + esc(slotLabel) + '</span></div><div class="flami-results-day__grid"></div>';
        var grid = section.querySelector('.flami-results-day__grid');
        meals.forEach(function(meal){
          try { grid.appendChild(buildCard(meal)); renderedCount += 1; }
          catch(error){ console.warn('[Flayvr Ami] Standard result card fallback.', error); }
        });
        menuGroups.appendChild(section);
      });
      if (!renderedCount && state.menu.length) return renderMenuLegacy();
      return renderedCount;
    }

    function renderMenu() {
      return root.hasAttribute('data-ami-dedicated-page') ? renderMenuStandard() : renderMenuLegacy();
    }

    function ensureChefNotesEditor() {
      if (!review) return;
      var host = review.querySelector('[data-ami-chef-notes-host]');
      if (!host) {
        host = document.createElement('section');
        host.setAttribute('data-ami-chef-notes-host', '');
        host.style.cssText = 'margin:18px 0;border:1px solid rgba(31,30,27,.12);border-radius:20px;padding:16px;background:transparent;';
        host.innerHTML = '<label style="display:block;font:500 11px/1.3 Helvetica Neue,Arial,sans-serif;margin-bottom:7px">Your notes to the chef</label>' +
          '<textarea data-ami-chef-notes rows="3" placeholder="Anything else the chef should know?" style="display:block;width:100%;resize:vertical;border:0;border-top:1px solid rgba(31,30,27,.1);padding:12px 0 0;background:transparent;color:inherit;font:400 13px/1.45 Inter Tight,Helvetica Neue,Arial,sans-serif;outline:none"></textarea>' +
          '<small data-ami-chef-notes-status style="display:block;margin-top:8px;color:#777169;font-size:11px;line-height:1.4"></small>';
        var actions = review.querySelector('.flami-review-actions') || review.querySelector('[data-ami-menu-groups]');
        if (actions && actions.parentNode) actions.parentNode.insertBefore(host, actions);
        else review.appendChild(host);
        var area = host.querySelector('[data-ami-chef-notes]');
        var noteStatus = host.querySelector('[data-ami-chef-notes-status]');
        area.addEventListener('change', function () {
          var next = String(area.value || '').trim();
          if (next === state.chefNotes) return;
          state.chefNotes = next;
          state.menu = [];
          save();
          var parsed = parseChefNotes(next);
          noteStatus.textContent = parsed.hard.length ? 'I’ll re-check the menu against: ' + parsed.hard.join(', ') + '.' : 'Saved. Ami will use this when checking and shaping the menu.';
          buildMenu();
        });
      }
      var input = host.querySelector('[data-ami-chef-notes]');
      if (input && input.value !== state.chefNotes) input.value = state.chefNotes || '';
      var parsed = parseChefNotes(state.chefNotes);
      var noteStatus = host.querySelector('[data-ami-chef-notes-status]');
      if (noteStatus) noteStatus.textContent = parsed.hard.length ? 'Hard rules found in your note: ' + parsed.hard.join(', ') + '.' : (state.chefNotes ? 'Saved with this menu.' : 'Optional. Add anything you want the chef to keep in mind.');
    }

    function showReview(options) {
      options = options || {};
      var savedNeedsFallback = Array.isArray(state.menu) && state.menu.some(function (meal) {
        return Boolean(meal && (meal.archiveFallback || String(meal.handle || '').indexOf('ami-fallback-') === 0));
      });

      if (savedNeedsFallback && !loadedFallbackBucket(fallbackBucketKey(state)) && !fallbackBucketFailed[fallbackBucketKey(state)]) {
        status.textContent = 'Loading your saved menu…';
        ensureFallbackBucket(fallbackBucketKey(state), function () {
          status.textContent = '';
          showReview(options);
        });
        return;
      }

      if (!options.freshBuild && !menuStillValid(state.menu)) {
        state.menu = [];
        save();
        buildMenu();
        return;
      }

      if (!review || !menuGroups) {
        throw new Error('Ami review markup is not available.');
      }

      var plan = coveragePlan();

      /* Enter review before optional decoration. Once the menu itself can render,
         secondary UI such as memory or notes must never be able to hide it. */
      root.classList.add('is-reviewing');
      try { syncPortalReviewState(); } catch (error) { console.warn('[Flayvr Ami v27] Review portal sync skipped.', error); }
      try { setDedicatedConversationLock(true); } catch (error) { console.warn('[Flayvr Ami v27] Review conversation lock skipped.', error); }
      try {
        ensureResultsScrollSurface();
        overlay.setAttribute('tabindex', '-1');
      } catch (error) {
        console.warn('[Flayvr Ami v27] Results scroll surface setup skipped.', error);
      }

      try {
        var reviewKicker = review.querySelector('.flami-kicker');
        var reviewTitle = review.querySelector('.flami-review-head h2');
        var reviewCopy = review.querySelector('[data-ami-review-copy]');
        var reviewPrice = review.querySelector('[data-ami-price]');
        var reviewCoverage = review.querySelector('[data-ami-coverage-summary]');
        var reviewDiet = review.querySelector('[data-ami-diet-summary]');
        var reviewSpice = review.querySelector('[data-ami-spice-summary]');
        if (reviewKicker) reviewKicker.textContent = 'Your menu from Ami';
        if (reviewTitle) reviewTitle.textContent = 'Cooked for your week, not picked from a catalogue.';
        if (reviewCopy) reviewCopy.textContent = tasteEnhancementContext(state.name)
          ? 'Your food rules were applied first. Your Taste Test then helped Ami rank the strongest safe matches and balance contrast across the week.'
          : 'Ami built this week around the food rules and preferences you gave her, with enough variety to keep it useful rather than repetitive.';
        if (reviewPrice) reviewPrice.textContent = '£' + plan.price + ' / week';
        if (reviewCoverage) reviewCoverage.textContent = plan.label;
        if (reviewDiet) reviewDiet.textContent = state.diet.join(', ') || 'No restrictions saved';
        if (reviewSpice) reviewSpice.textContent = state.spice || 'Medium';
      } catch (error) {
        console.warn('[Flayvr Ami v27] Review header decoration skipped.', error);
      }

      try {
        var enhanced = Boolean(tasteEnhancementContext(state.name));
        review.classList.toggle('has-taste-pdf', enhanced);
        review.classList.toggle('is-simple-result', !enhanced);
        var menuContext = review.querySelector('[data-ami-menu-context]');
        if (menuContext) menuContext.innerHTML = enhanced
          ? 'Tap <strong>Why Ami picked this</strong> to see how each choice connects to your Taste Test. Taste fit never overrides allergies or dietary rules.'
          : 'Ami built this menu around the food rules and preferences you gave her. You can still swap or adjust anything before checkout.';
        var topBack = review.querySelector('[data-ami-results-back]');
        if (topBack && !topBack.__amiBound) { topBack.__amiBound = true; topBack.addEventListener('click', function(){ var back = review.querySelector('[data-ami-back-chat]'); if (back) back.click(); }); }
        var topPdf = review.querySelector('[data-ami-results-pdf]');
        if (topPdf && !topPdf.__amiBound) { topPdf.__amiBound = true; topPdf.addEventListener('click', downloadPdf); }
      } catch (error) { console.warn('[Flayvr Ami v27] Standard results state skipped.', error); }

      try { renderReviewTastePanel(); } catch (error) { console.warn('[Flayvr Ami v27] Taste Profile review panel skipped.', error); }
      var rendered = renderMenu();

      try { ensureChefNotesEditor(); } catch (error) { console.warn('[Flayvr Ami v27] Chef notes editor skipped.', error); }
      try { renderReviewTasteSummary(); } catch (error) { console.warn('[Flayvr Ami v27] Taste Profile week summary skipped.', error); }
      try { renderMemory(); } catch (error) { console.warn('[Flayvr Ami v27] Memory panel render skipped.', error); }
      try {
        if (overlay && overlay.scrollTo) overlay.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      } catch (error) {
        console.warn('[Flayvr Ami v27] Review scroll reset skipped.', error);
      }

      return rendered;
    }

    function renderMemory() {
      if (!memoryList) return;
      var plan = coveragePlan();
      var bullets = [];
      if (state.name) bullets.push('Planning for ' + state.name);
      if (state.people) bullets.push('Feeding: ' + state.people);
      bullets.push(plan.label + ' · £' + plan.price + ' per week');
      if (state.allergies.length) bullets.push('Hard allergies: ' + state.allergies.join(', '));
      else if (state.legacyHardAvoids) bullets.push('Hard avoids to reconfirm: ' + state.legacyHardAvoids);
      if (state.dietKnown) bullets.push(state.diet.length ? state.diet.join(', ') : 'No dietary restrictions');
      if (state.dislikes.length) bullets.push('Dislikes: ' + state.dislikes.join(', '));
      if (state.spice) bullets.push(state.spice + ' spice');
      if (state.chefNotes) bullets.push('Notes to chef: ' + state.chefNotes);
      /* Mood is deliberately omitted from identity memory: order-level only. */
      memoryList.innerHTML = bullets.map(function (item) { return '<li>' + esc(item) + '</li>'; }).join('') || '<li>No answers saved yet</li>';
    }

    function editCoverage() {
      enterConversationMode();
      state.editingCoverage = true;
      addMessage('Everything else is still saved. Which coverage do you want instead?', 'ami');
      addChoices(STEPS.find(function (step) { return step.id === 'coverage'; }));
    }

    function editSingleAnswer(stepId) {
      var step = STEPS.find(function (item) { return item.id === stepId; });
      if (!step) return;
      enterConversationMode();
      state.menu = [];
      state.completed = state.completed.filter(function (id) { return id !== stepId; });
      clearChat();
      addMessage('I’ve kept the rest of your profile. Let’s update just this answer.', 'ami');
      askStep();
    }

    function restartEditing() {
      enterConversationMode();
      clearChat();
      addMessage('What would you like to change?', 'ami');
      addActionButtons([
        ['Name', function () { editSingleAnswer('name'); }],
        ['Household size', function () { editSingleAnswer('people'); }],
        ['Coverage', editCoverage],
        ['Allergies', function () { state.updatingAllergies = true; editSingleAnswer('allergies'); }],
        ['Food rules', function () { editSingleAnswer('diet'); }],
        ['Dislikes', function () { editSingleAnswer('dislikes'); }],
        ['Spice', function () { editSingleAnswer('spice'); }],
        ['This week’s plate direction', function () { editSingleAnswer('mood'); }]
      ]);
    }

    function reset() {
      clearSaved();
      Object.assign(state, blankState());
      enterConversationMode();
      workspacePreviousSnapshot = null;
      clearChat();
      renderMemory();
      startNew();
    }

    function nextMonday(referenceDate) {
      var date = referenceDate ? new Date(referenceDate) : new Date();
      date.setHours(12, 0, 0, 0);
      var days = (8 - date.getDay()) % 7;
      if (!days) days = 7;
      date.setDate(date.getDate() + days);
      return date;
    }

    function formatDate(date) {
      try {
        return new Intl.DateTimeFormat('en-GB', {
          day: 'numeric',
          month: 'short',
          year: 'numeric'
        }).format(date);
      } catch (error) {
        return date.toISOString().slice(0, 10);
      }
    }

    function possessive(name) {
      if (!name) return 'Your';
      return /s$/i.test(name) ? name + "'" : name + "'s";
    }

    function amiPdfDocument() {
      var plan = coveragePlan();
      var library = parseLibrary();
      var tasteContext = tasteEnhancementContext(state.name);
      var tasteProfile = tasteContext && tasteContext.currentProfile ? tasteContext.currentProfile : null;
      var maxDay = state.menu.reduce(function (max, meal) {
        return Math.max(max, Number(meal.day || 0));
      }, 0);
      var slotOrder = { Breakfast: 0, Lunch: 1, Dinner: 2, Snack: 3 };

      function sourceFor(meal) {
        return findSource(meal, library) || meal;
      }

      function numberFrom(object, keys) {
        for (var i = 0; i < keys.length; i += 1) {
          var value = Number(object && object[keys[i]]);
          if (Number.isFinite(value)) return Math.max(0, Math.min(100, Math.round(value)));
        }
        return 0;
      }

      function mealRecord(meal) {
        var source = sourceFor(meal);
        var match = tasteProfile ? tasteMatchForMeal(source, state.name) : null;
        return {
          slot: meal.slot || '',
          name: displayMealName(source) || meal.displayName || meal.name || 'Meal',
          description: (function () {
            var description = annaDescriptionForMeal(source) || meal.description || '';
            if (typeof description === 'object') description = description.text || '';
            description = String(description || '').replace(/\s+/g, ' ').trim();
            return description ? description.charAt(0).toUpperCase() + description.slice(1) : '';
          })(),
          tags: plainMealMeta(source).slice(0, 4),
          match: match == null ? null : Math.round(match),
          reason: tasteProfile ? (function () {
            var reason = tasteReasonForMeal(source) || '';
            return reason && typeof reason === 'object' ? (reason.text || '') : String(reason || '');
          })() : ''
        };
      }

      var days = [];
      for (var day = 1; day <= maxDay; day += 1) {
        var meals = state.menu
          .filter(function (meal) { return Number(meal.day || 0) === day; })
          .sort(function (a, b) {
            return (slotOrder[a.slot] == null ? 99 : slotOrder[a.slot]) -
              (slotOrder[b.slot] == null ? 99 : slotOrder[b.slot]);
          });
        if (!meals.length) continue;
        var slots = meals.map(function (meal) { return meal.slot; })
          .filter(function (value, index, all) { return value && all.indexOf(value) === index; });
        days.push({
          day: day,
          name: resultsDayName(day),
          note: slots.join(' + '),
          meals: meals.map(mealRecord)
        });
      }

      var taste = null;
      var movedDown = '';
      var movedUp = '';
      if (tasteProfile) {
        var ranked = tasteRankedSignals(tasteProfile);
        var low = ranked[ranked.length - 1];
        movedDown = low && low.key === 'sweet' && Number(low.value) <= 35
          ? 'Sweet-forward meals without enough savoury, acidic or textural contrast. Sweetness scored just ' + Math.round(low.value) + '%.'
          : 'Ami avoids over-indexing on ' + (low ? tasteDimensionLabel(low.key) : 'lower-scoring signals') + ' compared with your stronger signals.';
        movedUp = tasteMoveUpCopy(tasteProfile);
        taste = {
          profileName: tasteProfileDisplayName(tasteProfile),
          scores: {
            adventure: numberFrom(tasteProfile, ['adventure', 'adv']),
            heat: numberFrom(tasteProfile, ['heat']),
            intensity: numberFrom(tasteProfile, ['intensity', 'int']),
            acid: numberFrom(tasteProfile, ['acid']),
            texture: numberFrom(tasteProfile, ['texture', 'tex']),
            sweet: numberFrom(tasteProfile, ['sweet'])
          },
          signals: ranked.slice(0, 3).map(function (signal) {
            return {
              key: signal.key,
              label: tasteDimensionDisplay(signal.key),
              value: Math.round(signal.value),
              explanation: tasteSignalExplanation(signal.key)
            };
          }),
          movedDown: movedDown,
          movedUp: movedUp
        };
      }

      var weekDate = nextMonday(new Date());
      var logo = root.querySelector('[data-ami-results-logo]');
      var foodProfile = state.diet.join(', ') || 'No restrictions saved';

      return {
        version: 'ami-real-pdf-v1',
        name: state.name || '',
        weekOf: formatDate(weekDate),
        coverage: plan.label,
        price: plan.price,
        people: state.people || '',
        foodProfile: foodProfile,
        allergies: state.allergies.join(', '),
        dislikes: state.dislikes.join(', '),
        spice: state.spice || 'Medium',
        logoSrc: logo && logo.src ? logo.src : '',
        intro: tasteProfile
          ? 'Ami applied your food rules first, then used your Taste Test to decide which suitable meals should move higher - and where the week needs more contrast.'
          : 'Ami built this week around the food rules and preferences you gave her, with enough variety to keep the week useful rather than repetitive.',
        menuHelp: tasteProfile
          ? 'Taste Match shows how closely each suitable meal aligns with your imported Taste Test. Food rules always come first.'
          : 'Every meal shown here already fits the food rules Ami used to build your plan.',
        taste: taste,
        days: days,
        summaryIntro: tasteProfile
          ? 'Your Taste Test is a ranking signal, not a command to make every meal taste the same. Ami kept your strongest preferences visible, then deliberately varied heat, cuisine and meal shape.'
          : 'Ami built the week from your saved food rules and preferences, then varied meal shape and flavour so the plan stays useful rather than repetitive.',
        movedUp: movedUp || 'Meals that best fit your saved preferences and this week’s food rules.',
        movedDown: movedDown || 'Meals that conflict with your saved requirements or would make the week unnecessarily repetitive.',
        balanced: 'At least one calmer meal can stay when it creates useful contrast without losing the shape of your plan.'
      };
    }

    async function downloadPdf() {
      if (status.textContent && /Searching|Balancing|Checking|Building/i.test(status.textContent)) {
        status.textContent = 'Finish building your menu first.';
        return;
      }
      if (!state.menu.length) {
        status.textContent = 'Build a valid menu first.';
        return;
      }
      if (downloadPdf.busy) return;
      if (!window.FlayvrAmiPDFV1 || typeof window.FlayvrAmiPDFV1.download !== 'function') {
        status.textContent = 'The PDF engine did not load. Refresh the page and try again.';
        return;
      }

      downloadPdf.busy = true;
      status.textContent = 'Generating your PDF…';
      try {
        var dateStamp = new Date().toISOString().slice(0, 10);
        var filename = 'Flayvr-Ami-' + (state.name || 'Personalised') + '-Menu-' + dateStamp + '.pdf';
        var result = await window.FlayvrAmiPDFV1.download(amiPdfDocument(), filename);
        status.textContent = result && result.mode === 'apple-ready'
          ? 'Your personalised PDF is ready to download or open.'
          : 'Your personalised PDF has downloaded.';
      } catch (error) {
        console.error('[Flayvr Ami PDF] Real PDF generation failed.', error);
        status.textContent = 'I couldn’t create the PDF. Your menu is still saved — please try again.';
      } finally {
        downloadPdf.busy = false;
      }
    }


    async function checkout() {
      var id = config['variant' + state.coverage];
      var plan = coveragePlan();

      if (!id) {
        window.location.href = config.fallbackUrl || '/cart';
        return;
      }

      status.textContent = 'Adding your plan…';

      var kitchenDays = {};
      state.menu.forEach(function (meal) {
        var key = 'Kitchen Day ' + meal.day;
        var code = meal.versionCode || meal.handle || meal.name;
        var piece = meal.slot.charAt(0) + ':' + code;
        kitchenDays[key] = kitchenDays[key] ? kitchenDays[key] + ' · ' + piece : piece;
      });

      try {
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: Number(id),
            quantity: 1,
            properties: Object.assign({
              'Ami coverage': plan.label,
              'Ami price': '£' + plan.price,
              'Ami name': state.name,
              'Ami household': state.people,
              'Allergies / hard avoids': state.allergies.concat(list(state.legacyHardAvoids)).join(', '),
              'Dietary profile': state.diet.join(', '),
              'Dislikes': state.dislikes.join(', '),
              'Spice': state.spice,
              'Ami mood this order': state.mood,
              'Additional goals': state.goal.join(', '),
              'Ami menu': state.menu.map(function (meal) {
                return meal.slot + ' ' + meal.day + ': ' + (meal.displayName || meal.name) + (meal.versionLabel ? ' [' + meal.versionLabel + ']' : '');
              }).join(' | ')
            }, kitchenDays)
          })
        });

        if (!response.ok) throw new Error('Cart add failed');
        window.location.href = '/cart';
      } catch (error) {
        window.location.href = config.fallbackUrl || '/cart';
      }
    }

    function startNew() {
      awaitingResume = false;
      savedRecord = null;
      Object.assign(state, blankState());
      clearChat();
      addMessage('Hi, I’m Ami. I’ll ask only what I need to build a practical first menu.', 'ami');
      setTimeout(askStep, 180);
    }

    function startFresh() {
      clearSaved();
      enterConversationMode();
      workspacePreviousSnapshot = null;
      startNew();
    }

    function resumePlan() {
      if (!savedRecord) return;

      awaitingResume = false;
      applySaved(savedRecord);
      clearChat();
      renderMemory();

      if (menuStillValid(state.menu)) {
        addMessage('Welcome back' + (state.name ? ', ' + state.name : '') + '. I’ve restored your saved plan.', 'ami');
        showReview();
        return;
      }

      state.menu = [];
      save();

      if (firstIncomplete()) {
        addMessage('Welcome back' + (state.name ? ', ' + state.name : '') + '. I’ve restored your saved answers.', 'ami');
        setTimeout(askStep, 180);
      } else {
        addMessage('Welcome back' + (state.name ? ', ' + state.name : '') + '. I’ve restored your profile and I’m re-checking the current menu before I rebuild your week.', 'ami');
        buildMenu();
      }
    }

    function showResumePrompt(record) {
      savedRecord = record;
      awaitingResume = true;
      clearChat();
      input.placeholder = 'Message Ami…';
      addMessage('Welcome back' + (record.state.name ? ', ' + record.state.name : '') + '. I saved the plan you were building. Continue where you left off or start fresh?', 'ami');
      addActionButtons([
        ['Continue my plan', resumePlan],
        ['Start fresh', startFresh]
      ]);
    }

    function fullProfileExcerptCopy(handoff) {
      handoff = handoff || {};
      var d = handoff.dining || {};
      var ins = handoff.insights || {};
      var style = String(ins.archetype || diningStyleName(d) || 'Balanced & flexible').trim();
      var pieces = ['Dining Style: ' + style + '.'];
      if ([d.menu,d.energy,d.theatre,d.formal,d.travel].every(function(v){ return Number.isFinite(Number(v)); })) {
        pieces.push('Menu commitment ' + Math.round(Number(d.menu)) + ' · Room energy ' + Math.round(Number(d.energy)) + ' · Theatre ' + Math.round(Number(d.theatre)) + ' · Formality ' + Math.round(Number(d.formal)) + ' · Destination appetite ' + Math.round(Number(d.travel)) + '.');
      }
      if (String(ins.brief || '').trim()) pieces.push(String(ins.brief).trim());
      var london = Array.isArray(handoff.london) ? handoff.london.slice(0,3).map(function(r){ return String(r && r.n || '').trim(); }).filter(Boolean) : [];
      var world = Array.isArray(handoff.world) ? handoff.world.slice(0,3).map(function(r){ return String(r && r.n || '').trim(); }).filter(Boolean) : [];
      if (london.length) pieces.push('London matches: ' + london.join(', ') + '.');
      if (world.length) pieces.push('Travel matches: ' + world.join(', ') + '.');
      return pieces.join(' ');
    }

    function resumeFullProfileHandoff(handoff) {
      handoff = handoff || window.FlayvrAmiFullProfile || null;
      if (!handoff || !handoff.profile) return false;
      var record = savedRecord || readSaved();
      awaitingResume = false;
      if (record) applySaved(record);
      clearChat();
      renderMemory();
      state.menu = [];
      save();

      var p = numericTasteProfile(handoff.profile);
      var first = String(handoff.profile.firstName || state.name || '').trim();
      var profileName = String(handoff.profile.name || 'your Full Taste Profile').trim();
      addMessage('I’ve got your Full Taste Profile' + (first ? ', ' + first : '') + '. I’ll start from the profile you just completed rather than asking you to explain your taste again.', 'ami');
      if (p) renderTasteAnalysisCard(p);
      var excerpt = fullProfileExcerptCopy(handoff);
      if (excerpt) addMessage(excerpt, 'ami');

      if (firstIncomplete()) {
        window.setTimeout(function () { askStep(); }, 220);
      } else {
        addMessage('I already have everything I need. I’m rebuilding your menu around this profile now.', 'ami');
        buildMenu();
      }
      return true;
    }

    function restoreWorkspaceSavedIfNeeded() {
      if (awaitingResume && savedRecord) {
        applySaved(savedRecord);
        awaitingResume = false;
        renderMemory();
      }
    }

    function ensureWorkspaceGoal(goal) {
      var current = list(state.goal);
      var wanted = cleanText(goal);
      var exists = current.some(function (item) { return cleanText(item) === wanted; });
      if (!exists) current.push(goal);
      state.goal = current;
      markComplete('goal');
    }

    function setDedicatedConversationLock(locked) {
      if (!workspaceMode) return;

      if (locked && !amiScrollLockActive) {
        amiBackgroundScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
        amiBodyStyleSnapshot = {
          position: document.body.style.position,
          top: document.body.style.top,
          left: document.body.style.left,
          right: document.body.style.right,
          width: document.body.style.width,
          overflow: document.body.style.overflow
        };

        document.documentElement.classList.add('flami-overlay-open');
        document.body.classList.add('flami-overlay-open');
        document.body.style.position = 'fixed';
        document.body.style.top = (-amiBackgroundScrollY) + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
        amiScrollLockActive = true;
        return;
      }

      if (!locked && amiScrollLockActive) {
        document.documentElement.classList.remove('flami-overlay-open');
        document.body.classList.remove('flami-overlay-open');

        var snapshot = amiBodyStyleSnapshot || {};
        document.body.style.position = snapshot.position || '';
        document.body.style.top = snapshot.top || '';
        document.body.style.left = snapshot.left || '';
        document.body.style.right = snapshot.right || '';
        document.body.style.width = snapshot.width || '';
        document.body.style.overflow = snapshot.overflow || '';

        amiScrollLockActive = false;
        window.scrollTo({ top: amiBackgroundScrollY, left: 0, behavior: 'auto' });
      }
    }

    function ensureResultsScrollSurface() {
      if (!overlay) return;

      /* The overlay is the sole scroll owner while Ami has the page locked.
         Some desktop Safari builds do not hand wheel/trackpad deltas to this
         fixed overflow container reliably when body is position:fixed. */
      overlay.style.setProperty('overflow-y', 'auto', 'important');
      overlay.style.setProperty('overflow-x', 'hidden', 'important');
      overlay.style.setProperty('height', '100dvh', 'important');
      overlay.style.setProperty('max-height', '100dvh', 'important');
      overlay.style.setProperty('overscroll-behavior', 'contain', 'important');
      overlay.style.setProperty('touch-action', 'pan-y', 'important');
      overlay.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');

      if (overlay.__flayvrDesktopResultsScrollInstalled) return;
      overlay.__flayvrDesktopResultsScrollInstalled = true;

      overlay.addEventListener('wheel', function (event) {
        if (!root.classList.contains('is-open') || !root.classList.contains('is-reviewing')) return;
        if (window.matchMedia('(max-width: 820px)').matches) return;

        var maxScroll = Math.max(0, overlay.scrollHeight - overlay.clientHeight);
        if (maxScroll <= 1) return;

        var delta = Number(event.deltaY || 0);
        if (!delta) return;

        var before = overlay.scrollTop;
        overlay.scrollTop = Math.max(0, Math.min(maxScroll, before + delta));

        if (overlay.scrollTop !== before) {
          event.preventDefault();
        }
      }, { passive: false });

      overlay.addEventListener('keydown', function (event) {
        if (!root.classList.contains('is-reviewing')) return;
        if (['PageDown', 'PageUp', 'Home', 'End'].indexOf(event.key) < 0) return;

        var amount = Math.max(320, Math.round(overlay.clientHeight * 0.82));
        if (event.key === 'PageDown') overlay.scrollTop += amount;
        else if (event.key === 'PageUp') overlay.scrollTop -= amount;
        else if (event.key === 'Home') overlay.scrollTop = 0;
        else if (event.key === 'End') overlay.scrollTop = overlay.scrollHeight;
        event.preventDefault();
      });
    }

    function enterConversationMode() {
      root.classList.remove('is-reviewing');
      syncPortalReviewState();
      setDedicatedConversationLock(true);
    }

    function restoreWorkspaceSnapshot(snapshot) {
      if (!snapshot || !snapshot.state) return false;
      Object.assign(state, blankState(), clone(snapshot.state));
      renderMemory();
      save();
      return true;
    }

    function currentWorkspaceSnapshot() {
      return { state: clone(state), capturedAt: Date.now() };
    }

    function hasUsablePreviousPlan(snapshot) {
      return Boolean(
        snapshot &&
        snapshot.state &&
        Array.isArray(snapshot.state.menu) &&
        snapshot.state.menu.length
      );
    }

    function reviewPreviousWorkspacePlan() {
      if (!restoreWorkspaceSnapshot(workspacePreviousSnapshot)) return false;
      showReview();
      return true;
    }

    function prepareNewOrderState() {
      state.menu = [];
      state.mood = '';
      state.goal = [];

      /* Stable/remembered identity stays. Order-level/reconfirm fields reset. */
      state.completed = list(state.completed).filter(function (id) {
        if (id === 'coverage' || id === 'allergies' || id === 'diet' || id === 'mood') return false;
        if (id === 'dislikes' && !state.dislikesKnown) return false;
        return true;
      });

      state.updatingAllergies = false;
      state.currentStepId = '';
      save();
    }

    function createNewWorkspaceMenu() {
      prepareNewOrderState();
      runThinkingCycle([
        'Keeping what I already know…',
        'Checking what I still need…'
      ], 560).then(function () {
        var missing = firstIncomplete();
        if (missing) {
          addMessage('I’ll keep the useful parts of your profile. I just need anything that’s still missing before I build the new menu.', 'ami');
          askStep();
          return;
        }

        runThinkingCycle([
          'Re-checking this week’s meals…',
          'Building a fresh menu…'
        ], 520).then(buildMenu);
      });
      return true;
    }

    function offerExistingPlanChoice(message, snapshot) {
      workspacePreviousSnapshot = snapshot && snapshot.state ? snapshot : currentWorkspaceSnapshot();
      if (message) addMessage(message, 'ami');
      addActionButtons([
        ['Review previous plan', reviewPreviousWorkspacePlan],
        ['Create a new menu', createNewWorkspaceMenu],
        ['Start fresh', startFresh]
      ]);
      return true;
    }

    function workspaceContinue() {
      try {
        renderMemory();
        save();
        var step = firstIncomplete();
        if (step) {
          setTimeout(askStep, 180);
        } else {
          buildMenu();
        }
      } catch (error) {
        console.error('[Flayvr Ami v27] Workspace continuation failed.', error);
        status.textContent = '';
        addMessage('I couldn’t finish that step just now. Your answers are still saved — please try Plan my week again.', 'ami');
        return false;
      }
      return true;
    }

    function workspaceLovedCount() {
      var taste = readTasteMemory();
      var items = taste.items || {};
      return Object.keys(items).filter(function (key) {
        return items[key] && String(items[key].rating || '') === 'loved';
      }).length;
    }

    function workspaceSurpriseSeed() {
      workspaceSurpriseNames = new Set();
      (Array.isArray(state.menu) ? state.menu : []).forEach(function (item) {
        if (item && item.name) workspaceSurpriseNames.add(cleanText(item.name));
      });

      var taste = readTasteMemory();
      var items = taste.items || {};
      Object.keys(items).forEach(function (key) {
        var item = items[key] || {};
        if (String(item.rating || '') !== 'loved') return;
        var title = cleanText(item.title || item.name || '');
        if (title) workspaceSurpriseNames.add(title);
      });
    }

    function applyWorkspaceShortcut(key) {
      if (!workspaceMode) return false;
      openAmi();
      restoreWorkspaceSavedIfNeeded();
      root.classList.remove('is-reviewing');
      status.textContent = '';

      if (key === 'last-menu') {
        clearChat();
        addMessage('Show me my last menu', 'user');
        if (Array.isArray(state.menu) && state.menu.length) {
          addMessage('Here’s your last saved Ami menu. Availability can change week to week, so I’ll re-check the current library if you make changes.', 'ami');
          showReview();
        } else {
          addMessage('I don’t have a saved Ami menu on this device yet. I can build one now.', 'ami');
          workspaceContinue();
        }
        return true;
      }

      clearChat();
      workspaceSurpriseNames = new Set();

      if (key === 'plan-week') {
        var previousPlanSnapshot = currentWorkspaceSnapshot();
        addMessage('Plan my week', 'user');
        runThinkingCycle(['Thinking about your week…', 'Checking what I already know…'], 560).then(function () {
          if (hasUsablePreviousPlan(previousPlanSnapshot)) {
            offerExistingPlanChoice(
              'I already have a complete plan from last time. Would you like to review that one, or create a fresh menu using what I already know about you?',
              previousPlanSnapshot
            );
            return;
          }
          addMessage('Absolutely. I’ll keep what I already know, use it as context, and only ask for anything that’s actually missing.', 'ami');
          workspaceContinue();
        });
        return true;
      } else if (key === 'higher-protein') {
        prepareNewOrderState();
        addMessage('Make this week higher protein', 'user');
        ensureWorkspaceGoal('Higher protein');
        state.menu = [];
        addMessage('Done. I’ll bias the menu toward meals explicitly suitable for your higher-protein goal, while keeping your dietary rules intact.', 'ami');
      } else if (key === 'lighter') {
        prepareNewOrderState();
        addMessage('Make this week lighter', 'user');
        ensureWorkspaceGoal('Lighter eating');
        state.menu = [];
        addMessage('Done. I’ll lean the week toward lighter meals without throwing away the rest of your Taste profile.', 'ami');
      } else if (key === 'comfort') {
        prepareNewOrderState();
        addMessage('I want comfort food', 'user');
        ensureWorkspaceGoal('Comfort food');
        state.menu = [];
        addMessage('Comfort it is. I’ll keep your saved food rules and favour the warmer, more comforting side of this week’s menu.', 'ami');
      } else if (key === 'favourites') {
        prepareNewOrderState();
        addMessage('Show me my favourites', 'user');
        state.menu = [];
        var loved = workspaceLovedCount();
        if (loved) {
          addMessage('I found ' + loved + ' meal' + (loved === 1 ? '' : 's') + ' you’ve marked Loved on this device. I’ll push those higher when they’re available this week.', 'ami');
        } else {
          addMessage('You haven’t marked any meals Loved on this device yet. I can still build from the rest of your Taste profile.', 'ami');
        }
      } else if (key === 'surprise') {
        prepareNewOrderState();
        addMessage('Surprise me', 'user');
        workspaceSurpriseSeed();
        state.menu = [];
        if (workspaceSurpriseNames.size) {
          addMessage('I’ll keep your dietary rules, but move away from your recent and Loved meals so the next menu feels genuinely different.', 'ami');
        } else {
          addMessage('I don’t have enough previous menu history to avoid yet, so I’ll build something varied from what’s available this week.', 'ami');
        }
      } else {
        return false;
      }

      workspaceContinue();
      return true;
    }

    function applyWorkspacePrompt(value) {
      if (!workspaceMode) return false;
      var textValue = String(value || '').trim();
      if (!textValue) return false;
      var typed = cleanText(textValue);

      if (/\blast menu\b|\bprevious menu\b/.test(typed)) return applyWorkspaceShortcut('last-menu');
      if (/\bfavourites?\b|\bloved\b/.test(typed)) return applyWorkspaceShortcut('favourites');
      if (/\bsurprise\b|\bsomething different\b/.test(typed)) return applyWorkspaceShortcut('surprise');

      openAmi();
      restoreWorkspaceSavedIfNeeded();
      var previousPlanSnapshot = currentWorkspaceSnapshot();
      enterConversationMode();
      clearChat();
      workspaceSurpriseNames = new Set();
      addMessage(textValue, 'user');

      var changed = false;

      var people = matchPeople(textValue);
      if (people) {
        state.people = people;
        markComplete('people');
        changed = true;
      }

      var coverage = matchCoverage(textValue);
      if (coverage) {
        state.coverage = coverage;
        markComplete('coverage');
        changed = true;
      }

      if (/\bvegan\b/.test(typed)) {
        state.diet = ['Vegan']; markComplete('diet'); changed = true;
      } else if (/\bvegetarian\b/.test(typed)) {
        state.diet = ['Vegetarian']; markComplete('diet'); changed = true;
      } else if (/\bpescatarian\b/.test(typed)) {
        state.diet = ['Pescatarian']; markComplete('diet'); changed = true;
      }

      if (/\bgluten[- ]?free\b/.test(typed)) {
        state.diet = list(state.diet).filter(function (item) { return cleanText(item) !== 'gluten free'; });
        state.diet.push('Gluten-free'); markComplete('diet'); changed = true;
      }
      if (/\bdairy[- ]?free\b/.test(typed)) {
        state.diet = list(state.diet).filter(function (item) { return cleanText(item) !== 'dairy free'; });
        state.diet.push('Dairy-free'); markComplete('diet'); changed = true;
      }

      if (/\b(steady|balanced week|keep me steady)\b/.test(typed)) { state.mood = 'Keep me steady'; markComplete('mood'); changed = true; }
      else if (/\b(feel lighter|lighter week|something lighter)\b/.test(typed)) { state.mood = 'Feel lighter'; markComplete('mood'); changed = true; }
      else if (/\b(comfort|comforting)\b/.test(typed)) { state.mood = 'More comforting'; markComplete('mood'); changed = true; }
      else if (/\b(energising|energizing|more energy)\b/.test(typed)) { state.mood = 'More energising'; markComplete('mood'); changed = true; }
      else if (/\b(interesting|adventurous|surprise me)\b/.test(typed)) { state.mood = 'Keep it interesting'; markComplete('mood'); changed = true; }
      else if (/\b(make life easy|easy week|less decision)\b/.test(typed)) { state.mood = 'Make life easy'; markComplete('mood'); changed = true; }

      if (/\bextra[ -]?hot\b/.test(typed)) { state.spice = 'Extra Hot'; markComplete('spice'); changed = true; }
      else if (/\bhot\b/.test(typed)) { state.spice = 'Hot'; markComplete('spice'); changed = true; }
      else if (/\bmedium\b|\bmild\b/.test(typed)) { state.spice = 'Medium'; markComplete('spice'); changed = true; }

      if (/\bprotein\b/.test(typed)) { ensureWorkspaceGoal('Higher protein'); changed = true; }
      if (/\blighter\b|\blight eating\b/.test(typed)) { ensureWorkspaceGoal('Lighter eating'); changed = true; }
      if (/\bcomfort\b|\bcomforting\b/.test(typed)) { ensureWorkspaceGoal('Comfort food'); changed = true; }
      if (/\bgut[- ]?friendly\b|\bgut\b/.test(typed)) { ensureWorkspaceGoal('Gut-friendly meals'); changed = true; }
      if (/\bsteady energy\b|\benergy\b/.test(typed)) { ensureWorkspaceGoal('Steady energy'); changed = true; }
      if (/\bless decision\b|\beasy week\b/.test(typed)) { ensureWorkspaceGoal('Less decision-making'); changed = true; }

      if (changed) state.menu = [];
      save();

      runThinkingCycle([
        'Thinking about what you need…',
        'Checking it against what I already know…'
      ], 560).then(function () {
        if (hasUsablePreviousPlan(previousPlanSnapshot)) {
          var returningCopy = changed
            ? 'I’ve understood that and updated the direction for your next menu. You also have a previous plan saved — would you like to review it, or create a fresh menu with what you’ve just told me?'
            : 'I already have a previous plan saved for you. Would you like to review that plan, or create a fresh menu using what I already know?';
          offerExistingPlanChoice(returningCopy, previousPlanSnapshot);
          return;
        }

        addMessage(
          changed
            ? 'Got it. I’ve already folded the useful parts of that into your food profile. I’ll only ask for anything I still need before I build the week.'
            : 'Got it. I’ll turn that into a few quick essentials, then build from what Flayvr’s chefs are actually cooking this week.',
          'ami'
        );
        workspaceContinue();
      });
      return true;
    }

    send.addEventListener('click', submitText);
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        submitText();
      }
    });

    function importedTasteProfile(raw) {
      var source = raw && raw.profile ? raw.profile : raw;
      if (!source || typeof source !== 'object') return null;
      var aliases = {adv:['adv','adventure','tasteAdventure'],heat:['heat','tasteHeat'],intensity:['intensity','tasteIntensity'],acid:['acid','acidity','tasteAcid'],texture:['texture','tasteTexture'],sweet:['sweet','sweetness','tasteSweet']};
      var profile={};
      Object.keys(aliases).forEach(function(key){var found;aliases[key].some(function(alias){if(source[alias]!=null&&source[alias]!==''){found=Number(source[alias]);return true;}return false;});profile[key]=found;});
      if(!TASTE_DIMENSIONS.every(function(key){return Number.isFinite(profile[key])&&profile[key]>=0&&profile[key]<=100;}))return null;
      profile.firstName=state.name||String(source.firstName||source.name||'');profile.name=String(source.name||'Imported Taste Test');profile.key=String(source.key||'ami-upload-'+Date.now());return profile;
    }
    function parseTasteCsv(text){var lines=String(text||'').trim().split(/\r?\n/).filter(Boolean);if(lines.length<2)return null;var headers=lines[0].split(',').map(function(x){return x.trim();});var values=lines[1].split(',').map(function(x){return x.trim();});var row={};headers.forEach(function(h,i){row[h]=values[i];});return importedTasteProfile(row);}
    function saveImportedTasteProfile(profile){var history=safeJsonStorage(TASTE_PROFILE_HISTORY_KEY,[]);if(!Array.isArray(history))history=[];history.unshift({profile:profile,completedAt:Date.now(),source:'ami_upload'});localStorage.setItem(TASTE_PROFILE_HISTORY_KEY,JSON.stringify(history.slice(0,20)));}
    function decodePdfStringLiteral(value){return String(value||'').replace(/\\([()\\])/g,'$1').replace(/\\n/g,'\n').replace(/\\r/g,'\r').replace(/\\t/g,'\t').replace(/\\([0-7]{1,3})/g,function(_,oct){return String.fromCharCode(parseInt(oct,8));});}
    function pdfBase64Bytes(token){try{var value=String(token||'').replace(/-/g,'+').replace(/_/g,'/');while(value.length%4)value+='=';var raw=atob(value),out=new Uint8Array(raw.length);for(var i=0;i<raw.length;i++)out[i]=raw.charCodeAt(i);return out;}catch(error){return null;}}
    function decodeTasteProfileToken(token){try{var a=pdfBase64Bytes(token);if(!a||a.length<9)return null;var firstName='';if(a[0]===4&&a[1]<4){var len=a[9];if(a.length!==11+len)return null;var check=0;for(var i=0;i<a.length-1;i++)check^=a[i];if(check!==a[a.length-1])return null;try{firstName=new TextDecoder().decode(a.slice(10,10+len));}catch(error){}return {key:['explorer','tastemaker','purist','classic'][a[1]],name:['The Explorer','The Tastemaker','The Purist','The Classic'][a[1]],firstName:firstName,adv:a[2],heat:a[3],intensity:a[4],acid:a[5],texture:a[6],sweet:a[7]};}if(a[0]===3&&a.length===10&&a[1]<4){var c3=0;for(var j=0;j<9;j++)c3^=a[j];if(c3!==a[9])return null;return {key:['explorer','tastemaker','purist','classic'][a[1]],name:['The Explorer','The Tastemaker','The Purist','The Classic'][a[1]],firstName:'',adv:a[2],heat:a[3],intensity:a[4],acid:a[5],texture:a[6],sweet:a[7]};}if(a[0]===2&&a.length===9&&a[1]<4){var c2=0;for(var k=0;k<8;k++)c2^=a[k];if(c2!==a[8])return null;return {key:['explorer','tastemaker','purist','classic'][a[1]],name:['The Explorer','The Tastemaker','The Purist','The Classic'][a[1]],firstName:'',adv:a[2],heat:a[3],intensity:a[4],acid:a[5],texture:a[6],sweet:a[7]};}}catch(error){}return null;}
    function decodeDiningToken(token){try{var a=pdfBase64Bytes(token);if(!a||a.length!==7||a[0]!==2)return null;var c=0;for(var i=0;i<6;i++)c^=a[i];if(c!==a[6])return null;return {menu:a[1],energy:a[2],theatre:a[3],formal:a[4],travel:a[5]};}catch(error){return null;}}
    function diningStyleName(d){if(!d)return 'Balanced & flexible';if(d.menu>70&&d.theatre>65&&d.formal<65)return 'Immersive, not stiff';if(d.formal>70)return 'Occasion-led';if(d.energy<40)return 'Quietly ambitious';if(d.energy>75&&d.theatre>75)return 'High-energy explorer';return 'Balanced & flexible';}
    function embeddedPayloadFromRawPdf(raw){var marker='FLAYVR_TASTE_PROFILE=',start=String(raw||'').indexOf(marker);if(start<0)return null;try{start+=marker.length;var end=start;while(end<raw.length&&/[A-Za-z0-9_-]/.test(raw.charAt(end)))end+=1;var token=raw.slice(start,end);if(!token)return null;var normal=token.replace(/-/g,'+').replace(/_/g,'/');while(normal.length%4)normal+='=';var decoded=decodeURIComponent(Array.prototype.map.call(atob(normal),function(c){return '%'+('00'+c.charCodeAt(0).toString(16)).slice(-2);}).join(''));var value=JSON.parse(decoded);return value&&typeof value==='object'?value:null;}catch(error){return null;}}
    function fullProfilePayloadFromPdfLink(raw){try{var re=/\/URI\s*\((https?:\/\/(?:\\.|[^\\)])+)\)/g,match;while((match=re.exec(String(raw||'')))){var uri=decodePdfStringLiteral(match[1]);if(uri.indexOf('from=full-profile')<0)continue;var u=new URL(uri),profile=decodeTasteProfileToken(u.searchParams.get('p')||''),dining=decodeDiningToken(u.searchParams.get('fp')||'');if(profile&&dining)return {v:1,source:'full_taste_profile_pdf_link',profile:profile,dining:dining,insights:{archetype:diningStyleName(dining)}};}return null;}catch(error){return null;}}
    function saveImportedFullProfilePayload(raw){try{if(!raw||typeof raw!=='object')return;var profile=importedTasteProfile(raw),d=raw.dining;if(!profile||!d)return;var dining={menu:Number(d.menu),energy:Number(d.energy),theatre:Number(d.theatre),formal:Number(d.formal!=null?d.formal:d.formality),travel:Number(d.travel!=null?d.travel:d.destination_appetite)};if(!['menu','energy','theatre','formal','travel'].every(function(k){return Number.isFinite(dining[k])&&dining[k]>=0&&dining[k]<=100;}))return;var payload={v:1,source:String(raw.source||'ami_pdf_upload'),createdAt:Date.now(),completedAt:Date.now(),profile:{key:String(profile.key||''),name:String(profile.name||''),firstName:String(profile.firstName||''),adv:Number(profile.adv),heat:Number(profile.heat),intensity:Number(profile.intensity),acid:Number(profile.acid),texture:Number(profile.texture),sweet:Number(profile.sweet)},dining:dining,insights:raw.insights&&typeof raw.insights==='object'?raw.insights:{archetype:diningStyleName(dining)}};localStorage.setItem('flayvr_ami_full_profile_handoff_v1',JSON.stringify(payload));window.FlayvrAmiFullProfile=payload;}catch(error){}}
    function installComposerUpload(){var composer=root.querySelector('.flami-composer');if(!composer||composer.querySelector('[data-ami-upload-plus]'))return;var plus=document.createElement('button');plus.type='button';plus.className='flami-upload-plus';plus.setAttribute('data-ami-upload-plus','');plus.setAttribute('aria-label','Add to Ami');plus.setAttribute('aria-expanded','false');plus.textContent='+';var menu=document.createElement('div');menu.className='flami-upload-menu';menu.hidden=true;menu.innerHTML='<button type="button" data-ami-upload-taste><strong>Upload Taste Profile PDF</strong><span>Taste Test or Full Profile — Ami will read the profile</span></button>';var file=document.createElement('input');file.type='file';file.accept='.pdf,application/pdf';file.hidden=true;composer.insertBefore(plus,input);composer.appendChild(menu);composer.appendChild(file);plus.addEventListener('click',function(){var opening=menu.hidden;menu.hidden=!opening;plus.setAttribute('aria-expanded',opening?'true':'false');});menu.querySelector('[data-ami-upload-taste]').addEventListener('click',function(){menu.hidden=true;plus.setAttribute('aria-expanded','false');file.click();});file.addEventListener('change',function(){
        var selected=file.files&&file.files[0];
        if(!selected)return;
        var lowerName=selected.name.toLowerCase();
        if(!lowerName.endsWith('.pdf')){
          addMessage('Please upload your Taste Test as a PDF.','ami');
          file.value='';
          return;
        }

        addMessage('I’ve uploaded my Taste Profile PDF','user');

        function decodePdfLiteral(value) {
          return String(value || '')
            .replace(/\\([()\\])/g, '$1')
            .replace(/\\n/g, '\n')
            .replace(/\\r/g, '\r')
            .replace(/\\t/g, '\t')
            .replace(/\\([0-7]{1,3})/g, function (_, oct) { return String.fromCharCode(parseInt(oct, 8)); });
        }

        function pdfLiteralStrings(buffer) {
          var bytes = new Uint8Array(buffer);
          var text = '';
          var chunk = 32768;
          for (var i = 0; i < bytes.length; i += chunk) {
            text += String.fromCharCode.apply(null, bytes.subarray(i, Math.min(i + chunk, bytes.length)));
          }
          var values = [];
          var re = /\(((?:\\.|[^\\)])*)\)\s*Tj/g;
          var match;
          while ((match = re.exec(text))) values.push(decodePdfLiteral(match[1]).trim());
          return { raw: text, strings: values.filter(Boolean) };
        }

        function tasteProfileFromVisiblePdf(buffer) {
          var parsed = pdfLiteralStrings(buffer);
          var values = parsed.strings;
          if (!values.length) return null;

          var axes = { ADVENTURE: 'adv', HEAT: 'heat', INTENSITY: 'intensity', ACID: 'acid', TEXTURE: 'texture', SWEET: 'sweet' };
          var profile = {};
          Object.keys(axes).forEach(function (label) {
            for (var i = 1; i < values.length; i += 1) {
              if (String(values[i]).toUpperCase() !== label) continue;
              var previous = Number(values[i - 1]);
              if (Number.isFinite(previous) && previous >= 0 && previous <= 100) {
                profile[axes[label]] = previous;
                break;
              }
              if (i + 1 < values.length) {
                var next = Number(values[i + 1]);
                if (Number.isFinite(next) && next >= 0 && next <= 100) {
                  profile[axes[label]] = next;
                  break;
                }
              }
            }
          });

          if (!TASTE_DIMENSIONS.every(function (key) { return Number.isFinite(profile[key]); })) return null;

          var persona = '';
          values.some(function (value) {
            var match = String(value).match(/^The\s+(.+?)\.?$/i);
            if (!match) return false;
            persona = match[1].trim();
            return true;
          });
          var owner = '';
          var ownerIndex = values.findIndex(function (value) { return String(value).toUpperCase() === 'PROFILE OWNER'; });
          if (ownerIndex >= 0 && values[ownerIndex + 1]) owner = values[ownerIndex + 1];
          if (!owner) {
            var intro = values.find(function (value) { return /,\s*you['’]re$/i.test(value); });
            if (intro) owner = intro.replace(/,\s*you['’]re$/i, '').trim();
          }

          profile.firstName = state.name || owner || '';
          profile.name = persona ? 'The ' + persona : 'Taste Profile';
          profile.key = 'ami-pdf-' + Date.now();
          profile.source = 'taste_test_pdf';
          return profile;
        }

        function pdfJpegImages(buffer) {
          var bytes = new Uint8Array(buffer);
          var images = [];
          for (var i = 0; i < bytes.length - 1; i += 1) {
            if (bytes[i] !== 0xFF || bytes[i + 1] !== 0xD8) continue;
            var end = -1;
            for (var j = i + 2; j < bytes.length - 1; j += 1) {
              if (bytes[j] === 0xFF && bytes[j + 1] === 0xD9) {
                end = j + 2;
                break;
              }
            }
            if (end > i) {
              images.push(bytes.slice(i, end));
              i = end - 1;
            }
          }
          return images;
        }

        function isFlayvrRedPixel(r, g, b) {
          return r >= 145 && r > g * 1.55 && r > b * 1.35 && g <= 125 && b <= 135;
        }

        function longestRun(values) {
          var best = null;
          var start = -1;
          for (var i = 0; i <= values.length; i += 1) {
            var on = i < values.length && values[i];
            if (on && start < 0) start = i;
            if (!on && start >= 0) {
              var run = { start: start, end: i - 1, length: i - start };
              if (!best || run.length > best.length) best = run;
              start = -1;
            }
          }
          return best;
        }

        function detectFlayvrTasteSignature(canvas) {
          var ctx = canvas.getContext('2d', { willReadFrequently: true });
          var width = canvas.width;
          var height = canvas.height;
          var data = ctx.getImageData(0, 0, width, height).data;
          var x0 = Math.floor(width * 0.50);
          var x1 = Math.floor(width * 0.90);
          var minRun = Math.max(70, Math.floor(width * 0.07));
          var rowGroups = [];

          for (var y = Math.floor(height * 0.15); y < Math.floor(height * 0.52); y += 1) {
            var redFlags = new Array(x1 - x0);
            var greyFlags = new Array(x1 - x0);

            for (var x = x0; x < x1; x += 1) {
              var o = (y * width + x) * 4;
              var r = data[o], g = data[o + 1], b = data[o + 2];
              var spread = Math.max(r, g, b) - Math.min(r, g, b);
              var mid = (r + g + b) / 3;
              redFlags[x - x0] = isFlayvrRedPixel(r, g, b);
              greyFlags[x - x0] = spread <= 20 && mid >= 175 && mid <= 235;
            }

            var redRun = longestRun(redFlags);
            var greyRun = longestRun(greyFlags);
            var redLength = redRun ? redRun.length : 0;
            var greyLength = greyRun ? greyRun.length : 0;

            // A Taste Signature row is a long horizontal red/grey track.
            if (Math.max(redLength, greyLength) < minRun) continue;

            var row = {
              y: y,
              red: redRun ? { start: x0 + redRun.start, end: x0 + redRun.end, length: redRun.length } : null,
              grey: greyRun ? { start: x0 + greyRun.start, end: x0 + greyRun.end, length: greyRun.length } : null
            };

            if (!rowGroups.length || y - rowGroups[rowGroups.length - 1][rowGroups[rowGroups.length - 1].length - 1].y > 12) {
              rowGroups.push([row]);
            } else {
              rowGroups[rowGroups.length - 1].push(row);
            }
          }

          var groups = rowGroups.map(function (rows) {
            return rows.reduce(function (best, row) {
              var bestScore = Math.max(best && best.red ? best.red.length : 0, best && best.grey ? best.grey.length : 0);
              var rowScore = Math.max(row.red ? row.red.length : 0, row.grey ? row.grey.length : 0);
              return !best || rowScore > bestScore ? row : best;
            }, null);
          });

          if (groups.length < 6) return null;

          // The Taste Signature page contains other horizontal rules. Choose the
          // contiguous run of six long rows with the most regular spacing.
          var bestRun = null;
          for (var runStart = 0; runStart <= groups.length - 6; runStart += 1) {
            var spacings = [];
            for (var si = 1; si < 6; si += 1) spacings.push(groups[runStart + si].y - groups[runStart + si - 1].y);
            var orderedSpacing = spacings.slice().sort(function (a, b) { return a - b; });
            var medianSpacing = orderedSpacing[Math.floor(orderedSpacing.length / 2)];
            var errorSum = spacings.reduce(function (sum, value) { return sum + Math.abs(value - medianSpacing); }, 0);
            if (medianSpacing < 45 || medianSpacing > 140) continue;
            var candidate = { start: runStart, spacing: medianSpacing, error: errorSum };
            if (!bestRun || candidate.error < bestRun.error || (candidate.error === bestRun.error && candidate.spacing < bestRun.spacing)) bestRun = candidate;
          }
          if (!bestRun) return null;
          groups = groups.slice(bestRun.start, bestRun.start + 6);

          var trackStarts = groups.map(function (group) {
            var values = [];
            if (group.red) values.push(group.red.start);
            if (group.grey) values.push(group.grey.start);
            return Math.min.apply(Math, values);
          }).sort(function (a, b) { return a - b; });

          var trackEnds = groups.map(function (group) {
            var values = [];
            if (group.red) values.push(group.red.end);
            if (group.grey) values.push(group.grey.end);
            return Math.max.apply(Math, values);
          }).sort(function (a, b) { return a - b; });

          var trackStart = trackStarts[Math.floor(trackStarts.length / 2)];
          var trackEnd = trackEnds[Math.floor(trackEnds.length / 2)];
          var trackWidth = trackEnd - trackStart + 1;
          if (!Number.isFinite(trackWidth) || trackWidth < width * 0.15) return null;

          var rawScores = groups.map(function (group) {
            if (!group.red) return 0;
            var score = ((group.red.end - trackStart + 1) / trackWidth) * 100;
            return Math.max(0, Math.min(100, Math.round(score)));
          });

          var profile = {
            adv: rawScores[0],
            heat: rawScores[1],
            intensity: rawScores[2],
            acid: rawScores[3],
            texture: rawScores[4],
            sweet: rawScores[5],
            source: 'taste_test_pdf_rendered_signature'
          };

          return TASTE_DIMENSIONS.every(function (key) { return Number.isFinite(profile[key]); }) ? profile : null;
        }

        function loadJpegImage(bytes) {
          return new Promise(function (resolve, reject) {
            var blob = new Blob([bytes], { type: 'image/jpeg' });
            var url = URL.createObjectURL(blob);
            var image = new Image();
            image.onload = function () { URL.revokeObjectURL(url); resolve(image); };
            image.onerror = function () { URL.revokeObjectURL(url); reject(new Error('legacy_pdf_image_decode_failed')); };
            image.src = url;
          });
        }

        function profileFromRenderedLegacyPdf(buffer) {
          var images = pdfJpegImages(buffer);
          if (!images.length) return Promise.resolve(null);

          function tryImage(index) {
            if (index >= images.length) return Promise.resolve(null);
            return loadJpegImage(images[index]).then(function (image) {
              var canvas = document.createElement('canvas');
              canvas.width = image.naturalWidth || image.width;
              canvas.height = image.naturalHeight || image.height;
              var context = canvas.getContext('2d', { alpha: false });
              context.drawImage(image, 0, 0);
              return detectFlayvrTasteSignature(canvas) || tryImage(index + 1);
            }).catch(function () {
              return tryImage(index + 1);
            });
          }

          // Page 2 is the stable Taste Signature page, but try all embedded images
          // so historical exports with reordered page objects remain compatible.
          return tryImage(0);
        }

        function profileFromPdfBytes(buffer) {
          /* Full Profile PDFs are image-led, so visible-text extraction is not reliable.
             Preserve the existing marker/link/text paths first.
             Only if those fail do we render the embedded legacy JPEG page image and
             recover the six stable Flayvr Taste Signature bars. */
          var parsed = pdfLiteralStrings(buffer);
          var fullPayload = embeddedPayloadFromRawPdf(parsed.raw) || fullProfilePayloadFromPdfLink(parsed.raw);
          if (fullPayload) {
            var embedded = importedTasteProfile(fullPayload);
            if (embedded) {
              saveImportedFullProfilePayload(fullPayload);
              embedded.source = 'full_profile_pdf';
              return embedded;
            }
          }
          var visible = tasteProfileFromVisiblePdf(buffer);
          if (visible) return visible;
          return profileFromRenderedLegacyPdf(buffer);
        }

        var reader=new FileReader();
        reader.onload=function(){
          runThinkingCycle([
            'Reading your Taste Profile…',
            'Analysing your flavour profile…',
            'Reasoning across this week’s menu…'
          ], 820).then(function(){
            return Promise.resolve(profileFromPdfBytes(reader.result)).then(function(profile){
              if(!profile)throw new Error('Taste Profile fields not found');
              saveImportedTasteProfile(profile);

              var labels={adv:'adventure',heat:'heat',intensity:'intensity',acid:'acidity',texture:'texture',sweet:'sweetness'};
              var ranked=Object.keys(labels).sort(function(a,b){return Number(profile[b]||0)-Number(profile[a]||0);});
              var strongest=ranked.slice(0,3).map(function(key){return labels[key];});
              var lowest=labels[ranked[ranked.length-1]];
              addMessage('I’ve got it. ' + (tasteProfileDisplayName(profile) !== 'Taste Profile' ? 'You’re ' + tasteProfileDisplayName(profile) + '. ' : '') + 'Your strongest taste signals are ' + strongest.join(', ') + ', while ' + lowest + ' sits much lower. I’m using that to shape this week around the flavours most likely to land for you.', 'ami');
              renderTasteAnalysisCard(profile);

              return runThinkingCycle([
                'Matching meals to your taste…',
                'Checking your dietary rules…',
                'Finalising your week…'
              ], 760).then(function(){
                state.menu=[];
                save();
                if(firstIncomplete()){
                  addMessage('I’ve saved what I learned from your Taste Profile. I just need the remaining details before I build the week.', 'ami');
                  askStep();
                } else {
                  addMessage('I’ve found the strongest matches. I’m rebuilding your menu now.', 'ami');
                  buildMenu();
                }
              });
            });
          }).catch(function(){
            addMessage('I can open that PDF, but I can’t confidently read a Flayvr Taste Profile from it. Try downloading a fresh Taste Profile PDF and upload it here.', 'ami');
          }).finally(function(){
            file.value='';
          });
        };
        reader.readAsArrayBuffer(selected);
      });document.addEventListener('click',function(event){if(menu.hidden||composer.contains(event.target))return;menu.hidden=true;plus.setAttribute('aria-expanded','false');});}
    installComposerUpload();

    /* Homepage composer parity bridge. It deliberately reuses the existing
       Ami workspace prompt path and existing PDF upload/parser. */
    if (homeComposer && homeInput && homeSend) {
      function submitHomeComposer() {
        var value = String(homeInput.value || '').trim();
        if (!value) return;
        homeInput.value = '';
        applyWorkspacePrompt(value);
      }

      homeSend.addEventListener('click', submitHomeComposer);
      homeInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          submitHomeComposer();
        }
      });

      if (homePlus && homeAddMenu) {
        homePlus.addEventListener('click', function () {
          var opening = homeAddMenu.hidden;
          homeAddMenu.hidden = !opening;
          homePlus.setAttribute('aria-expanded', opening ? 'true' : 'false');
        });

        document.addEventListener('click', function (event) {
          if (homeAddMenu.hidden || homeComposer.contains(event.target)) return;
          homeAddMenu.hidden = true;
          homePlus.setAttribute('aria-expanded', 'false');
        });
      }

      if (homeAddTaste) {
        homeAddTaste.addEventListener('click', function () {
          if (homeAddMenu) homeAddMenu.hidden = true;
          if (homePlus) homePlus.setAttribute('aria-expanded', 'false');
          openAmi();
          var existingPdfInput = overlay.querySelector('.flami-composer input[type="file"][accept*="pdf"]');
          if (existingPdfInput) existingPdfInput.click();
        });
      }
    }

    /* Dedicated Ami landing + button. Reuse the existing shared PDF
       input/parser so homepage and /pages/amyai behave identically. */
    var pageComposer = root.querySelector('[data-ami-page-composer]');
    var pagePlus = root.querySelector('[data-ami-page-plus]');
    var pageAddMenu = root.querySelector('[data-ami-page-add-menu]');
    var pageAddTaste = root.querySelector('[data-ami-page-add-taste]');

    if (pageComposer && pagePlus && pageAddMenu) {
      pagePlus.addEventListener('click', function () {
        var opening = pageAddMenu.hidden;
        pageAddMenu.hidden = !opening;
        pagePlus.setAttribute('aria-expanded', opening ? 'true' : 'false');
      });

      document.addEventListener('click', function (event) {
        if (pageAddMenu.hidden || pageComposer.contains(event.target)) return;
        pageAddMenu.hidden = true;
        pagePlus.setAttribute('aria-expanded', 'false');
      });

      if (pageAddTaste) {
        pageAddTaste.addEventListener('click', function () {
          pageAddMenu.hidden = true;
          pagePlus.setAttribute('aria-expanded', 'false');
          openAmi();
          var existingPdfInput = overlay.querySelector('.flami-composer input[type="file"][accept*="pdf"]');
          if (existingPdfInput) existingPdfInput.click();
        });
      }
    }

    memoryToggle.addEventListener('click', function () {
      var open = memory.classList.toggle('is-open');
      memoryToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      memoryToggle.querySelector('.flami-memory-toggle').textContent = open ? '−' : '+';
    });

    review.querySelector('[data-ami-change-plan]').addEventListener('click', editCoverage);
    review.querySelector('[data-ami-back-chat]').addEventListener('click', restartEditing);
    memory.querySelector('[data-ami-edit-memory]').addEventListener('click', restartEditing);
    memory.querySelector('[data-ami-clear-memory]').addEventListener('click', reset);
    review.querySelector('[data-ami-pdf]').addEventListener('click', downloadPdf);
    review.querySelector('[data-ami-checkout]').addEventListener('click', checkout);

    function measureSiteHeaderClearance() {
      var selectors = [
        'sticky-header',
        '#shopify-section-header',
        '.shopify-section-group-header-group',
        '[data-section-type="header"]',
        '.header-wrapper',
        '.site-header',
        '.flayvr-header',
        '.pill-header'
      ];
      var seen = new Set();
      var bottom = 0;

      selectors.forEach(function (selector) {
        Array.prototype.forEach.call(document.querySelectorAll(selector), function (element) {
          if (!element || seen.has(element) || root.contains(element)) return;
          seen.add(element);

          var style = window.getComputedStyle(element);
          var rect = element.getBoundingClientRect();
          if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return;
          if (rect.width < 120 || rect.height < 24) return;
          if (rect.bottom <= 0 || rect.top > 50) return;

          bottom = Math.max(bottom, rect.bottom);
        });
      });

      var fallback = window.matchMedia('(max-width: 820px)').matches ? 78 : 94;
      return Math.max(0, Math.min(180, Math.ceil(bottom || fallback)));
    }

    function syncSiteHeaderClearance() {
      root.style.setProperty('--ami-site-header-clearance', measureSiteHeaderClearance() + 'px');
    }

    function openAmi() {
      syncSiteHeaderClearance();
      mountAmiPortal();
      root.classList.add('is-open');
      syncPortalReviewState();
      overlay.setAttribute('aria-hidden', 'false');

      if (workspaceMode) {
        root.classList.add('is-workspace-chatting');
        setDedicatedConversationLock(true);
        if (root.classList.contains('is-reviewing')) ensureResultsScrollSurface();
      } else {
        document.documentElement.classList.add('flami-overlay-open');
        document.body.classList.add('flami-overlay-open');
      }

      window.setTimeout(function () {
        var target = root.classList.contains('is-reviewing')
          ? review.querySelector('[data-ami-change-plan]')
          : input;
        if (target) target.focus({ preventScroll: true });
      }, 180);
    }

    function closeAmi() {
      root.classList.remove('is-open');
      root.classList.remove('is-workspace-chatting');
      overlay.setAttribute('aria-hidden', 'true');

      if (workspaceMode) {
        setDedicatedConversationLock(false);
      } else {
        document.documentElement.classList.remove('flami-overlay-open');
        document.body.classList.remove('flami-overlay-open');
      }

      unmountAmiPortal();
      if (launch && !workspaceMode) launch.focus({ preventScroll: true });
    }

    launch.addEventListener('click', openAmi);
    window.addEventListener('resize', syncSiteHeaderClearance, { passive: true });
    var closeControl = overlay.querySelector('[data-ami-close]');
    if (closeControl) closeControl.addEventListener('click', closeAmi);
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closeAmi();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) closeAmi();
    });

    var publicApi = {
      version: VERSION,
      asset: 'flayvr-ami-final-v27-9.js (logic 2.24.0)',
      pdfTemplate: 'ami-standard-results-v1',
      pdfEngine: 'flayvr-ami-pdf-v1',
      pdfDelivery: 'real-pdf-no-print',
      getState: function () { return clone(state); },
      clearMemory: function () { clearSaved(); return true; },
      open: openAmi,
      close: closeAmi,
      startFresh: function () { startFresh(); openAmi(); return true; },
      workspacePrompt: applyWorkspacePrompt,
      workspaceShortcut: applyWorkspaceShortcut,
      resumeFullProfile: function (handoff) { return resumeFullProfileHandoff(handoff); },
      exportLibraryCsv: function () {
        var rows = parseLibrary();
        var headers = ['id', 'handle', 'name', 'display_name', 'base_meal_key', 'version_code', 'version_label', 'adapted', 'generated_variant', 'variant_approved', 'kitchen_instruction', 'meal_type', 'active', 'available', 'image_present', 'image_url', 'diet', 'ingredients', 'allergens', 'plan', 'priority', 'calories', 'protein', 'taste_adventure', 'taste_heat', 'taste_intensity', 'taste_acid', 'taste_texture', 'taste_sweet', 'taste_match'];
        var lines = [headers.join(',')];

        function csv(value) {
          var text = String(value == null ? '' : value);
          return /[",\n\r]/.test(text) ? '"' + text.replace(/"/g, '""') + '"' : text;
        }

        rows.forEach(function (meal) {
          var row = {
            id: meal.id,
            handle: meal.handle,
            name: meal.name,
            display_name: displayMealName(meal),
            base_meal_key: mealFamilyKey(meal),
            version_code: meal.versionCode,
            version_label: meal.versionLabel,
            adapted: meal.adapted,
            generated_variant: Boolean(meal.generatedVariant),
            variant_approved: meal.variantApproved,
            kitchen_instruction: meal.kitchenInstruction,
            meal_type: typeOf(meal),
            active: meal.active,
            available: meal.available,
            image_present: Boolean(meal.image),
            image_url: meal.image,
            diet: meal.diet.join('; '),
            ingredients: meal.ingredients.join('; '),
            allergens: meal.allergens.join('; '),
            plan: meal.plan.join('; '),
            priority: meal.priority,
            calories: meal.calories,
            protein: meal.protein,
            taste_adventure: meal.tasteAdventure || '',
            taste_heat: meal.tasteHeat || '',
            taste_intensity: meal.tasteIntensity || '',
            taste_acid: meal.tasteAcid || '',
            taste_texture: meal.tasteTexture || '',
            taste_sweet: meal.tasteSweet || '',
            taste_match: tasteMatchForMeal(meal, state.name) == null ? '' : tasteMatchForMeal(meal, state.name)
          };
          lines.push(headers.map(function (header) { return csv(row[header]); }).join(','));
        });

        var blob = new Blob([lines.join('\r\n')], { type: 'text/csv;charset=utf-8' });
        var url = URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = url;
        link.download = 'Flayvr-Ami-Library-Audit-' + new Date().toISOString().slice(0, 10) + '.csv';
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
        return rows;
      },
      libraryDiagnostics: function () {
        return libraryDiagnostics();
      },
      eligibilityDiagnostics: function (slot) {
        if (slot) return eligibilityDiagnostics(String(slot), parseLibrary());
        return {
          Breakfast: eligibilityDiagnostics('Breakfast', parseLibrary()),
          Lunch: eligibilityDiagnostics('Lunch', parseLibrary()),
          Dinner: eligibilityDiagnostics('Dinner', parseLibrary()),
          Snack: eligibilityDiagnostics('Snack', parseLibrary())
        };
      },
      tasteProfileDiagnostics: function () {
        return clone(readTasteProfileContext(state.name));
      },
      tasteMatchForMeal: function (name) {
        var wanted = cleanText(name || '');
        var meal = parseLibrary().find(function (item) { return cleanText(item.name) === wanted || cleanText(item.handle) === wanted; });
        if (!meal) return null;
        return { name: meal.name, match: tasteMatchForMeal(meal, state.name), vector: clone(mealTasteVector(meal)) };
      },
      tasteCoverageAudit: function () {
        var library = parseLibrary();
        var context = readTasteProfileContext(state.name);
        var bySlot = {};
        ['Breakfast', 'Lunch', 'Dinner', 'Snack'].forEach(function (slot) {
          var safe = library.filter(function (meal) {
            return supportsSlot(meal, slot) && planAllows(meal) && matchesDiet(meal) && matchesAllergies(meal) && matchesTaste(meal);
          });
          var vectorised = safe.filter(function (meal) { return Boolean(mealTasteVector(meal)); });
          var matches = vectorised.map(function (meal) { return tasteMatchForMeal(meal, state.name); }).filter(function (n) { return n != null; });
          bySlot[slot] = {
            safe: safe.length,
            vectorised: vectorised.length,
            vectorCoveragePct: safe.length ? Math.round(vectorised.length / safe.length * 100) : 0,
            match80Plus: matches.filter(function (n) { return n >= 80; }).length,
            match90Plus: matches.filter(function (n) { return n >= 90; }).length,
            averageTasteMatch: matches.length ? Math.round(matches.reduce(function (sum, n) { return sum + n; }, 0) / matches.length * 10) / 10 : null
          };
        });
        return {
          profile: clone(context),
          libraryMeals: library.length,
          vectorisedMeals: library.filter(function (meal) { return Boolean(mealTasteVector(meal)); }).length,
          bySlot: bySlot,
          unvectorisedMeals: library.filter(function (meal) { return !mealTasteVector(meal); }).map(function (meal) { return meal.name; })
        };
      },
      healthCheck: function () {
        var library = parseLibrary();
        var withImages = library.filter(function (meal) { return Boolean(meal.image); });
        var unsafe = state.menu.filter(function (item) {
          var source = findSource(item, library);
          return !source || !configurationAllowed(source) || !matchesDiet(source) || !matchesAllergies(source) || !planAllows(source);
        });
        var missingImages = state.menu.filter(function (item) {
          var source = findSource(item, library);
          return source && !source.image;
        });
        var tasteBlocked = state.menu.filter(function (item) {
          var source = findSource(item, library);
          return source && !matchesTaste(source);
        });
        var suitableBySlot = {};
        var imageReadyBySlot = {};
        var tasteProfileContext = readTasteProfileContext(state.name);
        var vectorisedMeals = library.filter(function (meal) { return Boolean(mealTasteVector(meal)); });

        ['Breakfast', 'Lunch', 'Dinner', 'Snack'].forEach(function (slot) {
          suitableBySlot[slot] = library.filter(function (meal) {
            return supportsSlot(meal, slot) &&
              planAllows(meal) &&
              matchesDiet(meal) &&
              matchesAllergies(meal) &&
              matchesTaste(meal);
          }).length;

          imageReadyBySlot[slot] = withImages.filter(function (meal) {
            return supportsSlot(meal, slot) &&
              planAllows(meal) &&
              matchesDiet(meal) &&
              matchesAllergies(meal) &&
              matchesTaste(meal);
          }).length;
        });

        return {
          ok: unsafe.length === 0 && library.length > 0,
          imagesOptional: true,
          librarySource: libraryDiagnostics(),
          diet: clone(state.diet),
          libraryMeals: library.length,
          mealsWithImages: withImages.length,
          mealsWithoutImages: library.length - withImages.length,
          explicitCustomerDescriptions: library.filter(function (meal) { return Boolean(meal.customerDescription); }).length,
          suitableBySlot: suitableBySlot,
          imageReadyBySlot: imageReadyBySlot,
          menuItems: state.menu.length,
          menuItemsWithoutImages: missingImages.map(function (item) { return item.name; }),
          unsafeMeals: unsafe.map(function (item) { return item.name; }),
          tasteBlockedMeals: tasteBlocked.map(function (item) { return item.name; }),
          tasteProfileVersion: 'Taste Profile v1.9.9 bridge',
          tasteProfileContext: clone(tasteProfileContext),
          tasteVectorisedMeals: vectorisedMeals.length,
          tasteVectorFallback: 'explicit Food Library values first; deterministic metadata-derived fallback for missing dimensions',
          tasteVectorCoveragePct: library.length ? Math.round(vectorisedMeals.length / library.length * 100) : 0,
          tasteRanking: 'Current Taste > Test Profile fallback; confidence-weighted six-axis match; soft ranking only',
          pdfTemplate: 'ami-standard-results-v1',
          pdfEngine: window.FlayvrAmiPDFV1 ? window.FlayvrAmiPDFV1.version : null,
          pdfDelivery: 'real-pdf-no-print',
          headerLibraryPatch: '28.4.0',
          fullWeekRepeatFallback: 'minimum-3-safe-families-after-live-adapt-custom-archive-search',
          weekdayRepeatFallback: 'minimum-2-safe-meals-per-slot',
          pdfLogoRestored: true,
          pdfFooterTheme: 'cream-outline-anna'
        };
      }
    };

    window.FlayvrAmi = publicApi;
    root.__flayvrAmi = publicApi;

    savedRecord = readSaved();
    renderMemory();

    if (savedRecord) showResumePrompt(savedRecord);
    else startNew();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootAll(document); }, { once: true });
  } else {
    bootAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    bootAll(event.target || document);
  });
})();
